import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateOnly: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Guid: { input: any; output: any; }
  Seconds: { input: any; output: any; }
};

/** Address input for creating or updating a location. */
export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
};

export type AvailabilityExceptionChangeNotifyGt = {
  __typename?: 'AvailabilityExceptionChangeNotifyGT';
  changeType?: Maybe<ChangeType>;
  date?: Maybe<Scalars['DateOnly']['output']>;
  end?: Maybe<Scalars['Seconds']['output']>;
  identityId: Scalars['ID']['output'];
  leaveTypeId?: Maybe<Scalars['Guid']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

export enum BasicJobStatus {
  Initialising = 'INITIALISING',
  None = 'NONE',
  OptimiserCompleted = 'OPTIMISER_COMPLETED',
  OptimiserError = 'OPTIMISER_ERROR',
  OptimiserQueued = 'OPTIMISER_QUEUED',
  OptimiserStarted = 'OPTIMISER_STARTED',
  Queueing = 'QUEUEING',
  SkippedError = 'SKIPPED_ERROR'
}

export type BatchJobStateChangeNotifyGt = {
  __typename?: 'BatchJobStateChangeNotifyGT';
  batchId: Scalars['ID']['output'];
  changeType?: Maybe<ChangeType>;
  date: Scalars['DateOnly']['output'];
  finished?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  progress?: Maybe<Scalars['Int']['output']>;
  properties: Scalars['String']['output'];
  started?: Maybe<Scalars['DateTime']['output']>;
};

export type BatchStatusGt = {
  __typename?: 'BatchStatusGT';
  locationStatuses?: Maybe<Array<Maybe<LocationStatusGt>>>;
};

export enum ChangeType {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Unknown = 'UNKNOWN',
  Update = 'UPDATE'
}

/** Change details of a work time record. */
export type CreateWorkTimeRecordChange = {
  changeReason?: InputMaybe<WorkTimeChangeReason>;
  end?: InputMaybe<UpdateWorkTimeOrigin>;
  recordId?: InputMaybe<Scalars['Guid']['input']>;
  risk?: InputMaybe<WorkTimeDataRisk>;
  start?: InputMaybe<UpdateWorkTimeOrigin>;
};

/** Returns an employee's location. */
export type EmployeeLocationGt = {
  __typename?: 'EmployeeLocationGT';
  employeeId?: Maybe<Scalars['Guid']['output']>;
  locationId: Scalars['Int']['output'];
};

/** End a work time record for the calling user. */
export type EndMyWorkTimeRecord = {
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  end: Scalars['DateTime']['input'];
  endGeoLocation?: InputMaybe<UpdateGeoLocation>;
  endSource?: InputMaybe<WorkTimeDataSource>;
  locationId: Scalars['Int']['input'];
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

/** Updates end work time record for the calling user */
export type EndWorkTimeRecord = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  end: Scalars['DateTime']['input'];
  endGeoLocation?: InputMaybe<UpdateGeoLocation>;
  endSource?: InputMaybe<WorkTimeDataSource>;
  locationId: Scalars['Int']['input'];
};

/** Returns a working pattern for an employee. */
export type Gdpr_WorkingPatternGt = {
  __typename?: 'GDPR_WorkingPatternGT';
  workingPattern?: Maybe<Array<Maybe<Gdpr_WorkingPatternDay>>>;
};

/** Returns geo-location latitude and longitude. */
export type GeoLocation = {
  __typename?: 'GeoLocation';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

/** Return work time record for an employee. */
export type GetMyWorkTimeRecordsGt = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
};

/** Return work time record for the calling employee within a date range. */
export type GetMyWorkTimeRecordsInRangeGt = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Return work time record for an employee. */
export type GetWorkTimeRecordsGt = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};

/** Return work time record for an employee within a date range. */
export type GetWorkTimeRecordsInRangeGt = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type JobDateStatusGt = {
  __typename?: 'JobDateStatusGT';
  batchJobId?: Maybe<Scalars['Guid']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<BasicJobStatus>;
};

export type LocationStatusGt = {
  __typename?: 'LocationStatusGT';
  locationId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  statuses?: Maybe<Array<Maybe<JobDateStatusGt>>>;
};

/** Returns targets for location. */
export type LocationTargetsGt = {
  __typename?: 'LocationTargetsGT';
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  targets?: Maybe<Array<Maybe<TargetDateGt>>>;
};

export type NotificationChangeNotifyGt = {
  __typename?: 'NotificationChangeNotifyGT';
  changeType?: Maybe<ChangeType>;
  date?: Maybe<Scalars['DateOnly']['output']>;
  locationId: Scalars['Int']['output'];
  notificationId?: Maybe<Scalars['Guid']['output']>;
  value: Scalars['Boolean']['output'];
};

/** Returns a notification. */
export type NotificationGt = {
  __typename?: 'NotificationGT';
  date?: Maybe<Scalars['DateOnly']['output']>;
  id: Scalars['ID']['output'];
  locationId: Scalars['Int']['output'];
  properties?: Maybe<Scalars['String']['output']>;
  triggerType: Scalars['Int']['output'];
  value: Scalars['Boolean']['output'];
};

/** Returns a list of operating hours exceptions. */
export type OperatingHoursExceptionsGt = {
  __typename?: 'OperatingHoursExceptionsGT';
  endDate?: Maybe<Scalars['DateOnly']['output']>;
  exceptions?: Maybe<Array<Maybe<OperatingHoursException>>>;
  startDate?: Maybe<Scalars['DateOnly']['output']>;
};

/** Returns station selection. */
export type ReadStationSelectionGt = {
  __typename?: 'ReadStationSelectionGT';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

export type RosterChangeNotifyGt = {
  __typename?: 'RosterChangeNotifyGT';
  changeType?: Maybe<ChangeType>;
  date?: Maybe<Scalars['DateOnly']['output']>;
  locationId: Scalars['Int']['output'];
  rosterId?: Maybe<Scalars['Guid']['output']>;
  status: Scalars['Int']['output'];
};

export type RosteringMutation = {
  __typename?: 'RosteringMutation';
  /** Adds location for the employee. */
  addEmployeeLocation?: Maybe<EmployeeLocationGt>;
  /** Adds assign a task to a roster station. */
  addRosterTask?: Maybe<MinimalRosterResult>;
  /** Adds a time slot to a roster task. */
  addRosterTaskTimeSlot?: Maybe<MinimalRosterResult>;
  /** Adds a task to a template station. */
  addTemplateTask?: Maybe<MinimalTemplateResult>;
  /** Adds a time slot to a template task. */
  addTemplateTaskTimeSlot?: Maybe<MinimalTemplateResult>;
  /** Applies availabilities. */
  applyAvailabilities?: Maybe<Scalars['Boolean']['output']>;
  /** Applies availability. */
  applyLocationAvailability?: Maybe<Scalars['Boolean']['output']>;
  /** Applies availabilities. */
  approveAndApplyAvailabilities?: Maybe<Scalars['Boolean']['output']>;
  /** Approves an availability exception. */
  approveAvailabilityException?: Maybe<AvailabilityException>;
  /** Approves availability exceptions. */
  approveAvailabilityExceptions?: Maybe<Scalars['Boolean']['output']>;
  /** Approves an employee's entire working pattern. */
  approveWorkingPattern?: Maybe<Scalars['Guid']['output']>;
  /** assign employee to positions. */
  assignEmployeeToPositions?: Maybe<Scalars['Boolean']['output']>;
  /** Assigns an employee to a position on a roster. */
  assignEmployeeToRosterPosition?: Maybe<Scalars['Boolean']['output']>;
  /** Assigns an employee to a position on a template. */
  assignEmployeeToTemplatePosition?: Maybe<Scalars['Boolean']['output']>;
  /** Assign employee to template positions. */
  assignEmployeeToTemplatePositions?: Maybe<Scalars['Boolean']['output']>;
  /** assign employees to positions. */
  assignEmployeesToPositions?: Maybe<Scalars['Boolean']['output']>;
  /** Changes the list of stations assigned to a roster. */
  changeRosterStations?: Maybe<MinimalRosterResult>;
  /** Changes the template used to generate a roster, restructuring the contents of the roster. */
  changeRosterTemplate?: Maybe<MinimalRosterResult>;
  /** Changes the list of stations assigned to a template. */
  changeTemplateStations?: Maybe<MinimalTemplateResult>;
  /** Changes the status of a Roster to complete if the Roster has no positions to be assigned to staff members and all positions / tasks have times set. */
  completeRoster?: Maybe<CompleteRosterResult>;
  /** Creates a new rostering template from existing template. */
  copyTemplate?: Maybe<MinimalTemplateResult>;
  /** Creates new availability. */
  createAvailability?: Maybe<ReadAvailability>;
  /** Creates a new availability exception. */
  createAvailabilityException?: Maybe<AvailabilityException>;
  /** Creates a contract. */
  createContract?: Maybe<ReadContractTypes>;
  /** Creates a new device. */
  createDevice?: Maybe<Device>;
  /** Creates an employee skill. */
  createEmployeeSkill?: Maybe<ReadEmployeeSkills>;
  /** Creates a new leave type. */
  createLeaveType?: Maybe<ReadLeaveType>;
  /** Creates new leave types. */
  createLeaveTypes?: Maybe<Scalars['Boolean']['output']>;
  /** Creates a new location. */
  createLocation?: Maybe<Location>;
  /** Creates location coordinates. */
  createLocationCoordinates?: Maybe<LocationCoordinates>;
  /** Creates multiple users and employees. */
  createMultipleUsersAndEmployees?: Maybe<Array<Maybe<ReadEmployee>>>;
  /** Creates personal settings. */
  createMySettings?: Maybe<ReadSettings>;
  /** Creates a persona. */
  createPersona?: Maybe<Persona>;
  /** Creates personas. */
  createPersonas?: Maybe<Array<Maybe<Persona>>>;
  /** Creates a new rosters from a template. */
  createRosterFromTemplate?: Maybe<MinimalRosterResult>;
  /** Creates a new position for a station on a roster. */
  createRosterPosition?: Maybe<ReadRosterPositions>;
  /** Creates skills. */
  createSkills?: Maybe<Array<Maybe<ReadSkills>>>;
  /** Creates a station. */
  createStation?: Maybe<ReadStation>;
  /** Creates a new target. */
  createTarget?: Maybe<TargetDateGt>;
  /** Creates a task. */
  createTask?: Maybe<ReadTask>;
  /** Creates tasks. */
  createTasks?: Maybe<Array<Maybe<ReadTask>>>;
  /** Creates a new rostering template. */
  createTemplate?: Maybe<MinimalTemplateResult>;
  /** Creates a new position for a station on a template. */
  createTemplatePosition?: Maybe<ReadTemplatesPositions>;
  /** Creates a new template tag. */
  createTemplateTag?: Maybe<ReadTemplateTag>;
  /** Creates a user and employee. */
  createUserAndEmployee?: Maybe<ReadEmployee>;
  /** Deletes all availabilities. */
  deleteAllAvailabilities?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes all availability exceptions. */
  deleteAllAvailabilityExceptions?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes all rosters. */
  deleteAllRosters?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes all templates. */
  deleteAllTemplates?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes all working patterns. */
  deleteAllWorkingPatterns?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes availability. */
  deleteAvailability?: Maybe<ReadAvailability>;
  /** Deletes the user's availability exceptions for a specific date. */
  deleteAvailabilityException?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes the user's availability exceptions for a specific date. */
  deleteAvailabilityExceptions?: Maybe<Array<Maybe<AvailabilityException>>>;
  /** Delete a contract. */
  deleteContract?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a device. */
  deleteDevice?: Maybe<Device>;
  /** Deletes an employee. */
  deleteEmployee?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes location for the employee. */
  deleteEmployeeLocation?: Maybe<EmployeeLocationGt>;
  /** Deletes an employee skill. */
  deleteEmployeeSkill?: Maybe<ReadEmployeeSkills>;
  /** Deletes a leave type. */
  deleteLeaveType?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes leave types. */
  deleteLeaveTypes?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a location. */
  deleteLocation?: Maybe<Location>;
  /** Deletes location coordinates. */
  deleteLocationCoordinates?: Maybe<LocationCoordinates>;
  /** Deletes notifications. */
  deleteNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a persona. */
  deletePersona?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes personas. */
  deletePersonas?: Maybe<Scalars['Boolean']['output']>;
  /** delete positions from rosters. */
  deletePositions?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a roster. */
  deleteRoster?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a position from a roster. */
  deleteRosterPosition?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes the task assigned to a roster station. */
  deleteRosterTask?: Maybe<MinimalRosterResult>;
  /** Deletes a time slot on a roster task. */
  deleteRosterTaskTimeSlot?: Maybe<MinimalRosterResult>;
  /** Deletes rosters within a date range for a location. */
  deleteRostersInDateRange?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes skills. */
  deleteSkills?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a station. */
  deleteStation?: Maybe<ReadStation>;
  /** Deletes a task. */
  deleteTask?: Maybe<ReadTask>;
  /** Deletes tasks. */
  deleteTasks?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a rostering template. */
  deleteTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes a position from a template. */
  deleteTemplatePosition?: Maybe<Scalars['Boolean']['output']>;
  /** Deletes the task assigned to a template station. */
  deleteTemplateTask?: Maybe<MinimalTemplateResult>;
  /** Deletes a time slot on a template task. */
  deleteTemplateTaskTimeSlot?: Maybe<MinimalTemplateResult>;
  /** Deletes constraints for the employees. */
  deleteWorkRules?: Maybe<Scalars['Boolean']['output']>;
  /** Ends a work time record for the calling user. */
  endMyWorkTimeRecord?: Maybe<WorkTimeRecord>;
  /** Ends a work time record for the specified employee. */
  endWorkTimeRecord?: Maybe<WorkTimeRecord>;
  /** Deletes a user's GDPR. */
  gdprDeleteUser?: Maybe<Scalars['Boolean']['output']>;
  /** Pushes notifications. */
  pushNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** Reassigns an employee to positions on a roster. */
  reassignEmployeeToRosterPositions?: Maybe<Scalars['Boolean']['output']>;
  /** Reassign multiple employees to positions on a roster. */
  reassignMultipleEmployeesToRosterPositions?: Maybe<Scalars['Boolean']['output']>;
  /** Rejects an availability exception. */
  rejectAvailabilityException?: Maybe<AvailabilityException>;
  /** Rejects an employee's entire working pattern. */
  rejectWorkingPattern?: Maybe<Scalars['Guid']['output']>;
  /** Removes an assigned employee to a position on a roster. */
  removeEmployeeFromRosterPosition?: Maybe<Scalars['Boolean']['output']>;
  /** Removes an employee from a position on a template. */
  removeEmployeeFromTemplatePosition?: Maybe<Scalars['Boolean']['output']>;
  /** Removes employees from all rosters positions in a station. */
  removeEmployeesFromAllRosterPositionsInAStation?: Maybe<MinimalRosterResult>;
  /** Removes employees from all positions on a template in a station. */
  removeEmployeesFromAllTemplatePositionsInAStation?: Maybe<MinimalTemplateResult>;
  /** Resets all passwords. */
  resetAllPasswords?: Maybe<Scalars['Boolean']['output']>;
  /** Resets a device. */
  resetDevice?: Maybe<Device>;
  /** Reset's a user's password to the default value. */
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Revokes access tokens by client id. */
  revokeTokens?: Maybe<Scalars['Boolean']['output']>;
  /** Sends email and/or SMS on welcome and boarding information to a user */
  sendWelcomeInfo?: Maybe<Scalars['Boolean']['output']>;
  /** Sets time offsets before first break and after last break. */
  setBreakOffsets?: Maybe<Scalars['Boolean']['output']>;
  /** Updates a location's operating hours. Will create new entry if operating hours don't exist for the location. */
  setLocationOperatingHours?: Maybe<OperatingHours>;
  /** Updates a location's operating hours exceptions. */
  setOperatingHoursException?: Maybe<OperatingHoursException>;
  /** Sets organisation hierarchy. */
  setOrganisationHierarchy?: Maybe<Scalars['Boolean']['output']>;
  /** Sets the organisation's wide operating hours. */
  setOrganisationOperatingHours?: Maybe<OperatingHours>;
  /** Sets organisation's properties. */
  setOrganisationProperties?: Maybe<Scalars['Boolean']['output']>;
  /** Updates properties in positions. */
  setPositionProperties?: Maybe<Scalars['Boolean']['output']>;
  /** Sets breaks to a position on a roster. */
  setRosterPositionBreaks?: Maybe<Array<Maybe<ReadRosterTimeSlots>>>;
  /** Assigns a time slot to a position on a roster. */
  setRosterPositionTimeSlot?: Maybe<ReadRosterTimeSlots>;
  /** Updates properties in rosters. */
  setRosterProperties?: Maybe<Scalars['Boolean']['output']>;
  /** Changes the status of a Roster. */
  setRosterStatus?: Maybe<Scalars['String']['output']>;
  /** Changes the status of rosters. */
  setRosterStatuses?: Maybe<Scalars['Boolean']['output']>;
  /** Sets breaks to a position on a template. */
  setTemplatePositionBreaks?: Maybe<MinimalTemplateResult>;
  /** Updates properties in positions. */
  setTemplatePositionProperties?: Maybe<Scalars['Boolean']['output']>;
  /** Sets a time slot to a position on a template. */
  setTemplatePositionTimeSlot?: Maybe<ReadTaskTimeSlots>;
  /** Starts a work time record for the calling user. */
  startMyWorkTimeRecord?: Maybe<WorkTimeRecord>;
  /** Starts a work time record for the specified employee. */
  startWorkTimeRecord?: Maybe<WorkTimeRecord>;
  /** Updates availability. */
  updateAvailability?: Maybe<ReadAvailability>;
  /** Updates an availability exception. */
  updateAvailabilityException?: Maybe<AvailabilityException>;
  /** Updates availability exceptions. */
  updateAvailabilityExceptions?: Maybe<Array<Maybe<AvailabilityException>>>;
  /** Updates availability exceptions in the date range. */
  updateAvailabilityExceptionsInDateRange?: Maybe<Array<Maybe<AvailabilityException>>>;
  /** Updates a contract. */
  updateContract?: Maybe<Scalars['Boolean']['output']>;
  /** Updates contract roles. */
  updateContractRoles?: Maybe<Array<Maybe<ReadContractRole>>>;
  /** Updates the deactivated status for a user. */
  updateDeactivatedStatus?: Maybe<Id>;
  /** Updates a new device. */
  updateDevice?: Maybe<Device>;
  /** Updates an employee. */
  updateEmployee?: Maybe<ReadEmployee>;
  /** Updates locations for the employee. */
  updateEmployeeLocations?: Maybe<Scalars['Boolean']['output']>;
  /** Updates an employee role. */
  updateEmployeeRole?: Maybe<Scalars['Boolean']['output']>;
  /** Updates an employee skill. */
  updateEmployeeSkill?: Maybe<ReadEmployeeSkills>;
  /** Updates skills of multiple employees. */
  updateEmployeeSkills?: Maybe<Scalars['Boolean']['output']>;
  /** Updates a list of employees. */
  updateEmployees?: Maybe<Scalars['Boolean']['output']>;
  /** Updates a leave type. */
  updateLeaveType?: Maybe<ReadLeaveType>;
  /** Updates leave types. */
  updateLeaveTypes?: Maybe<Scalars['Boolean']['output']>;
  /** Updates a location. */
  updateLocation?: Maybe<Location>;
  /** Updates location coordinates. */
  updateLocationCoordinates?: Maybe<LocationCoordinates>;
  /** Updates location-scoped holidays for a location. */
  updateLocationHolidays?: Maybe<Array<Maybe<LocationHoliday>>>;
  /** Updates locations. */
  updateLocations?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Updates an user's information.
   * @deprecated Only Admins may update users. General endpoint is sufficient. Use 'updateEmployee'
   */
  updateMyInfo?: Maybe<ReadEmployee>;
  /** Updates personal settings. */
  updateMySettings?: Maybe<ReadSettings>;
  /** Updates the constraints for the employee. */
  updateMyWorkRules?: Maybe<MyConstraints>;
  /** Updates a work time record for the calling user. */
  updateMyWorkTimeRecord?: Maybe<WorkTimeRecord>;
  /** Updates notifications. */
  updateNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** Updates a persona. */
  updatePersona?: Maybe<Persona>;
  /** Updates personas. */
  updatePersonas?: Maybe<Array<Maybe<Persona>>>;
  /** Updates a roster. */
  updateRoster?: Maybe<MinimalRosterResult>;
  /** Updates the task assigned to a roster station. */
  updateRosterTask?: Maybe<MinimalRosterResult>;
  /** Updates the start and end times of a time slot on a roster task. */
  updateRosterTaskTimeSlot?: Maybe<MinimalRosterResult>;
  /** Updates skills. */
  updateSkills?: Maybe<Array<Maybe<ReadSkills>>>;
  /** Updates a station. */
  updateStation?: Maybe<ReadStation>;
  /** Updates a target. */
  updateTarget?: Maybe<TargetDateGt>;
  /** Updates targets. */
  updateTargets?: Maybe<Array<Maybe<TargetGt>>>;
  /** Updates a task. */
  updateTask?: Maybe<ReadTask>;
  /** Updates tasks. */
  updateTasks?: Maybe<Array<Maybe<ReadTask>>>;
  /** Updates a rostering template. */
  updateTemplate?: Maybe<MinimalTemplateResult>;
  /** Updates template base hours. */
  updateTemplateBaseHours?: Maybe<Scalars['Boolean']['output']>;
  /** Updates a rostering template name. */
  updateTemplateName?: Maybe<Scalars['Boolean']['output']>;
  /** Updates a rostering template target. */
  updateTemplateTarget?: Maybe<Scalars['Boolean']['output']>;
  /** Updates the task assigned to a template station. */
  updateTemplateTask?: Maybe<MinimalTemplateResult>;
  /** Updates the start and end times of a time slot on a template task. */
  updateTemplateTaskTimeSlot?: Maybe<MinimalTemplateResult>;
  /** Updates template weekday. */
  updateTemplateWeekday?: Maybe<Scalars['Boolean']['output']>;
  /** Updates constraints for the employees. */
  updateWorkRules?: Maybe<Array<Maybe<EmployeeConstraints>>>;
  /** Updates a work time record for an employee. */
  updateWorkTimeRecord?: Maybe<WorkTimeRecord>;
  /** Updates working patterns for an employee. */
  updateWorkingPattern?: Maybe<WorkingPatternGt>;
  /** Updates working pattern for an employee. */
  updateWorkingPatternDay?: Maybe<WorkingPatternDay>;
  /** Updates working patterns for multiple employees. */
  updateWorkingPatterns?: Maybe<Scalars['Boolean']['output']>;
};


export type RosteringMutationAddEmployeeLocationArgs = {
  employeeLocations: EmployeeLocationsInfo;
};


export type RosteringMutationAddRosterTaskArgs = {
  addRosterTask: AssignRosterTask;
};


export type RosteringMutationAddRosterTaskTimeSlotArgs = {
  newTimeSlot: CreateRosterTaskTimeSlot;
};


export type RosteringMutationAddTemplateTaskArgs = {
  addTemplateTask: AssignTemplateTask;
};


export type RosteringMutationAddTemplateTaskTimeSlotArgs = {
  templateTaskTimeSlot: CreateTemplateTaskTimeSlot;
};


export type RosteringMutationApplyAvailabilitiesArgs = {
  applyAvailabilities: ApplyAvailabilities;
};


export type RosteringMutationApplyLocationAvailabilityArgs = {
  applyAvailability: ApplyAvailability;
};


export type RosteringMutationApproveAndApplyAvailabilitiesArgs = {
  applyAvailabilities: ApplyAvailabilities;
};


export type RosteringMutationApproveAvailabilityExceptionArgs = {
  availabilityExceptionApproval: UpdateAvailabilityException;
};


export type RosteringMutationApproveAvailabilityExceptionsArgs = {
  ids: Array<InputMaybe<Scalars['Guid']['input']>>;
};


export type RosteringMutationApproveWorkingPatternArgs = {
  workingPatternApproval: WorkingPatternApprovalRejection;
};


export type RosteringMutationAssignEmployeeToPositionsArgs = {
  employeeAndPositions: AssignPositionsEmployee;
};


export type RosteringMutationAssignEmployeeToRosterPositionArgs = {
  rosterEmployee: AssignRosterPositionEmployee;
};


export type RosteringMutationAssignEmployeeToTemplatePositionArgs = {
  templateEmployee: AssignTemplatePositionEmployee;
};


export type RosteringMutationAssignEmployeeToTemplatePositionsArgs = {
  employeeAndPositions: AssignTemplatePositionsEmployee;
};


export type RosteringMutationAssignEmployeesToPositionsArgs = {
  positionAndEmployeePairs: Array<InputMaybe<AssignPositionEmployee>>;
};


export type RosteringMutationChangeRosterStationsArgs = {
  rosterStationSelection: SetRosterStations;
};


export type RosteringMutationChangeRosterTemplateArgs = {
  rosterWithNewTemplate: ChangeRosterTemplate;
};


export type RosteringMutationChangeTemplateStationsArgs = {
  templateStationSelection: UpdateTemplateStations;
};


export type RosteringMutationCompleteRosterArgs = {
  rosterId: Scalars['Guid']['input'];
};


export type RosteringMutationCopyTemplateArgs = {
  template: CopyTemplate;
};


export type RosteringMutationCreateAvailabilityArgs = {
  availability: CreateAvailability;
};


export type RosteringMutationCreateAvailabilityExceptionArgs = {
  exception: CreateAvailabilityException;
};


export type RosteringMutationCreateContractArgs = {
  contract: CreateContract;
};


export type RosteringMutationCreateDeviceArgs = {
  device: CreateDevice;
};


export type RosteringMutationCreateEmployeeSkillArgs = {
  skill: EmployeeSkill;
};


export type RosteringMutationCreateLeaveTypeArgs = {
  leaveType: CreateLeaveType;
};


export type RosteringMutationCreateLeaveTypesArgs = {
  leaveTypes: Array<InputMaybe<CreateLeaveType>>;
};


export type RosteringMutationCreateLocationArgs = {
  location: CreateLocation;
};


export type RosteringMutationCreateLocationCoordinatesArgs = {
  locationCoordinates: NewLocationCoordinates;
};


export type RosteringMutationCreateMultipleUsersAndEmployeesArgs = {
  employees: Array<InputMaybe<CreateEmployee>>;
};


export type RosteringMutationCreateMySettingsArgs = {
  settings: CreateSettings;
};


export type RosteringMutationCreatePersonaArgs = {
  persona: CreatePersona;
};


export type RosteringMutationCreatePersonasArgs = {
  personas: Array<InputMaybe<CreatePersona>>;
};


export type RosteringMutationCreateRosterFromTemplateArgs = {
  rosterCreationDetails: CreateRoster;
};


export type RosteringMutationCreateRosterPositionArgs = {
  rosterAndStation: CreateRosterPosition;
};


export type RosteringMutationCreateSkillsArgs = {
  skills: Array<InputMaybe<CreateSkill>>;
};


export type RosteringMutationCreateStationArgs = {
  station: CreateStation;
};


export type RosteringMutationCreateTargetArgs = {
  target: CreateTarget;
};


export type RosteringMutationCreateTaskArgs = {
  task: CreateTask;
};


export type RosteringMutationCreateTasksArgs = {
  tasks: Array<InputMaybe<CreateTask>>;
};


export type RosteringMutationCreateTemplateArgs = {
  template: CreateTemplate;
};


export type RosteringMutationCreateTemplatePositionArgs = {
  templateAndStation: CreatePosition;
};


export type RosteringMutationCreateTemplateTagArgs = {
  templateTag: CreateTemplateTag;
};


export type RosteringMutationCreateUserAndEmployeeArgs = {
  employee: CreateEmployee;
};


export type RosteringMutationDeleteAvailabilityArgs = {
  id: Scalars['Guid']['input'];
};


export type RosteringMutationDeleteAvailabilityExceptionArgs = {
  exceptionDetails: DeleteAvailabilityException;
};


export type RosteringMutationDeleteAvailabilityExceptionsArgs = {
  exceptionDetails: DeleteAvailabilityException;
};


export type RosteringMutationDeleteContractArgs = {
  id: Scalars['Guid']['input'];
};


export type RosteringMutationDeleteDeviceArgs = {
  id: Scalars['Guid']['input'];
};


export type RosteringMutationDeleteEmployeeArgs = {
  id: Scalars['Guid']['input'];
};


export type RosteringMutationDeleteEmployeeLocationArgs = {
  employeeLocations: EmployeeLocationsInfo;
};


export type RosteringMutationDeleteEmployeeSkillArgs = {
  employeeSkillId: Scalars['Int']['input'];
};


export type RosteringMutationDeleteLeaveTypeArgs = {
  id: Scalars['Guid']['input'];
};


export type RosteringMutationDeleteLeaveTypesArgs = {
  ids: Array<InputMaybe<Scalars['Guid']['input']>>;
};


export type RosteringMutationDeleteLocationArgs = {
  id: Scalars['Int']['input'];
};


export type RosteringMutationDeleteLocationCoordinatesArgs = {
  locationCoordinatesId: Scalars['Guid']['input'];
};


export type RosteringMutationDeleteNotificationsArgs = {
  notifications: Array<InputMaybe<Scalars['Guid']['input']>>;
};


export type RosteringMutationDeletePersonaArgs = {
  id: Scalars['Guid']['input'];
};


export type RosteringMutationDeletePersonasArgs = {
  ids: Array<InputMaybe<Scalars['Guid']['input']>>;
};


export type RosteringMutationDeletePositionsArgs = {
  positionIds: Array<InputMaybe<Scalars['Guid']['input']>>;
};


export type RosteringMutationDeleteRosterArgs = {
  id: Scalars['Guid']['input'];
};


export type RosteringMutationDeleteRosterPositionArgs = {
  position: DeleteRosterPosition;
};


export type RosteringMutationDeleteRosterTaskArgs = {
  deleteRosterTask: DeleteRosterTask;
};


export type RosteringMutationDeleteRosterTaskTimeSlotArgs = {
  deletedTimeSlot: DeleteRosterTimeSlot;
};


export type RosteringMutationDeleteRostersInDateRangeArgs = {
  locationAndDateRange: DeleteRostersInDateRange;
};


export type RosteringMutationDeleteSkillsArgs = {
  skillIds: Array<InputMaybe<Scalars['Guid']['input']>>;
};


export type RosteringMutationDeleteStationArgs = {
  id: Scalars['Int']['input'];
};


export type RosteringMutationDeleteTaskArgs = {
  id: Scalars['Int']['input'];
};


export type RosteringMutationDeleteTasksArgs = {
  taskIds: Array<InputMaybe<Scalars['Int']['input']>>;
};


export type RosteringMutationDeleteTemplateArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Guid']['input'];
};


export type RosteringMutationDeleteTemplatePositionArgs = {
  position: DeleteTemplatePosition;
};


export type RosteringMutationDeleteTemplateTaskArgs = {
  deleteTemplateTask: DeleteTemplateTask;
};


export type RosteringMutationDeleteTemplateTaskTimeSlotArgs = {
  deletedTimeSlot: DeleteTemplateTimeSlot;
};


export type RosteringMutationDeleteWorkRulesArgs = {
  ids: Array<InputMaybe<Scalars['Guid']['input']>>;
};


export type RosteringMutationEndMyWorkTimeRecordArgs = {
  workTimeRecordEnd: EndMyWorkTimeRecord;
};


export type RosteringMutationEndWorkTimeRecordArgs = {
  workTimeRecordEnd: EndWorkTimeRecord;
};


export type RosteringMutationGdprDeleteUserArgs = {
  id: Scalars['Guid']['input'];
};


export type RosteringMutationPushNotificationsArgs = {
  notifications: PushNotifications;
};


export type RosteringMutationReassignEmployeeToRosterPositionsArgs = {
  rosterEmployee: ReassignEmployeeToRosterPositions;
};


export type RosteringMutationReassignMultipleEmployeesToRosterPositionsArgs = {
  rosterEmployee: Array<InputMaybe<ReassignEmployeeToRosterPositions>>;
};


export type RosteringMutationRejectAvailabilityExceptionArgs = {
  availabilityExceptionApproval: UpdateAvailabilityException;
};


export type RosteringMutationRejectWorkingPatternArgs = {
  workingPatternRejection: WorkingPatternApprovalRejection;
};


export type RosteringMutationRemoveEmployeeFromRosterPositionArgs = {
  removeEmployeeAssignment: RemoveFromRoster;
};


export type RosteringMutationRemoveEmployeeFromTemplatePositionArgs = {
  removeEmployeeAssignment: DeleteEmployeeAssignment;
};


export type RosteringMutationRemoveEmployeesFromAllRosterPositionsInAStationArgs = {
  rosterAndStationIds: RemoveFromRoster;
};


export type RosteringMutationRemoveEmployeesFromAllTemplatePositionsInAStationArgs = {
  templateAndStationIds: RemoveFromTemplate;
};


export type RosteringMutationResetDeviceArgs = {
  id: Scalars['Guid']['input'];
};


export type RosteringMutationResetPasswordArgs = {
  employeeId: Scalars['Guid']['input'];
};


export type RosteringMutationRevokeTokensArgs = {
  clientId: Scalars['String']['input'];
};


export type RosteringMutationSendWelcomeInfoArgs = {
  welcomeInfo: SendWelcomeInfo;
};


export type RosteringMutationSetBreakOffsetsArgs = {
  breakOffsets: SetBreakOffsets;
};


export type RosteringMutationSetLocationOperatingHoursArgs = {
  operatingHours: UpdateLocationOperatingHours;
};


export type RosteringMutationSetOperatingHoursExceptionArgs = {
  updateOperatingHoursException: UpdateOperatingHoursException;
};


export type RosteringMutationSetOrganisationHierarchyArgs = {
  hierarchy: SetDivision;
};


export type RosteringMutationSetOrganisationOperatingHoursArgs = {
  operatingHours: UpdateOrgOperatingHours;
};


export type RosteringMutationSetOrganisationPropertiesArgs = {
  properties: Scalars['String']['input'];
};


export type RosteringMutationSetPositionPropertiesArgs = {
  idAndPropertiesPairs: Array<InputMaybe<SetPositionProperties>>;
};


export type RosteringMutationSetRosterPositionBreaksArgs = {
  rosterPositionBreaks: SetRosterPositionBreaks;
};


export type RosteringMutationSetRosterPositionTimeSlotArgs = {
  rosterPositionTimeSlot: SetRosterTaskTimeSlot;
};


export type RosteringMutationSetRosterPropertiesArgs = {
  idAndPropertiesPairs: Array<InputMaybe<SetRosterProperties>>;
};


export type RosteringMutationSetRosterStatusArgs = {
  rosterStatus: UpdateRosterStatus;
};


export type RosteringMutationSetRosterStatusesArgs = {
  rosterStatuses: UpdateRosterStatuses;
};


export type RosteringMutationSetTemplatePositionBreaksArgs = {
  templatePositionBreaks: SetTemplatePositionBreaks;
};


export type RosteringMutationSetTemplatePositionPropertiesArgs = {
  idAndPropertiesPairs: Array<InputMaybe<SetTemplatePositionProperties>>;
};


export type RosteringMutationSetTemplatePositionTimeSlotArgs = {
  templatePositionTimeSlot: SetTemplateTaskTimeSlot;
};


export type RosteringMutationStartMyWorkTimeRecordArgs = {
  workTimeRecordStart: StartMyWorkTimeRecord;
};


export type RosteringMutationStartWorkTimeRecordArgs = {
  workTimeRecordStart: StartWorkTimeRecord;
};


export type RosteringMutationUpdateAvailabilityArgs = {
  availability: UpdateAvailability;
};


export type RosteringMutationUpdateAvailabilityExceptionArgs = {
  exception: CreateAvailabilityException;
};


export type RosteringMutationUpdateAvailabilityExceptionsArgs = {
  exceptions: Array<InputMaybe<UpdateAvailabilityExceptions>>;
};


export type RosteringMutationUpdateAvailabilityExceptionsInDateRangeArgs = {
  exceptions: UpdateAvailabilityExceptionsInDateRange;
};


export type RosteringMutationUpdateContractArgs = {
  contract: UpdateContract;
};


export type RosteringMutationUpdateContractRolesArgs = {
  contractRoles: UpdateContractRoles;
};


export type RosteringMutationUpdateDeactivatedStatusArgs = {
  deactivated: Scalars['Boolean']['input'];
  id: Scalars['Guid']['input'];
};


export type RosteringMutationUpdateDeviceArgs = {
  device: UpdateDevice;
};


export type RosteringMutationUpdateEmployeeArgs = {
  employee: UpdateEmployee;
};


export type RosteringMutationUpdateEmployeeLocationsArgs = {
  employeeLocations: Array<InputMaybe<UpdateEmployeeLocations>>;
};


export type RosteringMutationUpdateEmployeeRoleArgs = {
  roleId: Scalars['Int']['input'];
  userId: Scalars['Guid']['input'];
};


export type RosteringMutationUpdateEmployeeSkillArgs = {
  skill: EmployeeSkill;
};


export type RosteringMutationUpdateEmployeeSkillsArgs = {
  skills: Array<InputMaybe<UpdateEmployeeSkillsByEmployeeIdAndSkills>>;
};


export type RosteringMutationUpdateEmployeesArgs = {
  employees: Array<InputMaybe<UpdateEmployee>>;
};


export type RosteringMutationUpdateLeaveTypeArgs = {
  leaveType: UpdateLeaveType;
};


export type RosteringMutationUpdateLeaveTypesArgs = {
  leaveTypes: Array<InputMaybe<UpdateLeaveType>>;
};


export type RosteringMutationUpdateLocationArgs = {
  location: UpdateLocation;
};


export type RosteringMutationUpdateLocationCoordinatesArgs = {
  locationCoordinates: UpdateLocationCoordinates;
};


export type RosteringMutationUpdateLocationHolidaysArgs = {
  holidays: Array<InputMaybe<UpdateLocationHoliday>>;
  locationId: Scalars['Int']['input'];
};


export type RosteringMutationUpdateLocationsArgs = {
  locations: Array<InputMaybe<UpdateLocation>>;
};


export type RosteringMutationUpdateMyInfoArgs = {
  employee: UpdateEmployee;
};


export type RosteringMutationUpdateMySettingsArgs = {
  settings: UpdateSettings;
};


export type RosteringMutationUpdateMyWorkRulesArgs = {
  constraints: UpdateMyWorkRules;
};


export type RosteringMutationUpdateMyWorkTimeRecordArgs = {
  workTimeRecordChange: CreateWorkTimeRecordChange;
};


export type RosteringMutationUpdateNotificationsArgs = {
  notifications: Array<InputMaybe<UpdateNotification>>;
};


export type RosteringMutationUpdatePersonaArgs = {
  persona: UpdatePersona;
};


export type RosteringMutationUpdatePersonasArgs = {
  personas: Array<InputMaybe<UpdatePersona>>;
};


export type RosteringMutationUpdateRosterArgs = {
  roster: UpdateRoster;
};


export type RosteringMutationUpdateRosterTaskArgs = {
  updateRosterTask: RosterStationTask;
};


export type RosteringMutationUpdateRosterTaskTimeSlotArgs = {
  rosterTaskTimeSlot: UpdateRosterTaskTimeSlot;
};


export type RosteringMutationUpdateSkillsArgs = {
  skills: Array<InputMaybe<UpdateSkill>>;
};


export type RosteringMutationUpdateStationArgs = {
  station: UpdateStation;
};


export type RosteringMutationUpdateTargetArgs = {
  target: UpdateTarget;
};


export type RosteringMutationUpdateTargetsArgs = {
  targets: Array<InputMaybe<UpdateTargetByValue>>;
};


export type RosteringMutationUpdateTaskArgs = {
  task: UpdateTask;
};


export type RosteringMutationUpdateTasksArgs = {
  tasks: Array<InputMaybe<UpdateTask>>;
};


export type RosteringMutationUpdateTemplateArgs = {
  template: UpdateTemplate;
};


export type RosteringMutationUpdateTemplateBaseHoursArgs = {
  baseHours: UpdateTemplateBaseHours;
};


export type RosteringMutationUpdateTemplateNameArgs = {
  name: UpdateTemplateName;
};


export type RosteringMutationUpdateTemplateTargetArgs = {
  target: UpdateTemplateTarget;
};


export type RosteringMutationUpdateTemplateTaskArgs = {
  updateTemplateTask: TemplateStationTask;
};


export type RosteringMutationUpdateTemplateTaskTimeSlotArgs = {
  templateTaskTimeSlot: UpdateTemplateTaskTimeSlot;
};


export type RosteringMutationUpdateTemplateWeekdayArgs = {
  weekday: UpdateTemplateWeekday;
};


export type RosteringMutationUpdateWorkRulesArgs = {
  constraints: UpdateWorkRules;
};


export type RosteringMutationUpdateWorkTimeRecordArgs = {
  workTimeRecordChange: CreateWorkTimeRecordChange;
};


export type RosteringMutationUpdateWorkingPatternArgs = {
  workingPattern: UpdateWorkingPattern;
};


export type RosteringMutationUpdateWorkingPatternDayArgs = {
  workingPatternDay: UpdateWorkingPatternDay;
};


export type RosteringMutationUpdateWorkingPatternsArgs = {
  workingPatterns: UpdateWorkingPatterns;
};

export type RosteringQuery = {
  __typename?: 'RosteringQuery';
  /** Returns a list of availabilities. */
  availabilities?: Maybe<Array<Maybe<ReadAvailability>>>;
  /** Returns a list of availability exceptions within the date range for the employees. */
  availabilityExceptions?: Maybe<Array<Maybe<AvailabilityException>>>;
  /** Returns a list of an employee's availability exceptions. */
  availabilityExceptionsForEmployee?: Maybe<AvailabilityExceptions>;
  /** Returns a list of the current batch job status for the location over specified date range. */
  batchJobStatusForLocation?: Maybe<LocationStatusGt>;
  /** Current batch job status for locations of the manager over specified date range. */
  batchJobStatusForManager?: Maybe<BatchStatusGt>;
  /** Returns a list of shifts on a given date. */
  dayShifts?: Maybe<Array<Maybe<Shifts>>>;
  /** Returns a device. */
  device?: Maybe<Device>;
  /** Returns a list of devices. */
  devicesForLocation?: Maybe<Array<Maybe<Device>>>;
  /** Returns an employee's data. */
  employee?: Maybe<ReadEmployee>;
  /** Returns an employee's data. */
  employeeByEmployeeId?: Maybe<ReadEmployee>;
  /** An Employee's data */
  employeeByName?: Maybe<ReadEmployee>;
  employeeHistory?: Maybe<ReadEmployeeHistory>;
  /** Returns the working patterns of an employee. */
  employeeIdWorkingPatterns?: Maybe<WorkingPatternPeriods>;
  /** Returns a list of employee names by identity ids */
  employeeNamesByIds?: Maybe<Array<Maybe<ReadEmployeeName>>>;
  /** Returns a list of skills for a given employee. */
  employeeSkills?: Maybe<Array<Maybe<ReadEmployeeSkills>>>;
  /** Returns a list of skills by identity ids */
  employeeSkillsByEmployeeIds?: Maybe<Array<Maybe<ReadEmployeeIdAndSkills>>>;
  employeeSummariesByContractRoleId?: Maybe<Array<Maybe<ReadEmployeeSummary>>>;
  employeeSummariesByContractTypeId?: Maybe<Array<Maybe<ReadEmployeeSummary>>>;
  /** Returns the working patterns of the employee. */
  employeeWorkingPatterns?: Maybe<WorkingPatternPeriods>;
  /** Returns a list of employees. */
  employees?: Maybe<Array<Maybe<ReadEmployee>>>;
  /** Employees assigned to the contract roles in a contract */
  employeesAssignedToRolesInContract?: Maybe<Array<Maybe<ReadEmployee>>>;
  /** Returns a list of employees by identity ids */
  employeesByIds?: Maybe<Array<Maybe<ReadEmployee>>>;
  /** Returns a list of employees for the provided locations. */
  employeesByLocations?: Maybe<ReadEmployeesList>;
  /** Returns employees' data. */
  employeesWithNoEmployeeId?: Maybe<Array<Maybe<ReadEmployee>>>;
  /** Returns a list of employees without an assigned location. */
  employeesWithoutLocation?: Maybe<ReadEmployeesList>;
  /** Returns reassigned employee shifts from the location. */
  findReassignedShifts?: Maybe<Array<Maybe<FoundShifts>>>;
  /** Returns reassigned employee shifts from the location. */
  findReassignedShiftsInDateRange?: Maybe<Array<Maybe<FoundShiftsInDateRange>>>;
  /** Returns employee shifts met by the search criteria. */
  findShiftsByProperty?: Maybe<Array<Maybe<FoundShifts>>>;
  /** Returns my employee GDPR personal information. */
  gdpr_myPersonalInfo?: Maybe<Gdpr_ReadEmployee>;
  /** Returns a list of the work time data for the calling employee. */
  getAllMyWorkTimeRecord?: Maybe<Array<Maybe<WorkTimeRecord>>>;
  /** Returns time offsets before first break and after last break. */
  getBreakOffsets?: Maybe<ReadBreakOffsets>;
  /** Returns my staff shifts worked at other locations. */
  getMyEmployeesShifts?: Maybe<Array<Maybe<LocationShift>>>;
  /** Returns a list of open work time data for the calling user by location. */
  getMyOpenWorkTimeRecord?: Maybe<Array<Maybe<EmployeeWorkTimeRecord>>>;
  /** Returns a list of the work time data by location and date range for the calling employee. */
  getMyWorkTimeRecord?: Maybe<Array<Maybe<EmployeeWorkTimeRecord>>>;
  /** Returns a list of open work time data by employee and location. */
  getOpenWorkTimeRecord?: Maybe<Array<Maybe<EmployeeWorkTimeRecord>>>;
  /** Returns organisation hierarchy. */
  getOrganisationHierarchy?: Maybe<ReadDivision>;
  /** Returns organisation properties. */
  getOrganisationProperties?: Maybe<Scalars['String']['output']>;
  /** Returns a list of the work time data by employee, location and date range. */
  getWorkTimeRecord?: Maybe<Array<Maybe<EmployeeWorkTimeRecord>>>;
  /** Returns a list of the history of a work record item. */
  getWorkTimeRecordHistory?: Maybe<Array<Maybe<WorkTimeRecordChange>>>;
  /** Returns a list of employees at all assigned locations. */
  globalEmployeeSearch?: Maybe<ReadEmployeesList>;
  /** Returns a list of national holidays. */
  holidays?: Maybe<Holidays>;
  /** Returns a list of the system supported languages. */
  languages?: Maybe<Array<Maybe<ReadLanguage>>>;
  /** Returns a leave type. */
  leaveType?: Maybe<ReadLeaveType>;
  /** Returns leave type usages split by a boundary date for delete validation. */
  leaveTypeDeleteValidation: LeaveTypeDeleteValidation;
  /** Returns a list of leave types. */
  leaveTypes?: Maybe<Array<Maybe<ReadLeaveType>>>;
  /** Returns a single location. Examples of Location: restaurant, shop, etc. */
  location?: Maybe<Location>;
  /** Returns a list of all the employee's availability exceptions within the date range for the location. */
  locationAvailabilityExceptions?: Maybe<LocationAvailabilityExceptions>;
  /** Returns a list of the coordinates of a location. */
  locationCoordinates?: Maybe<LocationCoordinatesList>;
  /** Returns location-scoped holidays for a location. */
  locationHolidays?: Maybe<Array<Maybe<LocationHoliday>>>;
  /** Returns notifications for location within date range. */
  locationNotificationsForDateRange?: Maybe<Array<Maybe<NotificationGt>>>;
  /** Returns a list of operating hours for corresponding days of a specific location. Will return the organisation's default hours if not set. */
  locationOperatingHours?: Maybe<OperatingHoursForWeek>;
  locationTargetForDate?: Maybe<LocationTargetForDate>;
  /** Returns targets for location within date range. */
  locationTargetForDateRange?: Maybe<LocationTargetsGt>;
  /** Returns target values for a location. */
  locationTargetValues?: Maybe<TargetValueGt>;
  /** Returns the working patterns of the location's employees. */
  locationWorkingPatterns?: Maybe<LocationWorkingPattern>;
  /** Returns a list of all locations. Examples of Locations: restaurants, shops, etc. */
  locations?: Maybe<Array<Maybe<Location>>>;
  locationsForManager?: Maybe<Array<Maybe<Location>>>;
  /** Returns a list of an employee's availability exceptions. */
  myAvailabilityExceptions?: Maybe<AvailabilityExceptions>;
  /** Returns my employee data. */
  myEmployee?: Maybe<ReadEmployee>;
  /** My home location */
  myHomeLocation?: Maybe<Location>;
  /** Returns upcoming shifts in the next 30 days */
  myNextShifts?: Maybe<Shifts>;
  /** Returns an employee's personal settings. */
  mySettings?: Maybe<ReadSettings>;
  /** Returns a list of shifts in date range. */
  myShiftsForDateRange?: Maybe<Shifts>;
  /** Returns the constraints of the employee. */
  myWorkRules?: Maybe<MyConstraints>;
  /** Returns vacant shift counts in the location. */
  notifiableVacantShiftsInDateRange?: Maybe<CountAndShifts>;
  /** Returns a list of operating hours exceptions. */
  operatingHoursExceptions?: Maybe<OperatingHoursExceptionsGt>;
  /** Returns the organisation's wide operating hours. */
  organisationOperatingHours?: Maybe<OperatingHoursForWeek>;
  /** Returns organisation settings. */
  organisationSettings?: Maybe<OrganisationSettings>;
  /** Returns a list of overtime rules. */
  overtimeRules?: Maybe<Array<Maybe<ReadOvertimeRules>>>;
  /** Returns a persona. */
  persona?: Maybe<Persona>;
  /** Returns a list of personas. */
  personas?: Maybe<Array<Maybe<Persona>>>;
  /** Returns a contract. */
  readContract?: Maybe<ReadContractTypes>;
  /** Returns all contracts. */
  readContracts?: Maybe<Array<Maybe<ReadContractTypes>>>;
  /** Returns a list of the employee roles. */
  roles?: Maybe<Array<Maybe<ReadRole>>>;
  /** Returns roster with provided Id. */
  roster?: Maybe<ReadRoster>;
  /** Returns the roster of a specific location for a specific day. Despite requiring a date range, only the start date is used. */
  rosterByLocationAndDate?: Maybe<ReadRoster>;
  /** Returns properties for the roster ids. */
  rosterProperties?: Maybe<Array<Maybe<RosterProperties>>>;
  /** Returns a list of stations currently assigned to a roster. */
  rosterStations?: Maybe<ReadSelectedRosterStations>;
  /** Returns a list of roster statuses for a given location for a given date range. */
  rosterStatuses?: Maybe<Array<Maybe<RosterStatus>>>;
  /** List of all rosters where the specified contract role is selected in positions. */
  rosterSummariesByContractRoleId?: Maybe<Array<Maybe<ReadRosterSummary>>>;
  /** Returns the template of a specific location for a specific day. Despite requiring a date range, only the start date is used. */
  rosterTemplate?: Maybe<ReadTemplate>;
  /** Returns the templates of a specific location for a specific day. */
  rosterTemplatesInDateRange?: Maybe<Array<Maybe<ReadTemplate>>>;
  /** Returns a list of rostered staff where the roster date is after their leave date. */
  rosteredStaffAfterLeaveDate?: Maybe<Array<Maybe<RosteredEmployeeIdAndDates>>>;
  /** Returns a list of rostered staff for a given location for a given date range. */
  rosteredStaffInDateRange?: Maybe<Array<Maybe<RosteredEmployeeIdAndSchedule>>>;
  /** Returns a list of all rosters. */
  rosters?: Maybe<Array<Maybe<ReadRoster>>>;
  /** Returns a list of all rosters for specified location. */
  rostersForLocation?: Maybe<Array<Maybe<ReadRoster>>>;
  /** Returns a list of rosters for given locations for a given date range. */
  rostersForLocations?: Maybe<Array<Maybe<ReadRoster>>>;
  /** Returns a list of rosters for a given location for a given date range. */
  rostersInDateRange?: Maybe<Array<Maybe<ReadRoster>>>;
  /** Get rosters including positions and tasks for a given location for a given date range. */
  rostersWithPositionsAndTasksInDateRange?: Maybe<Array<Maybe<ReadRoster>>>;
  /** Returns a list of availabilities that overlap the required time slot. */
  searchAvailabilities?: Maybe<Array<Maybe<AvailableEmployeesInLocation>>>;
  /** Returns shift operating hours for a given location for a given date range. */
  shiftOperatingHoursInDateRange?: Maybe<Array<Maybe<ShiftOperatingHoursDay>>>;
  shopAccounts?: Maybe<Array<Maybe<ReadEmployee>>>;
  /** Returns a list of skills. */
  skills?: Maybe<Array<Maybe<ReadSkills>>>;
  /** Returns a station. */
  station?: Maybe<ReadStation>;
  /** Returns a list of stations. */
  stations?: Maybe<Array<Maybe<ReadStation>>>;
  /** Returns a list of holiday regions supported by the system. */
  supportedHolidayRegions?: Maybe<Array<Maybe<HolidayRegion>>>;
  /** Returns all targets. */
  targets?: Maybe<Array<Maybe<LocationTargetsGt>>>;
  /** Returns targets by location IDs. */
  targetsByLocationIds?: Maybe<Array<Maybe<TargetGt>>>;
  /** Returns a task. */
  task?: Maybe<ReadTask>;
  /** Returns a list of tasks. */
  tasks?: Maybe<Array<Maybe<ReadTask>>>;
  /** Returns template with provided Id. */
  template?: Maybe<ReadTemplate>;
  /** Lists stations currently assigned to a template. */
  templateStations?: Maybe<ReadSelectedTemplateStations>;
  /** List of all templates where the specified contract role is selected in positions. */
  templateSummariesByContractRoleId?: Maybe<Array<Maybe<ReadTemplateSummary>>>;
  /** Returns a list of all template tags that the user has access to. */
  templateTags?: Maybe<Array<Maybe<ReadTemplateTag>>>;
  /** Returns a list of all templates that the user has access to. */
  templates?: Maybe<Array<Maybe<ReadTemplate>>>;
  /** Returns a list of templates by template ids. */
  templatesByIds?: Maybe<Array<Maybe<ReadTemplate>>>;
  /** Returns a list of all templates for specified location. */
  templatesForLocation?: Maybe<Array<Maybe<ReadTemplate>>>;
  /** List of all templates for specified manager. */
  templatesForManager?: Maybe<Array<Maybe<ReadTemplate>>>;
  /** Returns the current tenant. */
  tenant?: Maybe<Tenant>;
  /** Returns vacant shifts from the location. */
  vacantShiftsInDateRange?: Maybe<CountAndShifts>;
  /** Returns a list of the constraints of the employees. */
  workRules?: Maybe<Array<Maybe<EmployeeConstraints>>>;
  /** Returns a list of the constraints of the employees. */
  workRulesByEmployeeIds?: Maybe<Array<Maybe<EmployeeConstraints>>>;
};


export type RosteringQueryAvailabilitiesArgs = {
  employeeId: Scalars['Guid']['input'];
  start: Scalars['DateOnly']['input'];
};


export type RosteringQueryAvailabilityExceptionsArgs = {
  availabilityExceptions?: InputMaybe<EmployeesAndDateRange>;
};


export type RosteringQueryAvailabilityExceptionsForEmployeeArgs = {
  dateRange?: InputMaybe<MyAvailabilityExceptionsDateRange>;
  userId: Scalars['Guid']['input'];
};


export type RosteringQueryBatchJobStatusForLocationArgs = {
  locationIdAndDateRange?: InputMaybe<BatchStatusForLocation>;
};


export type RosteringQueryBatchJobStatusForManagerArgs = {
  managerIdAndDateRange?: InputMaybe<ManagerIdAndDateRange>;
};


export type RosteringQueryDayShiftsArgs = {
  dateAndIdentityIds?: InputMaybe<DayShifts>;
};


export type RosteringQueryDeviceArgs = {
  id?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryDevicesForLocationArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type RosteringQueryEmployeeArgs = {
  id?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryEmployeeByEmployeeIdArgs = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
};


export type RosteringQueryEmployeeByNameArgs = {
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type RosteringQueryEmployeeHistoryArgs = {
  idAndDateRange?: InputMaybe<GetEmployeeHistory>;
};


export type RosteringQueryEmployeeIdWorkingPatternsArgs = {
  dateAndPeriods?: InputMaybe<DateAndPeriods>;
  id?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryEmployeeNamesByIdsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
};


export type RosteringQueryEmployeeSkillsArgs = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryEmployeeSkillsByEmployeeIdsArgs = {
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
};


export type RosteringQueryEmployeeSummariesByContractRoleIdArgs = {
  contractRoleId?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryEmployeeSummariesByContractTypeIdArgs = {
  contractTypeId?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryEmployeeWorkingPatternsArgs = {
  dateAndPeriods?: InputMaybe<DateAndPeriods>;
};


export type RosteringQueryEmployeesAssignedToRolesInContractArgs = {
  contractId?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryEmployeesByIdsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
};


export type RosteringQueryEmployeesByLocationsArgs = {
  locationIds: Array<Scalars['Int']['input']>;
};


export type RosteringQueryFindReassignedShiftsArgs = {
  searchParams?: InputMaybe<FindReassignedShifts>;
};


export type RosteringQueryFindReassignedShiftsInDateRangeArgs = {
  searchParams?: InputMaybe<FindReassignedShiftsInDateRange>;
};


export type RosteringQueryFindShiftsByPropertyArgs = {
  searchParams?: InputMaybe<FindShiftsByProperty>;
};


export type RosteringQueryGetMyEmployeesShiftsArgs = {
  locationAndDateRange?: InputMaybe<GetLocationShiftsForDateRange>;
};


export type RosteringQueryGetMyOpenWorkTimeRecordArgs = {
  queryOpenWorkItemArgs?: InputMaybe<GetMyWorkTimeRecordsGt>;
};


export type RosteringQueryGetMyWorkTimeRecordArgs = {
  queryWorkItemArgs?: InputMaybe<GetMyWorkTimeRecordsInRangeGt>;
};


export type RosteringQueryGetOpenWorkTimeRecordArgs = {
  queryOpenWorkItemArgs?: InputMaybe<GetWorkTimeRecordsGt>;
};


export type RosteringQueryGetWorkTimeRecordArgs = {
  queryWorkItemArgs?: InputMaybe<GetWorkTimeRecordsInRangeGt>;
};


export type RosteringQueryGetWorkTimeRecordHistoryArgs = {
  recordId?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryGlobalEmployeeSearchArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type RosteringQueryHolidaysArgs = {
  holidays?: InputMaybe<HolidayRegionCodeAndDateRange>;
};


export type RosteringQueryLeaveTypeArgs = {
  id?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryLeaveTypeDeleteValidationArgs = {
  boundaryDate: Scalars['DateOnly']['input'];
  leaveTypeId: Scalars['Guid']['input'];
};


export type RosteringQueryLocationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type RosteringQueryLocationAvailabilityExceptionsArgs = {
  locationDates?: InputMaybe<LocationAndDateRange>;
};


export type RosteringQueryLocationHolidaysArgs = {
  locationId: Scalars['Int']['input'];
};


export type RosteringQueryLocationNotificationsForDateRangeArgs = {
  notifications?: InputMaybe<GetNotifications>;
};


export type RosteringQueryLocationOperatingHoursArgs = {
  locationId: Scalars['Int']['input'];
};


export type RosteringQueryLocationTargetForDateArgs = {
  locationAndDate?: InputMaybe<GetLocationTargetForDate>;
};


export type RosteringQueryLocationTargetForDateRangeArgs = {
  locationAndDateRange?: InputMaybe<DateRangeAndLocation>;
};


export type RosteringQueryLocationTargetValuesArgs = {
  targetLocation?: InputMaybe<GetLocationTargetValues>;
};


export type RosteringQueryLocationWorkingPatternsArgs = {
  locationAndPeriod?: InputMaybe<LocationAndPeriod>;
};


export type RosteringQueryLocationsForManagerArgs = {
  managerId?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryMyAvailabilityExceptionsArgs = {
  dateRange?: InputMaybe<MyAvailabilityExceptionsDateRange>;
};


export type RosteringQueryMyShiftsForDateRangeArgs = {
  range?: InputMaybe<GetShiftsForDateRange>;
};


export type RosteringQueryNotifiableVacantShiftsInDateRangeArgs = {
  notifiableVacantShifts?: InputMaybe<NotifiableVacantShiftsInDateRange>;
};


export type RosteringQueryOperatingHoursExceptionsArgs = {
  getOperatingHoursExceptions: GetOperatingHoursExceptions;
};


export type RosteringQueryPersonaArgs = {
  id: Scalars['Guid']['input'];
};


export type RosteringQueryReadContractArgs = {
  id: Scalars['Guid']['input'];
};


export type RosteringQueryRosterArgs = {
  id?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryRosterByLocationAndDateArgs = {
  locationAndDay?: InputMaybe<RestaurantAndDateRange>;
};


export type RosteringQueryRosterPropertiesArgs = {
  rosterIds?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
};


export type RosteringQueryRosterStationsArgs = {
  id?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryRosterStatusesArgs = {
  dateRangeAndLocations?: InputMaybe<RosterStatuses>;
};


export type RosteringQueryRosterSummariesByContractRoleIdArgs = {
  contractRoleId?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryRosterTemplateArgs = {
  locationAndDay?: InputMaybe<RestaurantAndDateRange>;
};


export type RosteringQueryRosterTemplatesInDateRangeArgs = {
  locationAndDateRange?: InputMaybe<RestaurantAndDateRange>;
};


export type RosteringQueryRosteredStaffAfterLeaveDateArgs = {
  rosteredStaffAfterLeave?: InputMaybe<RosteredStaffAfterLeaveDate>;
};


export type RosteringQueryRosteredStaffInDateRangeArgs = {
  restaurantAndDateRange?: InputMaybe<RestaurantAndDateRange>;
};


export type RosteringQueryRostersForLocationArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type RosteringQueryRostersForLocationsArgs = {
  locationsAndDateRange?: InputMaybe<LocationsAndDateRange>;
};


export type RosteringQueryRostersInDateRangeArgs = {
  restaurantAndDateRange?: InputMaybe<RestaurantAndDateRange>;
};


export type RosteringQueryRostersWithPositionsAndTasksInDateRangeArgs = {
  locationAndDateRange?: InputMaybe<RestaurantAndDateRange>;
};


export type RosteringQuerySearchAvailabilitiesArgs = {
  search: SearchAvailabilities;
};


export type RosteringQueryShiftOperatingHoursInDateRangeArgs = {
  locationAndDateRange?: InputMaybe<GetShiftOperatingHoursInDateRange>;
};


export type RosteringQueryStationArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type RosteringQueryTargetsArgs = {
  from?: InputMaybe<Scalars['DateOnly']['input']>;
};


export type RosteringQueryTargetsByLocationIdsArgs = {
  targetsLocationIds?: InputMaybe<TargetsByLocationIds>;
};


export type RosteringQueryTaskArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type RosteringQueryTemplateArgs = {
  id?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryTemplateStationsArgs = {
  id?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryTemplateSummariesByContractRoleIdArgs = {
  contractRoleId?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryTemplatesByIdsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
};


export type RosteringQueryTemplatesForLocationArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
};


export type RosteringQueryTemplatesForManagerArgs = {
  managerId?: InputMaybe<Scalars['Guid']['input']>;
};


export type RosteringQueryVacantShiftsInDateRangeArgs = {
  locationAndDateRange?: InputMaybe<VacantShiftsInDateRange>;
};


export type RosteringQueryWorkRulesArgs = {
  ids: Array<InputMaybe<Scalars['Guid']['input']>>;
};


export type RosteringQueryWorkRulesByEmployeeIdsArgs = {
  employeeIds: Array<InputMaybe<Scalars['Guid']['input']>>;
};

export type RosteringSubscription = {
  __typename?: 'RosteringSubscription';
  availabilityExceptionChange?: Maybe<AvailabilityExceptionChangeNotifyGt>;
  batchJobStateChange?: Maybe<BatchJobStateChangeNotifyGt>;
  notificationChange?: Maybe<NotificationChangeNotifyGt>;
  rosterChange?: Maybe<RosterChangeNotifyGt>;
  sessionState?: Maybe<ReadAccessTokenEvent>;
};

/** Starts a work time record for the calling user. */
export type StartMyWorkTimeRecord = {
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  locationId: Scalars['Int']['input'];
  start: Scalars['DateTime']['input'];
  startGeoLocation?: InputMaybe<UpdateGeoLocation>;
  startSource?: InputMaybe<WorkTimeDataSource>;
  verificationCode?: InputMaybe<Scalars['String']['input']>;
};

/** Starts a work time record for a user. */
export type StartWorkTimeRecord = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  locationId: Scalars['Int']['input'];
  start: Scalars['DateTime']['input'];
  startGeoLocation?: InputMaybe<UpdateGeoLocation>;
  startSource?: InputMaybe<WorkTimeDataSource>;
};

/** Returns target comparison. */
export type TargetComparisonGt = {
  __typename?: 'TargetComparisonGT';
  actual: Scalars['Float']['output'];
  condition: Scalars['String']['output'];
  difference: Scalars['Float']['output'];
  target: Scalars['Float']['output'];
  targetId?: Maybe<Scalars['Guid']['output']>;
  type: Scalars['String']['output'];
};

/** Returns target date. */
export type TargetDateGt = {
  __typename?: 'TargetDateGT';
  date: Scalars['DateOnly']['output'];
  targetData?: Maybe<Array<Maybe<TargetComparisonGt>>>;
};

/** Returns target for location. */
export type TargetGt = {
  __typename?: 'TargetGT';
  date?: Maybe<Scalars['DateOnly']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  locationId: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/** Returns target value. */
export type TargetValueGt = {
  __typename?: 'TargetValueGT';
  locationId: Scalars['Int']['output'];
  typeName: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export enum Tier {
  Advanced = 'ADVANCED',
  Standard = 'STANDARD'
}

/** Updates availability exception. */
export type UpdateAvailabilityExceptionDetail = {
  date: Scalars['DateOnly']['input'];
  end?: InputMaybe<Scalars['Seconds']['input']>;
  leaveTypeId?: InputMaybe<Scalars['Guid']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates a geo-location. */
export type UpdateGeoLocation = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/** Updates station selection. */
export type UpdateStationSelectionGt = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  selected: Scalars['Boolean']['input'];
};

/** Updates a work time origin. */
export type UpdateWorkTimeOrigin = {
  dateTime: Scalars['DateTime']['input'];
  geoLocation?: InputMaybe<UpdateGeoLocation>;
  origin?: InputMaybe<WorkTimeDataSource>;
};

export enum WorkTimeChangeReason {
  Forgot = 'FORGOT',
  ManagerCorrection = 'MANAGER_CORRECTION',
  SelfCorrection = 'SELF_CORRECTION'
}

export enum WorkTimeDataRisk {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum WorkTimeDataSource {
  Location = 'LOCATION',
  Manual = 'MANUAL',
  ManualLate = 'MANUAL_LATE',
  Nfc = 'NFC',
  None = 'NONE',
  Override = 'OVERRIDE',
  SecureCode = 'SECURE_CODE'
}

/** Returns origin of work time information. */
export type WorkTimeOrigin = {
  __typename?: 'WorkTimeOrigin';
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  device?: Maybe<Device>;
  geoLocation?: Maybe<GeoLocation>;
  origin?: Maybe<WorkTimeDataSource>;
};

/** Returns work time record. */
export type WorkTimeRecord = {
  __typename?: 'WorkTimeRecord';
  employeeId?: Maybe<Scalars['Guid']['output']>;
  end?: Maybe<WorkTimeOrigin>;
  id?: Maybe<Scalars['Guid']['output']>;
  locationId: Scalars['Int']['output'];
  risk?: Maybe<WorkTimeDataRisk>;
  start?: Maybe<WorkTimeOrigin>;
};

/** Returns work time record changed value. */
export type WorkTimeRecordChange = {
  __typename?: 'WorkTimeRecordChange';
  changeReason?: Maybe<WorkTimeChangeReason>;
  changedBy?: Maybe<Scalars['Guid']['output']>;
  changedOn?: Maybe<Scalars['DateTime']['output']>;
  end?: Maybe<WorkTimeOrigin>;
  recordId?: Maybe<Scalars['Guid']['output']>;
  start?: Maybe<WorkTimeOrigin>;
};

/** Returns working pattern. */
export type WorkingPatternGt = {
  __typename?: 'WorkingPatternGT';
  workRules?: Maybe<MyConstraints>;
  workingPattern?: Maybe<Array<Maybe<WorkingPatternDay>>>;
};

/** Returns an address. */
export type Address = {
  __typename?: 'address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
};

/** Contains the employee Ids and period for which to generate availabilities. */
export type ApplyAvailabilities = {
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Contains the location and period for which to generate availability. */
export type ApplyAvailability = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
  singleExceptionPerDay?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** An employee assignment for a staffing position */
export type AssignPositionEmployee = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  positionId?: InputMaybe<Scalars['Guid']['input']>;
};

/** An employee assignment for staffing positions */
export type AssignPositionsEmployee = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  positionIds?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
};

/** An employee assignment for a staffing position on a roster. */
export type AssignRosterPositionEmployee = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  rosterPositionId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Adds a task to be added to a station on a roster. */
export type AssignRosterTask = {
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  rosterStationId?: InputMaybe<Scalars['Guid']['input']>;
  taskId: Scalars['Int']['input'];
};

/** An employee assignment for a staffing position. */
export type AssignTemplatePositionEmployee = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  templateId?: InputMaybe<Scalars['Guid']['input']>;
  templatePositionId?: InputMaybe<Scalars['Guid']['input']>;
};

/** An employee assignment for staffing positions. */
export type AssignTemplatePositionsEmployee = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  positionIds?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
};

/** A task to be added to a station on a template. */
export type AssignTemplateTask = {
  taskId: Scalars['Int']['input'];
  templateId?: InputMaybe<Scalars['Guid']['input']>;
  templateStationId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Returns an employee's availability exception. */
export type AvailabilityException = {
  __typename?: 'availabilityException';
  approval: Scalars['String']['output'];
  available: Scalars['Boolean']['output'];
  date?: Maybe<Scalars['DateOnly']['output']>;
  employeeId?: Maybe<Scalars['Guid']['output']>;
  end?: Maybe<Scalars['Seconds']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  leaveType?: Maybe<ReadLeaveType>;
  start?: Maybe<Scalars['Seconds']['output']>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

/** Returns a list of an employee's availability exceptions. */
export type AvailabilityExceptions = {
  __typename?: 'availabilityExceptions';
  exceptions?: Maybe<Array<Maybe<AvailabilityException>>>;
};

/** Returns availabilities for a location. */
export type AvailableEmployeesInLocation = {
  __typename?: 'availableEmployeesInLocation';
  availabilities?: Maybe<Array<Maybe<ReadAvailability>>>;
  location?: Maybe<Location>;
};

/** Details for retrieving batch status. */
export type BatchStatusForLocation = {
  dateRangeEnd?: InputMaybe<Scalars['DateOnly']['input']>;
  dateRangeStart?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Returns a break. */
export type Break = {
  __typename?: 'break';
  end?: Maybe<Scalars['Seconds']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
};

/** Change template for a roster. */
export type ChangeRosterTemplate = {
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  templateId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Returns a result of complete roster mutation. */
export type CompleteRosterResult = {
  __typename?: 'completeRosterResult';
  lastModified: Scalars['DateTime']['output'];
  publicationTime?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

/** Creates template from existing template. */
export type CopyTemplate = {
  newLocationId?: InputMaybe<Scalars['Int']['input']>;
  newName: Scalars['String']['input'];
  sourceTemplateId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Returns count and shifts. */
export type CountAndShifts = {
  __typename?: 'countAndShifts';
  count: Scalars['Int']['output'];
  shifts?: Maybe<Array<Maybe<ReadRosterDayPositions>>>;
  total: Scalars['Int']['output'];
};

/** Creates availability. */
export type CreateAvailability = {
  day?: InputMaybe<Scalars['DateOnly']['input']>;
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  end?: InputMaybe<Scalars['Seconds']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Creates details required to create an availability exception. */
export type CreateAvailabilityException = {
  date: Scalars['DateOnly']['input'];
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  end?: InputMaybe<Scalars['Seconds']['input']>;
  leaveTypeId?: InputMaybe<Scalars['Guid']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Creates a new contract. */
export type CreateContract = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  earliestStartTime?: InputMaybe<Scalars['Seconds']['input']>;
  latestEndTime?: InputMaybe<Scalars['Seconds']['input']>;
  maxConsecutiveDays?: InputMaybe<Scalars['Int']['input']>;
  maxDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  maxHoursPerDay?: InputMaybe<Scalars['Float']['input']>;
  maxHoursPerShift?: InputMaybe<Scalars['Float']['input']>;
  maxHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  minHoursPerDay?: InputMaybe<Scalars['Float']['input']>;
  minHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overtimeAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  workRuleName?: InputMaybe<Scalars['String']['input']>;
  workRuleType?: InputMaybe<Scalars['String']['input']>;
};

/** Creates a device. */
export type CreateDevice = {
  locationId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

/** Creates employee. */
export type CreateEmployee = {
  appUrl?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  contractModification?: InputMaybe<Scalars['Int']['input']>;
  contractTypeId?: InputMaybe<Scalars['Guid']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateOnly']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endOfProbationDate?: InputMaybe<Scalars['DateOnly']['input']>;
  firstName: Scalars['String']['input'];
  hireDate?: InputMaybe<Scalars['DateOnly']['input']>;
  homeLocationId?: InputMaybe<Scalars['Int']['input']>;
  isRosterable?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leaveDate?: InputMaybe<Scalars['DateOnly']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  sendRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
};

/** Creates leave type. */
export type CreateLeaveType = {
  active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** Creates a location. */
export type CreateLocation = {
  divisionId?: InputMaybe<Scalars['ID']['input']>;
  holidayRegionCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** details of a persona. */
export type CreatePersona = {
  adminControlled?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  management?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
  templateLibrarian?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Creates position. */
export type CreatePosition = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
  stationId: Scalars['Int']['input'];
  templateId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Details from which to create a Roster. */
export type CreateRoster = {
  locationId: Scalars['Int']['input'];
  rosterDate: Scalars['DateOnly']['input'];
  templateId: Scalars['ID']['input'];
};

/** Details from which to create a Roster Position. */
export type CreateRosterPosition = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
  stationId: Scalars['Int']['input'];
};

/** Creates a roster time slot. */
export type CreateRosterTaskTimeSlot = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  rosterTaskId?: InputMaybe<Scalars['Guid']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Creates settings. */
export type CreateSettings = {
  displayLanguage: Scalars['String']['input'];
};

/** Creates skill. */
export type CreateSkill = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['Int']['input']>;
};

/** Creates a station. */
export type CreateStation = {
  excludeHours?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

/** Creates a target. */
export type CreateTarget = {
  date: Scalars['DateOnly']['input'];
  locationId: Scalars['Int']['input'];
  targetType: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

/** Creates task. */
export type CreateTask = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  optionalSkills?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  stationId: Scalars['Int']['input'];
};

/** Creates template. */
export type CreateTemplate = {
  baseHours?: InputMaybe<Scalars['Float']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  includeAllStations: Scalars['Boolean']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
  targetValue?: InputMaybe<Scalars['Int']['input']>;
  templateTags?: InputMaybe<Array<InputMaybe<CreateTemplateTag>>>;
  version?: InputMaybe<Scalars['String']['input']>;
  weekday?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Creates templateTag. */
export type CreateTemplateTag = {
  label: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Creates task time slot on template. */
export type CreateTemplateTaskTimeSlot = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
  templateId?: InputMaybe<Scalars['Guid']['input']>;
  templateTaskId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Returns working pattern based on date and periods. */
export type DateAndPeriods = {
  date?: InputMaybe<Scalars['DateOnly']['input']>;
  periods?: InputMaybe<Scalars['Int']['input']>;
};

/** Returns date range and location. */
export type DateRangeAndLocation = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Returns shifts on the day. */
export type DayShift = {
  __typename?: 'dayShift';
  date?: Maybe<Scalars['DateOnly']['output']>;
  lastModified: Scalars['DateTime']['output'];
  publicationTime?: Maybe<Scalars['DateTime']['output']>;
  shifts?: Maybe<Array<Maybe<EmployeeShift>>>;
  status: Scalars['String']['output'];
};

/** Returns shifts on the day. */
export type DayShifts = {
  date?: InputMaybe<Scalars['DateOnly']['input']>;
  identityIds?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
};

/** Deletes an availability exception. */
export type DeleteAvailabilityException = {
  date: Scalars['DateOnly']['input'];
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Deletes an employee's assignement on a template. */
export type DeleteEmployeeAssignment = {
  positionId?: InputMaybe<Scalars['Guid']['input']>;
  templateId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Deletes roster position. */
export type DeleteRosterPosition = {
  positionId?: InputMaybe<Scalars['Guid']['input']>;
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Deletes roster task. */
export type DeleteRosterTask = {
  idToRemove?: InputMaybe<Scalars['Guid']['input']>;
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Deletes roster time slot. */
export type DeleteRosterTimeSlot = {
  idToRemove?: InputMaybe<Scalars['Guid']['input']>;
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Deletes rosters within a date range for a location. */
export type DeleteRostersInDateRange = {
  dateRangeEnd?: InputMaybe<Scalars['DateOnly']['input']>;
  dateRangeStart?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Deletes template position. */
export type DeleteTemplatePosition = {
  positionId?: InputMaybe<Scalars['Guid']['input']>;
  templateId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Deletes task on a template. */
export type DeleteTemplateTask = {
  idToRemove?: InputMaybe<Scalars['Guid']['input']>;
  templateId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Deletes time slot on a template. */
export type DeleteTemplateTimeSlot = {
  idToRemove?: InputMaybe<Scalars['Guid']['input']>;
  templateId?: InputMaybe<Scalars['Guid']['input']>;
};

/** a registered device. */
export type Device = {
  __typename?: 'device';
  activated: Scalars['Boolean']['output'];
  activationId?: Maybe<Scalars['String']['output']>;
  activationToken?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  secret?: Maybe<Scalars['String']['output']>;
};

/** Returns a list of availability exceptions for the employee. */
export type EmployeeAvailabilityExceptions = {
  __typename?: 'employeeAvailabilityExceptions';
  employeeId?: Maybe<Scalars['Guid']['output']>;
  patternsAndExceptions?: Maybe<Array<Maybe<PatternsAndExceptions>>>;
};

/** Returns constraints for an employee. */
export type EmployeeConstraints = {
  __typename?: 'employeeConstraints';
  id?: Maybe<Scalars['Guid']['output']>;
  identityId?: Maybe<Scalars['Guid']['output']>;
  maxDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  maxHoursPerMonth?: Maybe<Scalars['Float']['output']>;
  maxHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  maxNumOfConsecutiveDays: Scalars['Int']['output'];
  minHoursPerMonth?: Maybe<Scalars['Float']['output']>;
  minHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  totalNumberOfWorkDaysInMonth: Scalars['Int']['output'];
};

/** Returns an employe's contract. */
export type EmployeeContract = {
  __typename?: 'employeeContract';
  contractModificationId: Scalars['Int']['output'];
  contractModificationName: Scalars['String']['output'];
  contractTypeId?: Maybe<Scalars['ID']['output']>;
  contractTypeName?: Maybe<Scalars['String']['output']>;
};

/** Returns locations information for an employee. */
export type EmployeeLocationsInfo = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Returns employee working pattern. */
export type EmployeePattern = {
  __typename?: 'employeePattern';
  identityId?: Maybe<Scalars['Guid']['output']>;
  periods?: Maybe<Array<Maybe<WorkingPatternPeriod>>>;
};

/** Returns an employee shift. */
export type EmployeeShift = {
  __typename?: 'employeeShift';
  breaks?: Maybe<Array<Maybe<Break>>>;
  end?: Maybe<Scalars['Seconds']['output']>;
  identityId?: Maybe<Scalars['Guid']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
  stationId: Scalars['Int']['output'];
  stationName: Scalars['String']['output'];
};

/** Updates employees skills. */
export type EmployeeSkill = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  employeeSkillId?: InputMaybe<Scalars['Int']['input']>;
  rating: Scalars['Int']['input'];
  skillId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Returns work time record. */
export type EmployeeWorkTimeRecord = {
  __typename?: 'employeeWorkTimeRecord';
  employee?: Maybe<ReadEmployee>;
  employeeId?: Maybe<Scalars['Guid']['output']>;
  end?: Maybe<WorkTimeOrigin>;
  id?: Maybe<Scalars['Guid']['output']>;
  locationId: Scalars['Int']['output'];
  risk?: Maybe<WorkTimeDataRisk>;
  start?: Maybe<WorkTimeOrigin>;
};

/** Contains the employee ids and date range for which to get the availability exceptions. */
export type EmployeesAndDateRange = {
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Returns reassigned shifts from the location. */
export type FindReassignedShifts = {
  date?: InputMaybe<Scalars['DateOnly']['input']>;
  homeLocationId: Scalars['Int']['input'];
};

/** Returns reassigned shifts from the location. */
export type FindReassignedShiftsInDateRange = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  homeLocationId: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Returns shifts for the date within the locations. */
export type FindShiftsByProperty = {
  date?: InputMaybe<Scalars['DateOnly']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  propertyPath: Scalars['String']['input'];
  propertyValue: Scalars['String']['input'];
};

/** Returns shifts found by a search. */
export type FoundShifts = {
  __typename?: 'foundShifts';
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  shifts?: Maybe<Array<Maybe<ReadRosterPositions>>>;
};

/** Returns shifts found by a search. */
export type FoundShiftsInDateRange = {
  __typename?: 'foundShiftsInDateRange';
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  shifts?: Maybe<Array<Maybe<ReadRosterDayPositions>>>;
};

/** Returns an employee's GDPR availability exception. */
export type Gdpr_AvailabilityException = {
  __typename?: 'gdpr_availabilityException';
  approval: Scalars['String']['output'];
  approvedOn?: Maybe<Scalars['DateTime']['output']>;
  available: Scalars['Boolean']['output'];
  date: Scalars['DateOnly']['output'];
  end?: Maybe<Scalars['Seconds']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

/** Returns GDPR availability. */
export type Gdpr_ReadAvailability = {
  __typename?: 'gdpr_readAvailability';
  day?: Maybe<Scalars['DateOnly']['output']>;
  end?: Maybe<Scalars['Seconds']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns an employee's GDPR. */
export type Gdpr_ReadEmployee = {
  __typename?: 'gdpr_readEmployee';
  acceptedPrivacyPolicy?: Maybe<Scalars['DateTime']['output']>;
  acceptedTermsAndConditions?: Maybe<Scalars['DateTime']['output']>;
  availabilities?: Maybe<Array<Maybe<Gdpr_ReadAvailability>>>;
  availabilityExceptions?: Maybe<Array<Maybe<Gdpr_AvailabilityException>>>;
  contract?: Maybe<EmployeeContract>;
  contractModification?: Maybe<Scalars['Int']['output']>;
  dateOfBirth?: Maybe<Scalars['DateOnly']['output']>;
  displayLanguage?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  employeeLocations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  employeeSkills?: Maybe<Array<Maybe<Gdpr_ReadEmployeeSkill>>>;
  endOfProbationDate?: Maybe<Scalars['DateOnly']['output']>;
  firstName: Scalars['String']['output'];
  hireDate?: Maybe<Scalars['DateOnly']['output']>;
  identityId?: Maybe<Scalars['Guid']['output']>;
  isRosterable?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leaveDate?: Maybe<Scalars['DateOnly']['output']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  roleId?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
  workingPattern?: Maybe<Gdpr_WorkingPatternGt>;
};

/** Returns employee's skill (GDPR). */
export type Gdpr_ReadEmployeeSkill = {
  __typename?: 'gdpr_readEmployeeSkill';
  rating: Scalars['Int']['output'];
  taskName: Scalars['String']['output'];
};

/** Returns a day's working pattern for an employee (GDPR). */
export type Gdpr_WorkingPatternDay = {
  __typename?: 'gdpr_workingPatternDay';
  approvedOn?: Maybe<Scalars['DateTime']['output']>;
  available: Scalars['Boolean']['output'];
  day: Scalars['String']['output'];
  dayNumber?: Maybe<Scalars['Int']['output']>;
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  effectiveFrom?: Maybe<Scalars['DateOnly']['output']>;
  effectiveTo?: Maybe<Scalars['DateOnly']['output']>;
  endTime?: Maybe<Scalars['Seconds']['output']>;
  startTime?: Maybe<Scalars['Seconds']['output']>;
  state: Scalars['String']['output'];
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

/** Gets employee history. */
export type GetEmployeeHistory = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  endDate?: InputMaybe<Scalars['DateOnly']['input']>;
  startDate?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Returns location shifts within a date range. */
export type GetLocationShiftsForDateRange = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Returns target for location for date.(Target type should be Sales). */
export type GetLocationTargetForDate = {
  date: Scalars['DateOnly']['input'];
  locationId: Scalars['Int']['input'];
  targetType: Scalars['String']['input'];
};

/** Returns target values for location for date. */
export type GetLocationTargetValues = {
  locationId: Scalars['Int']['input'];
  targetType: Scalars['String']['input'];
};

/** Returns the notification to the trigger. */
export type GetNotifications = {
  endDate?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateOnly']['input']>;
  triggerType: Scalars['Int']['input'];
};

/** Returns operating hours exceptions. */
export type GetOperatingHoursExceptions = {
  endDate?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Returns shift operating hours within a date range for a location. */
export type GetShiftOperatingHoursInDateRange = {
  dateRangeEnd?: InputMaybe<Scalars['DateOnly']['input']>;
  dateRangeStart?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Returns shifts within a date range. */
export type GetShiftsForDateRange = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  includeLocationRosterStatuses?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Returns national holiday. */
export type Holiday = {
  __typename?: 'holiday';
  active?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['DateOnly']['output']>;
  holidayRegionCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** Returns a supported holiday region. */
export type HolidayRegion = {
  __typename?: 'holidayRegion';
  code: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

/** Date range to get holidays. */
export type HolidayRegionCodeAndDateRange = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  holidayRegionCode?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Returns a list of national holidays. */
export type Holidays = {
  __typename?: 'holidays';
  holidays?: Maybe<Array<Maybe<Holiday>>>;
};

/** Deactivates employee status. */
export type Id = {
  __typename?: 'id';
  deactivated: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

/** Returns the usage validation result for deleting a leave type. */
export type LeaveTypeDeleteValidation = {
  __typename?: 'leaveTypeDeleteValidation';
  hasUsagesBeforeBoundary: Scalars['Boolean']['output'];
  usagesOnOrAfterBoundary: Array<LeaveTypeUsageOnOrAfterBoundary>;
};

/** Returns an availability exception on or after the provided boundary date. */
export type LeaveTypeUsageOnOrAfterBoundary = {
  __typename?: 'leaveTypeUsageOnOrAfterBoundary';
  availabilityExceptionId?: Maybe<Scalars['Guid']['output']>;
  date?: Maybe<Scalars['DateOnly']['output']>;
  employeeId?: Maybe<Scalars['Guid']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
};

/** Returns a location. */
export type Location = {
  __typename?: 'location';
  active: Scalars['Boolean']['output'];
  address?: Maybe<Address>;
  devices?: Maybe<Array<Maybe<Device>>>;
  externalId?: Maybe<Scalars['String']['output']>;
  holidayRegionCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  locationCoordinates?: Maybe<Array<Maybe<LocationCoordinates>>>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
};

/** Contains the location and date range for which to get the availability exceptions. */
export type LocationAndDateRange = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Returns location data for a period. */
export type LocationAndPeriod = {
  date?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
  periods?: InputMaybe<Scalars['Int']['input']>;
};

/** Returns a list of all availability exceptions for an employee's location. */
export type LocationAvailabilityExceptions = {
  __typename?: 'locationAvailabilityExceptions';
  employeeAvailabilityExceptions?: Maybe<Array<Maybe<EmployeeAvailabilityExceptions>>>;
  end: Scalars['DateOnly']['output'];
  locationId: Scalars['Int']['output'];
  start: Scalars['DateOnly']['output'];
};

/** Returns location coordinates. */
export type LocationCoordinates = {
  __typename?: 'locationCoordinates';
  id?: Maybe<Scalars['Guid']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
};

/** Returns a list of location coordinates. */
export type LocationCoordinatesList = {
  __typename?: 'locationCoordinatesList';
  locationsCoordinates?: Maybe<Array<Maybe<LocationCoordinates>>>;
};

/** Returns a location-scoped holiday. */
export type LocationHoliday = {
  __typename?: 'locationHoliday';
  active?: Maybe<Scalars['Boolean']['output']>;
  date: Scalars['DateOnly']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

/** Returns shifts in the location. */
export type LocationShift = {
  __typename?: 'locationShift';
  dates?: Maybe<Array<Maybe<DayShift>>>;
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
};

/** Returns location summary. */
export type LocationSummary = {
  __typename?: 'locationSummary';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Returns a target for a location and date. */
export type LocationTargetForDate = {
  __typename?: 'locationTargetForDate';
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/** Returns all working patterns for employees of a given location. */
export type LocationWorkingPattern = {
  __typename?: 'locationWorkingPattern';
  employeePatterns?: Maybe<Array<Maybe<EmployeePattern>>>;
};

/** Returns rosters within a date range for locations. */
export type LocationsAndDateRange = {
  dateRangeEnd?: InputMaybe<Scalars['DateOnly']['input']>;
  dateRangeStart?: InputMaybe<Scalars['DateOnly']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Details for retrieving batch status. */
export type ManagerIdAndDateRange = {
  dateRangeEnd?: InputMaybe<Scalars['DateOnly']['input']>;
  dateRangeStart?: InputMaybe<Scalars['DateOnly']['input']>;
  managerId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Returns the minimal roster data needed after a mutation. */
export type MinimalRosterResult = {
  __typename?: 'minimalRosterResult';
  id?: Maybe<Scalars['Guid']['output']>;
  lastModified: Scalars['DateTime']['output'];
  publicationTime?: Maybe<Scalars['DateTime']['output']>;
  rosterDate?: Maybe<Scalars['DateOnly']['output']>;
  status: Scalars['String']['output'];
};

/** Returns the minimal template data needed after a mutation. */
export type MinimalTemplateResult = {
  __typename?: 'minimalTemplateResult';
  id?: Maybe<Scalars['Guid']['output']>;
};

/** date range to get my availability exceptions. */
export type MyAvailabilityExceptionsDateRange = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Returns constraints for an employee. */
export type MyConstraints = {
  __typename?: 'myConstraints';
  id?: Maybe<Scalars['Guid']['output']>;
  maxDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  maxHoursPerMonth?: Maybe<Scalars['Float']['output']>;
  maxHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  maxNumOfConsecutiveDays: Scalars['Int']['output'];
  minHoursPerMonth?: Maybe<Scalars['Float']['output']>;
  minHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  totalNumberOfWorkDaysInMonth: Scalars['Int']['output'];
};

/** Creates new location coordinates. */
export type NewLocationCoordinates = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationId: Scalars['Int']['input'];
  locationName: Scalars['String']['input'];
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

/** Returns vacant shifts of the location. */
export type NotifiableVacantShiftsInDateRange = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  homeLocationId: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['DateOnly']['input']>;
  triggerType: Scalars['Int']['input'];
};

/** Returns operating hours in a day.; */
export type OperatingHours = {
  __typename?: 'operatingHours';
  closeTime?: Maybe<Scalars['Seconds']['output']>;
  day: Scalars['String']['output'];
  dayNumber?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['Seconds']['output']>;
  id: Scalars['Int']['output'];
  locationId?: Maybe<Scalars['Int']['output']>;
  openTime?: Maybe<Scalars['Seconds']['output']>;
  startTime?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns operating hours exception. */
export type OperatingHoursException = {
  __typename?: 'operatingHoursException';
  closeTime?: Maybe<Scalars['Seconds']['output']>;
  closed: Scalars['Boolean']['output'];
  date?: Maybe<Scalars['DateOnly']['output']>;
  endTime?: Maybe<Scalars['Seconds']['output']>;
  openTime?: Maybe<Scalars['Seconds']['output']>;
  startTime?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns a list of operating hours.; */
export type OperatingHoursForWeek = {
  __typename?: 'operatingHoursForWeek';
  operatingHours?: Maybe<Array<Maybe<OperatingHours>>>;
};

/** Returns an organisation's settings. */
export type OrganisationSettings = {
  __typename?: 'organisationSettings';
  defaultHolidayRegionCode?: Maybe<Scalars['String']['output']>;
  leaveTypeTier?: Maybe<Tier>;
  minMinutesAfterBreak?: Maybe<Scalars['Seconds']['output']>;
  minMinutesBeforeBreak?: Maybe<Scalars['Seconds']['output']>;
  shortestBreak?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns a list of patterns and availability exceptions. */
export type PatternsAndExceptions = {
  __typename?: 'patternsAndExceptions';
  end: Scalars['DateOnly']['output'];
  exceptions?: Maybe<Array<Maybe<AvailabilityException>>>;
  patterns?: Maybe<Array<Maybe<WorkingPatternDay>>>;
  start: Scalars['DateOnly']['output'];
};

/** Returns a persona. */
export type Persona = {
  __typename?: 'persona';
  adminControlled?: Maybe<Scalars['Boolean']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  management?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['String']['output']>;
  templateLibrarian?: Maybe<Scalars['Boolean']['output']>;
};

/** Pushes a notification to staff members in the location. */
export type PushNotifications = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['DateOnly']['input']>;
  triggerType: Scalars['Int']['input'];
};

/** Returns access token event */
export type ReadAccessTokenEvent = {
  __typename?: 'readAccessTokenEvent';
  accessTokenEventType: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
};

/** Returns availability. */
export type ReadAvailability = {
  __typename?: 'readAvailability';
  day?: Maybe<Scalars['DateOnly']['output']>;
  employeeId?: Maybe<Scalars['Guid']['output']>;
  end?: Maybe<Scalars['Seconds']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns availability history. */
export type ReadAvailabilityHistory = {
  __typename?: 'readAvailabilityHistory';
  date?: Maybe<Scalars['DateOnly']['output']>;
  history?: Maybe<Array<Maybe<ReadAvailabilityHistoryTimeSlot>>>;
  leaveTypeId?: Maybe<Scalars['Guid']['output']>;
};

/** Returns availability history timeslot. */
export type ReadAvailabilityHistoryTimeSlot = {
  __typename?: 'readAvailabilityHistoryTimeSlot';
  end?: Maybe<Scalars['Seconds']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns break offsets. */
export type ReadBreakOffsets = {
  __typename?: 'readBreakOffsets';
  timeOffsetAfterLastBreak?: Maybe<Scalars['Seconds']['output']>;
  timeOffsetBeforeFirstBreak?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns a contract role. */
export type ReadContractRole = {
  __typename?: 'readContractRole';
  active: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  id?: Maybe<Scalars['Guid']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
};

/** Returns contract types. */
export type ReadContractTypes = {
  __typename?: 'readContractTypes';
  active: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  earliestStartTime: Scalars['Seconds']['output'];
  id: Scalars['ID']['output'];
  latestEndTime: Scalars['Seconds']['output'];
  maxConsecutiveDays: Scalars['Int']['output'];
  maxDaysPerWeek: Scalars['Int']['output'];
  maxHoursPerDay: Scalars['Float']['output'];
  maxHoursPerShift: Scalars['Float']['output'];
  maxHoursPerWeek: Scalars['Float']['output'];
  minHoursPerDay: Scalars['Float']['output'];
  minHoursPerWeek: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  overtimeAllowed: Scalars['Boolean']['output'];
  properties?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<ReadContractRole>>>;
  workRuleName?: Maybe<Scalars['String']['output']>;
  workRuleType?: Maybe<Scalars['String']['output']>;
};

/** Returns division node. */
export type ReadDivision = {
  __typename?: 'readDivision';
  children?: Maybe<Array<Maybe<ReadDivision>>>;
  divisionId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  locations?: Maybe<Array<Maybe<Location>>>;
  name: Scalars['String']['output'];
};

/** Returns employee. */
export type ReadEmployee = {
  __typename?: 'readEmployee';
  acceptedPrivacyPolicy?: Maybe<Scalars['DateTime']['output']>;
  acceptedTermsAndConditions?: Maybe<Scalars['DateTime']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<EmployeeContract>;
  contractRoleId?: Maybe<Scalars['Guid']['output']>;
  dateOfBirth?: Maybe<Scalars['DateOnly']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  endOfProbationDate?: Maybe<Scalars['DateOnly']['output']>;
  firstName: Scalars['String']['output'];
  hireDate?: Maybe<Scalars['DateOnly']['output']>;
  homeLocationId?: Maybe<Scalars['Int']['output']>;
  identityId?: Maybe<Scalars['Guid']['output']>;
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isRosterable?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leaveDate?: Maybe<Scalars['DateOnly']['output']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  personas?: Maybe<Array<Maybe<Persona>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

/** Returns employee history. */
export type ReadEmployeeHistory = {
  __typename?: 'readEmployeeHistory';
  availabilityHistory?: Maybe<Array<Maybe<ReadAvailabilityHistory>>>;
  rosterHistory?: Maybe<Array<Maybe<ReadRosterHistory>>>;
};

/** Returns a pair of employee id and skills. */
export type ReadEmployeeIdAndSkills = {
  __typename?: 'readEmployeeIdAndSkills';
  employeeId?: Maybe<Scalars['Guid']['output']>;
  skills?: Maybe<Array<Maybe<ReadEmployeeSkills>>>;
};

/** Returns employee name. */
export type ReadEmployeeName = {
  __typename?: 'readEmployeeName';
  firstName: Scalars['String']['output'];
  identityId?: Maybe<Scalars['Guid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** Returns employees skills. */
export type ReadEmployeeSkills = {
  __typename?: 'readEmployeeSkills';
  employeeSkillId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  skillId?: Maybe<Scalars['Guid']['output']>;
  sortOrder: Scalars['Int']['output'];
  stationName?: Maybe<Scalars['String']['output']>;
};

/** Returns employee summary. */
export type ReadEmployeeSummary = {
  __typename?: 'readEmployeeSummary';
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  homeLocationId?: Maybe<Scalars['Int']['output']>;
  identityId?: Maybe<Scalars['Guid']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<LocationSummary>>>;
};

/** Returns a list of employees. */
export type ReadEmployeesList = {
  __typename?: 'readEmployeesList';
  employees?: Maybe<Array<Maybe<ReadEmployee>>>;
};

/** Returns language. */
export type ReadLanguage = {
  __typename?: 'readLanguage';
  name: Scalars['String']['output'];
  nativeName: Scalars['String']['output'];
};

/** Returns leave type. */
export type ReadLeaveType = {
  __typename?: 'readLeaveType';
  active: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Guid']['output']>;
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['String']['output']>;
};

/** Returns overtime rules. */
export type ReadOvertimeRules = {
  __typename?: 'readOvertimeRules';
  allowedOccurences: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  maxHoursPerMonth: Scalars['Int']['output'];
};

/** Returns role. */
export type ReadRole = {
  __typename?: 'readRole';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Returns a roster. */
export type ReadRoster = {
  __typename?: 'readRoster';
  id?: Maybe<Scalars['Guid']['output']>;
  isHoliday: Scalars['Boolean']['output'];
  lastModified: Scalars['DateTime']['output'];
  location?: Maybe<Location>;
  properties?: Maybe<Scalars['String']['output']>;
  publicationTime?: Maybe<Scalars['DateTime']['output']>;
  rosterDate?: Maybe<Scalars['DateOnly']['output']>;
  shiftOperatingHours?: Maybe<ShiftOperatingHours>;
  stations?: Maybe<Array<Maybe<RosterStation>>>;
  status: Scalars['String']['output'];
  templateId?: Maybe<Scalars['ID']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

/** Returns a staffing position that has been added to a roster. */
export type ReadRosterDayPositions = {
  __typename?: 'readRosterDayPositions';
  breaks?: Maybe<Array<Maybe<ReadRosterTimeSlots>>>;
  date?: Maybe<Scalars['DateOnly']['output']>;
  displayOrder: Scalars['Int']['output'];
  employeeId?: Maybe<Scalars['Guid']['output']>;
  end?: Maybe<Scalars['Seconds']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
  timeSlots?: Maybe<Array<Maybe<ReadRosterPositionTimeSlot>>>;
};

/** Returns roster history. */
export type ReadRosterHistory = {
  __typename?: 'readRosterHistory';
  date?: Maybe<Scalars['DateOnly']['output']>;
  history?: Maybe<Array<Maybe<ReadRosterHistoryTimeSlot>>>;
};

/** Returns roster history timeslot. */
export type ReadRosterHistoryTimeSlot = {
  __typename?: 'readRosterHistoryTimeSlot';
  end?: Maybe<Scalars['Seconds']['output']>;
  locationId: Scalars['Int']['output'];
  start?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns a time slot for a roster position. */
export type ReadRosterPositionTimeSlot = {
  __typename?: 'readRosterPositionTimeSlot';
  end?: Maybe<Scalars['Seconds']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns a staffing position that has been added to a roster. */
export type ReadRosterPositions = {
  __typename?: 'readRosterPositions';
  breaks?: Maybe<Array<Maybe<ReadRosterTimeSlots>>>;
  contractRoleId?: Maybe<Scalars['Guid']['output']>;
  displayOrder: Scalars['Int']['output'];
  employeeId?: Maybe<Scalars['Guid']['output']>;
  end?: Maybe<Scalars['Seconds']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
  templateEnd?: Maybe<Scalars['Seconds']['output']>;
  templateStart?: Maybe<Scalars['Seconds']['output']>;
  templatedContractRoleId?: Maybe<Scalars['Guid']['output']>;
  templatedEmployeeId?: Maybe<Scalars['Guid']['output']>;
  timeSlots?: Maybe<Array<Maybe<ReadRosterPositionTimeSlot>>>;
};

/** Returns roster summary. */
export type ReadRosterSummary = {
  __typename?: 'readRosterSummary';
  id?: Maybe<Scalars['Guid']['output']>;
  location?: Maybe<LocationSummary>;
  rosterDate: Scalars['DateOnly']['output'];
};

/** Returns a task that has been assigned to a station on a roster. */
export type ReadRosterTask = {
  __typename?: 'readRosterTask';
  displayOrder: Scalars['Int']['output'];
  id?: Maybe<Scalars['Guid']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  taskId: Scalars['Int']['output'];
  taskName: Scalars['String']['output'];
  taskWeight: Scalars['Int']['output'];
  timeSlots?: Maybe<Array<Maybe<ReadTaskTimeSlots>>>;
};

/** Returns a duration for a time slot. */
export type ReadRosterTimeSlots = {
  __typename?: 'readRosterTimeSlots';
  end?: Maybe<Scalars['Seconds']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns a list of all stations indicating which are selected in current roster. */
export type ReadSelectedRosterStations = {
  __typename?: 'readSelectedRosterStations';
  rosterId?: Maybe<Scalars['Guid']['output']>;
  stations?: Maybe<Array<Maybe<ReadStationSelectionGt>>>;
};

/** Returns selected template stations. */
export type ReadSelectedTemplateStations = {
  __typename?: 'readSelectedTemplateStations';
  stations?: Maybe<Array<Maybe<ReadStationSelectionGt>>>;
  templateId?: Maybe<Scalars['Guid']['output']>;
};

/** Returns settings. */
export type ReadSettings = {
  __typename?: 'readSettings';
  displayLanguage: Scalars['String']['output'];
};

/** Returns skills. */
export type ReadSkills = {
  __typename?: 'readSkills';
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['String']['output']>;
};

/** Returns a station. */
export type ReadStation = {
  __typename?: 'readStation';
  excludeHours: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** Returns task. */
export type ReadTask = {
  __typename?: 'readTask';
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  optionalSkills?: Maybe<Array<Maybe<ReadSkills>>>;
  priority?: Maybe<Scalars['Int']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Maybe<ReadSkills>>>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  stationId: Scalars['Int']['output'];
  stationName: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

/** Returns a duration for a task. */
export type ReadTaskTimeSlots = {
  __typename?: 'readTaskTimeSlots';
  end?: Maybe<Scalars['Seconds']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns a template of requirements for rosters. */
export type ReadTemplate = {
  __typename?: 'readTemplate';
  baseHours: Scalars['Float']['output'];
  baseTemplateId?: Maybe<Scalars['Guid']['output']>;
  draft?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  lastModified: Scalars['DateTime']['output'];
  location?: Maybe<Location>;
  name: Scalars['String']['output'];
  properties?: Maybe<Scalars['String']['output']>;
  shiftOperatingHours?: Maybe<ShiftOperatingHours>;
  stations?: Maybe<Array<Maybe<ReadTemplateStations>>>;
  target?: Maybe<Target>;
  templateTags?: Maybe<Array<Maybe<ReadTemplateTag>>>;
  version?: Maybe<Scalars['String']['output']>;
  weekday: Scalars['Boolean']['output'];
};

/** Returns a time slot for a template position. */
export type ReadTemplatePositionTimeSlot = {
  __typename?: 'readTemplatePositionTimeSlot';
  end?: Maybe<Scalars['Seconds']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns a station that has been assigned to a template. */
export type ReadTemplateStations = {
  __typename?: 'readTemplateStations';
  displayOrder: Scalars['Int']['output'];
  excludeHours: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Guid']['output']>;
  positions?: Maybe<Array<Maybe<ReadTemplatesPositions>>>;
  stationId: Scalars['Int']['output'];
  stationName: Scalars['String']['output'];
  tasks?: Maybe<Array<Maybe<ReadTemplateTasks>>>;
};

/** Returns template summary. */
export type ReadTemplateSummary = {
  __typename?: 'readTemplateSummary';
  id?: Maybe<Scalars['Guid']['output']>;
  location?: Maybe<LocationSummary>;
  name: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

/** Returns a template tag. */
export type ReadTemplateTag = {
  __typename?: 'readTemplateTag';
  id?: Maybe<Scalars['Guid']['output']>;
  label: Scalars['String']['output'];
};

/** Returns a task that has been assigned to a template. */
export type ReadTemplateTasks = {
  __typename?: 'readTemplateTasks';
  displayOrder: Scalars['Int']['output'];
  id?: Maybe<Scalars['Guid']['output']>;
  taskId: Scalars['Int']['output'];
  taskName: Scalars['String']['output'];
  timeSlots?: Maybe<Array<Maybe<ReadTaskTimeSlots>>>;
};

/** Returns a staffing position that has been added to a template. */
export type ReadTemplatesPositions = {
  __typename?: 'readTemplatesPositions';
  breaks?: Maybe<Array<Maybe<ReadTaskTimeSlots>>>;
  contractRoleId?: Maybe<Scalars['Guid']['output']>;
  displayOrder: Scalars['Int']['output'];
  employeeId?: Maybe<Scalars['Guid']['output']>;
  end?: Maybe<Scalars['Seconds']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
  timeSlots?: Maybe<Array<Maybe<ReadTemplatePositionTimeSlot>>>;
};

/** Updates an employee assignment for a staffing position on a roster. */
export type ReassignEmployeeToRosterPositions = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  stationId: Scalars['Int']['input'];
  timeSlots?: InputMaybe<Array<InputMaybe<SetRosterTimeSlot>>>;
};

/** Remove an entity from a roster. */
export type RemoveFromRoster = {
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  stationId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Removes an entity from a template. */
export type RemoveFromTemplate = {
  stationId?: InputMaybe<Scalars['Guid']['input']>;
  templateId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Returns rosters within a date range for a location. */
export type RestaurantAndDateRange = {
  dateRangeEnd?: InputMaybe<Scalars['DateOnly']['input']>;
  dateRangeStart?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Returns roster properties. */
export type RosterProperties = {
  __typename?: 'rosterProperties';
  id?: Maybe<Scalars['Guid']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
};

/** Returns a station that has been assigned to a roster. */
export type RosterStation = {
  __typename?: 'rosterStation';
  displayOrder: Scalars['Int']['output'];
  excludeHours: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Guid']['output']>;
  positions?: Maybe<Array<Maybe<ReadRosterPositions>>>;
  stationId: Scalars['Int']['output'];
  stationName: Scalars['String']['output'];
  tasks?: Maybe<Array<Maybe<ReadRosterTask>>>;
};

/** Updates a task for a station on a roster. */
export type RosterStationTask = {
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  rosterStationTaskId?: InputMaybe<Scalars['Guid']['input']>;
  taskId: Scalars['Int']['input'];
};

/** Returns a roster status. */
export type RosterStatus = {
  __typename?: 'rosterStatus';
  locationId: Scalars['Int']['output'];
  rosterDate: Scalars['DateOnly']['output'];
  rosterId?: Maybe<Scalars['Guid']['output']>;
  status: Scalars['String']['output'];
};

/** Returns roster statuses based on given location IDs and date range. */
export type RosterStatuses = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Returns a rostered employee Id and dates. */
export type RosteredEmployeeIdAndDates = {
  __typename?: 'rosteredEmployeeIdAndDates';
  dates: Array<Maybe<Scalars['DateOnly']['output']>>;
  identityId?: Maybe<Scalars['Guid']['output']>;
};

/** Returns a rostered employee Id and schedule. */
export type RosteredEmployeeIdAndSchedule = {
  __typename?: 'rosteredEmployeeIdAndSchedule';
  breaks?: Maybe<Array<Maybe<ReadRosterTimeSlots>>>;
  date: Scalars['DateOnly']['output'];
  end?: Maybe<Scalars['Seconds']['output']>;
  identityId?: Maybe<Scalars['Guid']['output']>;
  properties?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
  timeSlots?: Maybe<Array<Maybe<ReadRosterPositionTimeSlot>>>;
};

/** Returns rostered staff where the roster date is after the their leave date. */
export type RosteredStaffAfterLeaveDate = {
  dateRangeEnd?: InputMaybe<Scalars['DateOnly']['input']>;
  dateRangeStart?: InputMaybe<Scalars['DateOnly']['input']>;
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Searchs availabilities. */
export type SearchAvailabilities = {
  contractTypeId?: InputMaybe<Scalars['Seconds']['input']>;
  day?: InputMaybe<Scalars['DateOnly']['input']>;
  end?: InputMaybe<Scalars['Seconds']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
  targetLocationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Sends welcome notification for the employee. */
export type SendWelcomeInfo = {
  appUrl: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  sendToId: Scalars['ID']['input'];
  tenantId: Scalars['String']['input'];
};

/** Sets break offsets. */
export type SetBreakOffsets = {
  timeOffsetAfterLastBreak?: InputMaybe<Scalars['Seconds']['input']>;
  timeOffsetBeforeFirstBreak?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Sets division node. */
export type SetDivision = {
  children?: InputMaybe<Array<InputMaybe<SetDivision>>>;
  divisionId?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  locations?: InputMaybe<Array<InputMaybe<SetDivisionLocation>>>;
  name: Scalars['String']['input'];
};

/** Sets a location to division. */
export type SetDivisionLocation = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

/** Sets position properties. */
export type SetPositionProperties = {
  id?: InputMaybe<Scalars['Guid']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** Updates roster breaks in a position. */
export type SetRosterPositionBreaks = {
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  rosterPositionId?: InputMaybe<Scalars['Guid']['input']>;
  timeSlots?: InputMaybe<Array<InputMaybe<SetRosterTimeSlot>>>;
};

/** Sets roster properties. */
export type SetRosterProperties = {
  id?: InputMaybe<Scalars['Guid']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** Updates the stations assigned to a roster. */
export type SetRosterStations = {
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  stations?: InputMaybe<Array<InputMaybe<UpdateStationSelectionGt>>>;
};

/** Assign a duration for a staffing position on a roster. */
export type SetRosterTaskTimeSlot = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  rosterPositionId?: InputMaybe<Scalars['Guid']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates a duration for a break. */
export type SetRosterTimeSlot = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Sets breaks in a position. */
export type SetTemplatePositionBreaks = {
  templateId?: InputMaybe<Scalars['Guid']['input']>;
  templatePositionId?: InputMaybe<Scalars['Guid']['input']>;
  timeSlots?: InputMaybe<Array<InputMaybe<SetTemplateTimeSlot>>>;
};

/** Sets template properties. */
export type SetTemplatePositionProperties = {
  id?: InputMaybe<Scalars['Guid']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** Time slot to be assigned on a template. */
export type SetTemplateTaskTimeSlot = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
  templateId?: InputMaybe<Scalars['Guid']['input']>;
  templatePositionId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Sets time slot on a template. Duration for a break. */
export type SetTemplateTimeSlot = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Returns a shift. */
export type Shift = {
  __typename?: 'shift';
  breaks?: Maybe<Array<Maybe<Break>>>;
  date: Scalars['DateOnly']['output'];
  end?: Maybe<Scalars['Seconds']['output']>;
  lastModified: Scalars['DateTime']['output'];
  location?: Maybe<Location>;
  publicationTime?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['Seconds']['output']>;
  station?: Maybe<ReadStation>;
  status: Scalars['String']['output'];
};

/** Returns a shift operating hours object. */
export type ShiftOperatingHours = {
  __typename?: 'shiftOperatingHours';
  closeTime?: Maybe<Scalars['Seconds']['output']>;
  endTime?: Maybe<Scalars['Seconds']['output']>;
  openTime?: Maybe<Scalars['Seconds']['output']>;
  startTime?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns a shift operating hours of the day. */
export type ShiftOperatingHoursDay = {
  __typename?: 'shiftOperatingHoursDay';
  closeTime?: Maybe<Scalars['Seconds']['output']>;
  date?: Maybe<Scalars['DateOnly']['output']>;
  endTime?: Maybe<Scalars['Seconds']['output']>;
  openTime?: Maybe<Scalars['Seconds']['output']>;
  startTime?: Maybe<Scalars['Seconds']['output']>;
};

/** Returns a list of shifts. */
export type Shifts = {
  __typename?: 'shifts';
  identityId?: Maybe<Scalars['Guid']['output']>;
  shifts?: Maybe<Array<Maybe<Shift>>>;
};

/** Returns target. */
export type Target = {
  __typename?: 'target';
  type: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/** Returns targets based on given location IDs and date range. */
export type TargetsByLocationIds = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** A task to be updated for a station on a template. */
export type TemplateStationTask = {
  taskId: Scalars['Int']['input'];
  templateId?: InputMaybe<Scalars['Guid']['input']>;
  templateStationTaskId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Returns the current tenant. */
export type Tenant = {
  __typename?: 'tenant';
  id?: Maybe<Scalars['Guid']['output']>;
  name: Scalars['String']['output'];
};

/** Updates availability. */
export type UpdateAvailability = {
  day?: InputMaybe<Scalars['DateOnly']['input']>;
  end?: InputMaybe<Scalars['Seconds']['input']>;
  id?: InputMaybe<Scalars['Guid']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates an availability exception to be approved or rejected. */
export type UpdateAvailabilityException = {
  date?: InputMaybe<Scalars['DateOnly']['input']>;
  employeeId: Scalars['ID']['input'];
};

/** Updates availability exceptions. */
export type UpdateAvailabilityExceptions = {
  date: Scalars['DateOnly']['input'];
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  end?: InputMaybe<Scalars['Seconds']['input']>;
  leaveTypeId?: InputMaybe<Scalars['Guid']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates availability exceptions in the date range. */
export type UpdateAvailabilityExceptionsInDateRange = {
  employeeExceptions?: InputMaybe<Array<InputMaybe<UpdateEmployeeExceptions>>>;
  end: Scalars['DateOnly']['input'];
  start: Scalars['DateOnly']['input'];
};

/** Updates an existing contract. */
export type UpdateContract = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  earliestStartTime?: InputMaybe<Scalars['Seconds']['input']>;
  id: Scalars['ID']['input'];
  latestEndTime?: InputMaybe<Scalars['Seconds']['input']>;
  maxConsecutiveDays?: InputMaybe<Scalars['Int']['input']>;
  maxDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  maxHoursPerDay?: InputMaybe<Scalars['Float']['input']>;
  maxHoursPerShift?: InputMaybe<Scalars['Float']['input']>;
  maxHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  minHoursPerDay?: InputMaybe<Scalars['Float']['input']>;
  minHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overtimeAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  workRuleName?: InputMaybe<Scalars['String']['input']>;
  workRuleType?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a contract role. */
export type UpdateContractRole = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Guid']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** Updates contract roles. */
export type UpdateContractRoles = {
  contractTypeId: Scalars['ID']['input'];
  roles?: InputMaybe<Array<InputMaybe<UpdateContractRole>>>;
};

/** Updates a device. */
export type UpdateDevice = {
  id: Scalars['ID']['input'];
  locationId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

/** Updates an employee. */
export type UpdateEmployee = {
  contractModification?: InputMaybe<Scalars['Int']['input']>;
  contractRoleId?: InputMaybe<Scalars['ID']['input']>;
  contractTypeId?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['DateOnly']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endOfProbationDate?: InputMaybe<Scalars['DateOnly']['input']>;
  firstName: Scalars['String']['input'];
  hireDate?: InputMaybe<Scalars['DateOnly']['input']>;
  homeLocationId?: InputMaybe<Scalars['Int']['input']>;
  identityId?: InputMaybe<Scalars['Guid']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isRosterable?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  leaveDate?: InputMaybe<Scalars['DateOnly']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  personaIds?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** Updates employee's availability exceptions. */
export type UpdateEmployeeExceptions = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  exceptions?: InputMaybe<Array<InputMaybe<UpdateAvailabilityExceptionDetail>>>;
};

/** Updates locations for an employee. */
export type UpdateEmployeeLocations = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Updates employees skills. */
export type UpdateEmployeeSkills = {
  rating: Scalars['Int']['input'];
  skillId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Updates employee's skills. */
export type UpdateEmployeeSkillsByEmployeeIdAndSkills = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  skills?: InputMaybe<Array<InputMaybe<UpdateEmployeeSkills>>>;
};

/** Updates work rules constrains for the employee. */
export type UpdateEmployeeWorkRules = {
  identityId?: InputMaybe<Scalars['Guid']['input']>;
  maxDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  maxHoursPerMonth?: InputMaybe<Scalars['Float']['input']>;
  maxHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  maxNumOfConsecutiveDays: Scalars['Int']['input'];
  minHoursPerMonth?: InputMaybe<Scalars['Float']['input']>;
  minHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  totalNumberOfWorkDaysInMonth: Scalars['Int']['input'];
};

/** Updates working patterns of mutliple employees. */
export type UpdateEmployeeWorkingPatterns = {
  employeeId: Scalars['ID']['input'];
  patterns?: InputMaybe<Array<InputMaybe<WorkingPatternDayInput>>>;
  workRules?: InputMaybe<UpdateMyWorkRules>;
};

/** Updates leave type. */
export type UpdateLeaveType = {
  active: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Guid']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a location. */
export type UpdateLocation = {
  active: Scalars['Boolean']['input'];
  address?: InputMaybe<AddressInput>;
  divisionId?: InputMaybe<Scalars['ID']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  holidayRegionCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** Updates location coordinates. */
export type UpdateLocationCoordinates = {
  id?: InputMaybe<Scalars['Guid']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locationId: Scalars['Int']['input'];
  locationName: Scalars['String']['input'];
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

/** Updates a location-scoped holiday. */
export type UpdateLocationHoliday = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  date: Scalars['DateOnly']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

/** Updates operating hours for location. */
export type UpdateLocationOperatingHours = {
  closeTime?: InputMaybe<Scalars['Seconds']['input']>;
  dayNumber?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['Seconds']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  locationId: Scalars['Int']['input'];
  openTime?: InputMaybe<Scalars['Seconds']['input']>;
  startTime?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates work rules constrains for the employee. */
export type UpdateMyWorkRules = {
  maxDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  maxHoursPerMonth?: InputMaybe<Scalars['Float']['input']>;
  maxHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  maxNumOfConsecutiveDays: Scalars['Int']['input'];
  minHoursPerMonth?: InputMaybe<Scalars['Float']['input']>;
  minHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  totalNumberOfWorkDaysInMonth: Scalars['Int']['input'];
};

/** Updates notification. */
export type UpdateNotification = {
  date?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
  triggerType: Scalars['Int']['input'];
  value: Scalars['Boolean']['input'];
};

/** Updates operating hours exception. */
export type UpdateOperatingHoursException = {
  closeTime?: InputMaybe<Scalars['Seconds']['input']>;
  closed: Scalars['Boolean']['input'];
  date?: InputMaybe<Scalars['DateOnly']['input']>;
  endTime?: InputMaybe<Scalars['Seconds']['input']>;
  locationId: Scalars['Int']['input'];
  openTime?: InputMaybe<Scalars['Seconds']['input']>;
  startTime?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates an organisation's operating hours. */
export type UpdateOrgOperatingHours = {
  closeTime?: InputMaybe<Scalars['Seconds']['input']>;
  dayNumber?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['Seconds']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  openTime?: InputMaybe<Scalars['Seconds']['input']>;
  startTime?: InputMaybe<Scalars['Seconds']['input']>;
};

/** details of a persona. */
export type UpdatePersona = {
  adminControlled?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Guid']['input']>;
  management?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
  templateLibrarian?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Updates a roster. */
export type UpdateRoster = {
  id?: InputMaybe<Scalars['Guid']['input']>;
  locationId: Scalars['Int']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
  rosterDate: Scalars['DateOnly']['input'];
  shiftOperatingHours?: InputMaybe<UpdateShiftOperatingHours>;
  stations?: InputMaybe<Array<InputMaybe<UpdateRosterStation>>>;
  status: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Updates Roster position. */
export type UpdateRosterPosition = {
  breaks?: InputMaybe<Array<InputMaybe<UpdateRosterPositionBreak>>>;
  contractRoleId?: InputMaybe<Scalars['Guid']['input']>;
  displayOrder: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  end?: InputMaybe<Scalars['Seconds']['input']>;
  id?: InputMaybe<Scalars['Guid']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
  templatedContractRoleId?: InputMaybe<Scalars['Guid']['input']>;
  templatedEmployeeId?: InputMaybe<Scalars['Guid']['input']>;
  timeSlots?: InputMaybe<Array<InputMaybe<UpdateRosterPositionTimeSlot>>>;
};

/** Updates Roster position break. */
export type UpdateRosterPositionBreak = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  id?: InputMaybe<Scalars['Guid']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates Roster position time slot. */
export type UpdateRosterPositionTimeSlot = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  id?: InputMaybe<Scalars['Guid']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates Roster station. */
export type UpdateRosterStation = {
  displayOrder: Scalars['Int']['input'];
  excludeHours: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Guid']['input']>;
  positions?: InputMaybe<Array<InputMaybe<UpdateRosterPosition>>>;
  stationId: Scalars['Int']['input'];
  tasks?: InputMaybe<Array<InputMaybe<UpdateRosterTask>>>;
};

/** Updates roster status. */
export type UpdateRosterStatus = {
  rosterId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

/** Updates the status of rosters. */
export type UpdateRosterStatuses = {
  rosterIds?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
  status: Scalars['String']['input'];
};

/** Updates Roster task. */
export type UpdateRosterTask = {
  displayOrder: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Guid']['input']>;
  timeSlots?: InputMaybe<Array<InputMaybe<UpdateRosterTaskTimeSlot>>>;
};

/** Updates new details for a time slot. */
export type UpdateRosterTaskTimeSlot = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  rosterId?: InputMaybe<Scalars['Guid']['input']>;
  rosterTimeSlotId?: InputMaybe<Scalars['Guid']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates settings. */
export type UpdateSettings = {
  displayLanguage: Scalars['String']['input'];
};

/** Updates a shift operating hours object. */
export type UpdateShiftOperatingHours = {
  closeTime?: InputMaybe<Scalars['Seconds']['input']>;
  endTime?: InputMaybe<Scalars['Seconds']['input']>;
  openTime?: InputMaybe<Scalars['Seconds']['input']>;
  startTime?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates skill. */
export type UpdateSkill = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a station. */
export type UpdateStation = {
  excludeHours: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

/** Updates target. */
export type UpdateTarget = {
  id?: InputMaybe<Scalars['Guid']['input']>;
  value: Scalars['Float']['input'];
};

/** Updates target by value. */
export type UpdateTargetByValue = {
  date?: InputMaybe<Scalars['DateOnly']['input']>;
  locationId: Scalars['Int']['input'];
  targetType: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

/** Updates task. */
export type UpdateTask = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  optionalSkills?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['Guid']['input']>>>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  stationId: Scalars['Int']['input'];
};

/** Updates template. */
export type UpdateTemplate = {
  baseTemplateId?: InputMaybe<Scalars['Guid']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Guid']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  properties?: InputMaybe<Scalars['String']['input']>;
  shiftOperatingHours?: InputMaybe<UpdateShiftOperatingHours>;
  stations?: InputMaybe<Array<InputMaybe<UpdateTemplateStation>>>;
  targetType: Scalars['String']['input'];
  targetValue: Scalars['Int']['input'];
  templateTags?: InputMaybe<Array<InputMaybe<UpdateTemplateTag>>>;
  version?: InputMaybe<Scalars['String']['input']>;
  weekday: Scalars['Boolean']['input'];
};

/** Updates template base hours. */
export type UpdateTemplateBaseHours = {
  baseHours: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['Guid']['input']>;
};

/** Updates template name. */
export type UpdateTemplateName = {
  id?: InputMaybe<Scalars['Guid']['input']>;
  name: Scalars['String']['input'];
};

/** Updates template position. */
export type UpdateTemplatePosition = {
  breaks?: InputMaybe<Array<InputMaybe<UpdateTemplatePositionBreak>>>;
  contractRoleId?: InputMaybe<Scalars['Guid']['input']>;
  displayOrder: Scalars['Int']['input'];
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  end?: InputMaybe<Scalars['Seconds']['input']>;
  id?: InputMaybe<Scalars['Guid']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
  timeSlots?: InputMaybe<Array<InputMaybe<UpdateTemplatePositionTimeSlot>>>;
};

/** Updates template position break. */
export type UpdateTemplatePositionBreak = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  id?: InputMaybe<Scalars['Guid']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates template position time slot. */
export type UpdateTemplatePositionTimeSlot = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  id?: InputMaybe<Scalars['Guid']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates template station. */
export type UpdateTemplateStation = {
  displayOrder: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Guid']['input']>;
  positions?: InputMaybe<Array<InputMaybe<UpdateTemplatePosition>>>;
  stationId: Scalars['Int']['input'];
  tasks?: InputMaybe<Array<InputMaybe<UpdateTemplateTask>>>;
};

/** Sets stations on a template. */
export type UpdateTemplateStations = {
  stations?: InputMaybe<Array<InputMaybe<UpdateStationSelectionGt>>>;
  templateId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Updates templateTag. */
export type UpdateTemplateTag = {
  label: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

/** Updates template target. */
export type UpdateTemplateTarget = {
  id?: InputMaybe<Scalars['Guid']['input']>;
  targetType: Scalars['String']['input'];
  targetValue: Scalars['Int']['input'];
};

/** Updates template task. */
export type UpdateTemplateTask = {
  displayOrder: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Guid']['input']>;
  timeSlots?: InputMaybe<Array<InputMaybe<UpdateTemplateTaskTimeSlot>>>;
};

/** Updates task time slot on a template. */
export type UpdateTemplateTaskTimeSlot = {
  end?: InputMaybe<Scalars['Seconds']['input']>;
  start?: InputMaybe<Scalars['Seconds']['input']>;
  templateId?: InputMaybe<Scalars['Guid']['input']>;
  templateTimeSlotId?: InputMaybe<Scalars['Guid']['input']>;
};

/** Updates template weekday. */
export type UpdateTemplateWeekday = {
  id?: InputMaybe<Scalars['Guid']['input']>;
  weekday: Scalars['Boolean']['input'];
};

/** Updates work rules constrains for the employees. */
export type UpdateWorkRules = {
  employeeWorkRules?: InputMaybe<Array<InputMaybe<UpdateEmployeeWorkRules>>>;
};

/** Updates a list of working patterns. */
export type UpdateWorkingPattern = {
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  patterns?: InputMaybe<Array<InputMaybe<WorkingPatternDayInput>>>;
  workRules?: InputMaybe<UpdateMyWorkRules>;
};

/** Updates a day's working pattern. */
export type UpdateWorkingPatternDay = {
  dayNumber?: InputMaybe<Scalars['Int']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateOnly']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateOnly']['input']>;
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  endTime?: InputMaybe<Scalars['Seconds']['input']>;
  id?: InputMaybe<Scalars['Guid']['input']>;
  startTime?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Updates working patterns of mutliple employees. */
export type UpdateWorkingPatterns = {
  employeePatterns?: InputMaybe<Array<InputMaybe<UpdateEmployeeWorkingPatterns>>>;
};

/** Returns vacant shifts of the location. */
export type VacantShiftsInDateRange = {
  end?: InputMaybe<Scalars['DateOnly']['input']>;
  homeLocationId: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['DateOnly']['input']>;
};

/** Approval or rejection of a working pattern. */
export type WorkingPatternApprovalRejection = {
  approvedBy?: InputMaybe<Scalars['Guid']['input']>;
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
  periodId?: InputMaybe<Scalars['Int']['input']>;
  statusNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** Returns a day's working pattern for an employee. */
export type WorkingPatternDay = {
  __typename?: 'workingPatternDay';
  day: Scalars['String']['output'];
  dayNumber?: Maybe<Scalars['Int']['output']>;
  effectiveFrom?: Maybe<Scalars['DateOnly']['output']>;
  effectiveTo?: Maybe<Scalars['DateOnly']['output']>;
  endTime?: Maybe<Scalars['Seconds']['output']>;
  id?: Maybe<Scalars['Guid']['output']>;
  slotNumber?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['Seconds']['output']>;
  state: Scalars['String']['output'];
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

/** Updates a day's working pattern for an employee. */
export type WorkingPatternDayInput = {
  dayNumber?: InputMaybe<Scalars['Int']['input']>;
  effectiveFrom?: InputMaybe<Scalars['DateOnly']['input']>;
  effectiveTo?: InputMaybe<Scalars['DateOnly']['input']>;
  endTime?: InputMaybe<Scalars['Seconds']['input']>;
  slotNumber?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Seconds']['input']>;
};

/** Returns a list of working patterns for a period. */
export type WorkingPatternPeriod = {
  __typename?: 'workingPatternPeriod';
  patterns?: Maybe<Array<Maybe<WorkingPatternDay>>>;
  workRules?: Maybe<MyConstraints>;
};

/** Returns a list of working patterns for periods. */
export type WorkingPatternPeriods = {
  __typename?: 'workingPatternPeriods';
  periods?: Maybe<Array<Maybe<WorkingPatternPeriod>>>;
};

export type GetDevicesForLocationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDevicesForLocationQuery = { __typename?: 'RosteringQuery', devicesForLocation?: Array<{ __typename?: 'device', id: string, name: string, activated: boolean }> };

export type GetDeviceByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Guid']['input']>;
}>;


export type GetDeviceByIdQuery = { __typename?: 'RosteringQuery', device?: { __typename?: 'device', id: string, name: string, activationId?: string, activationToken?: string, activated: boolean } };

export type CreateDeviceMutationVariables = Exact<{
  args: CreateDevice;
}>;


export type CreateDeviceMutation = { __typename?: 'RosteringMutation', createDevice?: { __typename?: 'device', id: string, name: string } };

export type UpdateDeviceMutationVariables = Exact<{
  args: UpdateDevice;
}>;


export type UpdateDeviceMutation = { __typename?: 'RosteringMutation', updateDevice?: { __typename?: 'device', id: string } };

export type DeleteDeviceMutationVariables = Exact<{
  id: Scalars['Guid']['input'];
}>;


export type DeleteDeviceMutation = { __typename?: 'RosteringMutation', deleteDevice?: { __typename?: 'device', id: string } };

export type ResetDeviceMutationVariables = Exact<{
  id: Scalars['Guid']['input'];
}>;


export type ResetDeviceMutation = { __typename?: 'RosteringMutation', resetDevice?: { __typename?: 'device', id: string } };

export type DeleteLocationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteLocationMutation = { __typename?: 'RosteringMutation', deleteLocation?: { __typename?: 'location', id: number } };

export type GetPolicyAcceptanceDatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPolicyAcceptanceDatesQuery = { __typename?: 'RosteringQuery', myEmployee?: { __typename?: 'readEmployee', acceptedPrivacyPolicy?: any, acceptedTermsAndConditions?: any } };

export type GetAllMyShiftsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMyShiftsQuery = { __typename?: 'RosteringQuery', getAllMyWorkTimeRecord?: Array<{ __typename?: 'WorkTimeRecord', risk?: WorkTimeDataRisk, start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } }, end?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } } }> };

export type GetMyPersonalInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyPersonalInfoQuery = { __typename?: 'RosteringQuery', gdpr_myPersonalInfo?: { __typename?: 'gdpr_readEmployee', acceptedPrivacyPolicy?: any, acceptedTermsAndConditions?: any, userName: string, employeeLocations?: Array<string>, displayLanguage?: string, contractModification?: number, roleId?: number, firstName: string, lastName?: string, email?: string, identityId?: any, title?: string, role: string, employeeId?: string, isRosterable?: boolean, phoneNumber?: string, employeeSkills?: Array<{ __typename?: 'gdpr_readEmployeeSkill', rating: number, taskName: string }>, workingPattern?: { __typename?: 'GDPR_WorkingPatternGT', workingPattern?: Array<{ __typename?: 'gdpr_workingPatternDay', startTime?: any, endTime?: any, day: string, dayOfWeek?: number, dayNumber?: number, available: boolean, state: string, updatedOn?: any, approvedOn?: any }> }, availabilities?: Array<{ __typename?: 'gdpr_readAvailability', day?: any, start?: any, end?: any }>, availabilityExceptions?: Array<{ __typename?: 'gdpr_availabilityException', date: any, start?: any, end?: any, available: boolean, approval: string, approvedOn?: any, updatedOn?: any }>, locations?: Array<{ __typename?: 'location', name: string, locationCoordinates?: Array<{ __typename?: 'locationCoordinates', latitude?: number, longitude?: number }> }>, contract?: { __typename?: 'employeeContract', contractTypeId?: string, contractTypeName?: string, contractModificationName: string, contractModificationId: number } } };

export type GetShiftsListQueryVariables = Exact<{
  queryWorkItemArgs?: InputMaybe<GetWorkTimeRecordsInRangeGt>;
}>;


export type GetShiftsListQuery = { __typename?: 'RosteringQuery', getWorkTimeRecord?: Array<{ __typename?: 'employeeWorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk, employee?: { __typename?: 'readEmployee', identityId?: any, firstName: string, lastName?: string, isDeleted?: boolean, isDeactivated?: boolean }, start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', longitude: number, latitude: number }, device?: { __typename?: 'device', id: string, name: string } }, end?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', longitude: number, latitude: number }, device?: { __typename?: 'device', id: string, name: string } } }> };

export type GetMyShiftsListQueryVariables = Exact<{
  queryWorkItemArgs?: InputMaybe<GetMyWorkTimeRecordsInRangeGt>;
}>;


export type GetMyShiftsListQuery = { __typename?: 'RosteringQuery', getMyWorkTimeRecord?: Array<{ __typename?: 'employeeWorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk, employee?: { __typename?: 'readEmployee', identityId?: any, firstName: string, lastName?: string, isDeleted?: boolean, isDeactivated?: boolean }, start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', longitude: number, latitude: number }, device?: { __typename?: 'device', id: string, name: string } }, end?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', longitude: number, latitude: number }, device?: { __typename?: 'device', id: string, name: string } } }> };

export type UpdateShiftMutationVariables = Exact<{
  change: CreateWorkTimeRecordChange;
}>;


export type UpdateShiftMutation = { __typename?: 'RosteringMutation', updateWorkTimeRecord?: { __typename?: 'WorkTimeRecord', id?: any, risk?: WorkTimeDataRisk, start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', longitude: number, latitude: number }, device?: { __typename?: 'device', id: string, name: string } }, end?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', longitude: number, latitude: number }, device?: { __typename?: 'device', id: string, name: string } } } };

export type UpdateMyShiftMutationVariables = Exact<{
  change: CreateWorkTimeRecordChange;
}>;


export type UpdateMyShiftMutation = { __typename?: 'RosteringMutation', updateMyWorkTimeRecord?: { __typename?: 'WorkTimeRecord', id?: any, risk?: WorkTimeDataRisk, start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', longitude: number, latitude: number }, device?: { __typename?: 'device', id: string, name: string } }, end?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', longitude: number, latitude: number }, device?: { __typename?: 'device', id: string, name: string } } } };

export type BasicFragment = { __typename?: 'WorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk };

export type StartFragment = { __typename?: 'WorkTimeRecord', start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } } };

export type EndFragment = { __typename?: 'WorkTimeRecord', end?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } } };

export type BasicEFragment = { __typename?: 'employeeWorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk };

export type StartEFragment = { __typename?: 'employeeWorkTimeRecord', start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } } };

export type EndEFragment = { __typename?: 'employeeWorkTimeRecord', end?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } } };

export type GetCurrentWorkStatusForEmployeeQueryVariables = Exact<{
  employeeId?: InputMaybe<Scalars['Guid']['input']>;
}>;


export type GetCurrentWorkStatusForEmployeeQuery = { __typename?: 'RosteringQuery', getOpenWorkTimeRecord?: Array<{ __typename?: 'employeeWorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk, start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } } }> };

export type GetMyCurrentWorkStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCurrentWorkStatusQuery = { __typename?: 'RosteringQuery', getMyOpenWorkTimeRecord?: Array<{ __typename?: 'employeeWorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk, start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } }, end?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } } }> };

export type StartMyWorkTimeRecordMutationVariables = Exact<{
  workTimeRecordStart: StartMyWorkTimeRecord;
}>;


export type StartMyWorkTimeRecordMutation = { __typename?: 'RosteringMutation', startMyWorkTimeRecord?: { __typename?: 'WorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk, start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } } } };

export type EndMyWorkTimeRecordMutationVariables = Exact<{
  workTimeRecordEnd: EndMyWorkTimeRecord;
}>;


export type EndMyWorkTimeRecordMutation = { __typename?: 'RosteringMutation', endMyWorkTimeRecord?: { __typename?: 'WorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk, end?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } } } };

export type StartWorkTimeRecordMutationVariables = Exact<{
  workTimeRecordStart: StartWorkTimeRecord;
}>;


export type StartWorkTimeRecordMutation = { __typename?: 'RosteringMutation', startWorkTimeRecord?: { __typename?: 'WorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk, start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } } } };

export type EndWorkTimeRecordMutationVariables = Exact<{
  workTimeRecordEnd: EndWorkTimeRecord;
}>;


export type EndWorkTimeRecordMutation = { __typename?: 'RosteringMutation', endWorkTimeRecord?: { __typename?: 'WorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk, end?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', latitude: number, longitude: number } } } };

export type GetOpenWorkRecordsQueryVariables = Exact<{
  args?: InputMaybe<GetWorkTimeRecordsGt>;
}>;


export type GetOpenWorkRecordsQuery = { __typename?: 'RosteringQuery', getOpenWorkTimeRecord?: Array<{ __typename?: 'employeeWorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk, employee?: { __typename?: 'readEmployee', identityId?: any, firstName: string, lastName?: string }, start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', longitude: number, latitude: number } } }> };

export type GetMyOpenWorkRecordsQueryVariables = Exact<{
  args?: InputMaybe<GetMyWorkTimeRecordsGt>;
}>;


export type GetMyOpenWorkRecordsQuery = { __typename?: 'RosteringQuery', getMyOpenWorkTimeRecord?: Array<{ __typename?: 'employeeWorkTimeRecord', id?: any, locationId: number, risk?: WorkTimeDataRisk, employee?: { __typename?: 'readEmployee', identityId?: any, firstName: string, lastName?: string }, start?: { __typename?: 'WorkTimeOrigin', dateTime?: any, origin?: WorkTimeDataSource, geoLocation?: { __typename?: 'GeoLocation', longitude: number, latitude: number } } }> };

export type MyAvailabilityExceptionsQueryVariables = Exact<{
  dateRange?: InputMaybe<MyAvailabilityExceptionsDateRange>;
}>;


export type MyAvailabilityExceptionsQuery = { __typename?: 'RosteringQuery', myAvailabilityExceptions?: { __typename?: 'availabilityExceptions', exceptions?: Array<{ __typename?: 'availabilityException', available: boolean, approval: string, date?: any, start?: any, end?: any, updatedOn?: any, leaveType?: { __typename?: 'readLeaveType', id?: any, name: string, active: boolean, properties?: string } }> } };

export type AvailabilityExceptionsForEmployeeQueryVariables = Exact<{
  userId: Scalars['Guid']['input'];
  startDate: Scalars['DateOnly']['input'];
  endDate: Scalars['DateOnly']['input'];
}>;


export type AvailabilityExceptionsForEmployeeQuery = { __typename?: 'RosteringQuery', availabilityExceptions?: Array<{ __typename?: 'availabilityException', available: boolean, approval: string, date?: any, start?: any, end?: any, updatedOn?: any, leaveType?: { __typename?: 'readLeaveType', id?: any, name: string, active: boolean, properties?: string } }> };

export type UpdateAvailabilityExceptionsMutationVariables = Exact<{
  exceptions: UpdateAvailabilityExceptionsInDateRange;
}>;


export type UpdateAvailabilityExceptionsMutation = { __typename?: 'RosteringMutation', updateAvailabilityExceptionsInDateRange?: Array<{ __typename?: 'availabilityException', id?: any, employeeId?: any, date?: any, available: boolean, start?: any, end?: any, approval: string }> };

export type EmployeeWorkingPatternQueryVariables = Exact<{
  date?: InputMaybe<Scalars['DateOnly']['input']>;
}>;


export type EmployeeWorkingPatternQuery = { __typename?: 'RosteringQuery', employeeWorkingPatterns?: { __typename?: 'workingPatternPeriods', periods?: Array<{ __typename?: 'workingPatternPeriod', patterns?: Array<{ __typename?: 'workingPatternDay', id?: any, startTime?: any, endTime?: any, slotNumber?: number, dayNumber?: number, day: string }> }> } };

export type ApproveAndApplyAvailabilitiesMutationVariables = Exact<{
  applyAvailabilities: ApplyAvailabilities;
}>;


export type ApproveAndApplyAvailabilitiesMutation = { __typename?: 'RosteringMutation', approveAndApplyAvailabilities?: boolean };

export type LocationWorkingPatternsQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  date?: InputMaybe<Scalars['DateOnly']['input']>;
}>;


export type LocationWorkingPatternsQuery = { __typename?: 'RosteringQuery', locationWorkingPatterns?: { __typename?: 'locationWorkingPattern', employeePatterns?: Array<{ __typename?: 'employeePattern', identityId?: any, periods?: Array<{ __typename?: 'workingPatternPeriod', patterns?: Array<{ __typename?: 'workingPatternDay', id?: any, startTime?: any, endTime?: any, slotNumber?: number, dayNumber?: number, day: string }> }> }> } };

export type LocationExceptionsQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  startDate: Scalars['DateOnly']['input'];
  endDate: Scalars['DateOnly']['input'];
}>;


export type LocationExceptionsQuery = { __typename?: 'RosteringQuery', locationAvailabilityExceptions?: { __typename?: 'locationAvailabilityExceptions', employeeAvailabilityExceptions?: Array<{ __typename?: 'employeeAvailabilityExceptions', employeeId?: any, patternsAndExceptions?: Array<{ __typename?: 'patternsAndExceptions', patterns?: Array<{ __typename?: 'workingPatternDay', id?: any, startTime?: any, endTime?: any, slotNumber?: number, dayNumber?: number, day: string }>, exceptions?: Array<{ __typename?: 'availabilityException', available: boolean, approval: string, date?: any, start?: any, end?: any, updatedOn?: any, leaveType?: { __typename?: 'readLeaveType', id?: any, name: string, active: boolean, properties?: string } }> }> }> } };

export type SearchAvailabilitiesQueryVariables = Exact<{
  search: SearchAvailabilities;
}>;


export type SearchAvailabilitiesQuery = { __typename?: 'RosteringQuery', searchAvailabilities?: Array<{ __typename?: 'availableEmployeesInLocation', location?: { __typename?: 'location', id: number, name: string, properties?: string, active: boolean, phoneNumber?: string, holidayRegionCode?: string, externalId?: string, address?: { __typename?: 'address', line1: string, line2?: string, city: string, postcode: string, country: string } }, availabilities?: Array<{ __typename?: 'readAvailability', start?: any, end?: any, employeeId?: any, firstName?: string, lastName?: string, role?: string }> }> };

export type UpdateWorkingPatternsMutationVariables = Exact<{
  workingPatterns: Array<InputMaybe<UpdateEmployeeWorkingPatterns>> | InputMaybe<UpdateEmployeeWorkingPatterns>;
}>;


export type UpdateWorkingPatternsMutation = { __typename?: 'RosteringMutation', updateWorkingPatterns?: boolean };

export type DeleteAvailabilityExceptionMutationVariables = Exact<{
  employeeId: Scalars['Guid']['input'];
  date: Scalars['DateOnly']['input'];
}>;


export type DeleteAvailabilityExceptionMutation = { __typename?: 'RosteringMutation', deleteAvailabilityExceptions?: Array<{ __typename?: 'availabilityException', id?: any }> };

export type GetContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractsQuery = { __typename?: 'RosteringQuery', readContracts?: Array<{ __typename?: 'readContractTypes', id: string, name?: string, minHoursPerDay: number, maxHoursPerDay: number, minHoursPerWeek: number, maxHoursPerWeek: number, maxDaysPerWeek: number, maxConsecutiveDays: number, earliestStartTime: any, active: boolean, latestEndTime: any, maxHoursPerShift: number, displayOrder: number, properties?: string, overtimeAllowed: boolean, roles?: Array<{ __typename?: 'readContractRole', displayOrder: number, id?: any, name: string, notes?: string, properties?: string, active: boolean }> }> };

export type GetContractQueryVariables = Exact<{
  id: Scalars['Guid']['input'];
}>;


export type GetContractQuery = { __typename?: 'RosteringQuery', readContract?: { __typename?: 'readContractTypes', id: string, name?: string, minHoursPerDay: number, maxHoursPerDay: number, minHoursPerWeek: number, maxHoursPerWeek: number, maxDaysPerWeek: number, maxConsecutiveDays: number, earliestStartTime: any, active: boolean, latestEndTime: any, maxHoursPerShift: number, displayOrder: number, properties?: string, overtimeAllowed: boolean, roles?: Array<{ __typename?: 'readContractRole', displayOrder: number, id?: any, name: string, notes?: string, properties?: string, active: boolean }> } };

export type CreateContractMutationVariables = Exact<{
  contract: CreateContract;
}>;


export type CreateContractMutation = { __typename?: 'RosteringMutation', createContract?: { __typename?: 'readContractTypes', id: string, name?: string, minHoursPerDay: number, maxHoursPerDay: number, minHoursPerWeek: number, maxHoursPerWeek: number, maxDaysPerWeek: number, maxConsecutiveDays: number, earliestStartTime: any, active: boolean, latestEndTime: any, maxHoursPerShift: number, displayOrder: number, properties?: string, overtimeAllowed: boolean, roles?: Array<{ __typename?: 'readContractRole', displayOrder: number, id?: any, name: string, notes?: string, properties?: string, active: boolean }> } };

export type UpdateContractMutationVariables = Exact<{
  contract: UpdateContract;
}>;


export type UpdateContractMutation = { __typename?: 'RosteringMutation', updateContract?: boolean };

export type DeleteContractMutationVariables = Exact<{
  id: Scalars['Guid']['input'];
}>;


export type DeleteContractMutation = { __typename?: 'RosteringMutation', deleteContract?: boolean };

export type UpdateContractRolesMutationVariables = Exact<{
  contractRoles: UpdateContractRoles;
}>;


export type UpdateContractRolesMutation = { __typename?: 'RosteringMutation', updateContractRoles?: Array<{ __typename?: 'readContractRole', displayOrder: number, id?: any, name: string, notes?: string, properties?: string, active: boolean }> };

export type GetEmployeeSummariesQueryVariables = Exact<{
  contractTypeId: Scalars['Guid']['input'];
}>;


export type GetEmployeeSummariesQuery = { __typename?: 'RosteringQuery', employeeSummariesByContractTypeId?: Array<{ __typename?: 'readEmployeeSummary', identityId?: any, employeeId?: string, firstName: string, lastName?: string, homeLocationId?: number, locations?: Array<{ __typename?: 'locationSummary', id: number, name: string }> }> };

export type GetEmployeeSummariesByContractRoleQueryVariables = Exact<{
  contractRoleId: Scalars['Guid']['input'];
}>;


export type GetEmployeeSummariesByContractRoleQuery = { __typename?: 'RosteringQuery', employeeSummariesByContractRoleId?: Array<{ __typename?: 'readEmployeeSummary', identityId?: any, employeeId?: string, firstName: string, lastName?: string, homeLocationId?: number, locations?: Array<{ __typename?: 'locationSummary', id: number, name: string }> }> };

export type GetTemplateSummaryByContractRoleQueryVariables = Exact<{
  contractRoleId: Scalars['Guid']['input'];
}>;


export type GetTemplateSummaryByContractRoleQuery = { __typename?: 'RosteringQuery', templateSummariesByContractRoleId?: Array<{ __typename?: 'readTemplateSummary', id?: any, name: string, version?: string, location?: { __typename?: 'locationSummary', id: number, name: string } }> };

export type GetEmployeesAssignedToRolesInContractQueryVariables = Exact<{
  contractId: Scalars['Guid']['input'];
}>;


export type GetEmployeesAssignedToRolesInContractQuery = { __typename?: 'RosteringQuery', employeesAssignedToRolesInContract?: Array<{ __typename?: 'readEmployee', identityId?: any, firstName: string, lastName?: string, employeeId?: string, role: string, homeLocationId?: number, contractRoleId?: any, contract?: { __typename?: 'employeeContract', contractTypeId?: string } }> };

export type PatternFragment = { __typename?: 'workingPatternDay', id?: any, startTime?: any, endTime?: any, slotNumber?: number, dayNumber?: number, day: string };

export type ExceptionFragment = { __typename?: 'availabilityException', available: boolean, approval: string, date?: any, start?: any, end?: any, updatedOn?: any, leaveType?: { __typename?: 'readLeaveType', id?: any, name: string, active: boolean, properties?: string } };

export type EmployeeContractFragment = { __typename?: 'employeeContract', contractTypeId?: string, contractTypeName?: string, contractModificationName: string, contractModificationId: number };

export type ContractRolesFragment = { __typename?: 'readContractRole', displayOrder: number, id?: any, name: string, notes?: string, properties?: string, active: boolean };

export type ContractFragment = { __typename?: 'readContractTypes', id: string, name?: string, minHoursPerDay: number, maxHoursPerDay: number, minHoursPerWeek: number, maxHoursPerWeek: number, maxDaysPerWeek: number, maxConsecutiveDays: number, earliestStartTime: any, active: boolean, latestEndTime: any, maxHoursPerShift: number, displayOrder: number, properties?: string, overtimeAllowed: boolean, roles?: Array<{ __typename?: 'readContractRole', displayOrder: number, id?: any, name: string, notes?: string, properties?: string, active: boolean }> };

export type EmployeeFragment = { __typename?: 'readEmployee', identityId?: any, employeeId?: string, firstName: string, lastName?: string, role: string, isDeleted?: boolean, isDeactivated?: boolean, isRosterable?: boolean, contractRoleId?: any, email?: string, phoneNumber?: string, homeLocationId?: number, hireDate?: any, leaveDate?: any, dateOfBirth?: any, endOfProbationDate?: any, properties?: string, avatarUrl?: string, contract?: { __typename?: 'employeeContract', contractTypeId?: string, contractTypeName?: string, contractModificationName: string, contractModificationId: number }, locations?: Array<{ __typename?: 'location', id: number, name: string }>, personas?: Array<{ __typename?: 'persona', id?: any, name: string, displayOrder?: number, management?: boolean, adminControlled?: boolean, templateLibrarian?: boolean }> };

export type LeaveTypeFragment = { __typename?: 'readLeaveType', id?: any, name: string, active: boolean, properties?: string };

export type LocationFragment = { __typename?: 'location', id: number, name: string, properties?: string, active: boolean, phoneNumber?: string, holidayRegionCode?: string, externalId?: string, address?: { __typename?: 'address', line1: string, line2?: string, city: string, postcode: string, country: string } };

export type PersonaFragment = { __typename?: 'persona', id?: any, name: string, displayOrder?: number, management?: boolean, adminControlled?: boolean, templateLibrarian?: boolean };

export type TimeSlotsPositionsFragment = { __typename?: 'readRosterPositions', timeSlots?: Array<{ __typename?: 'readRosterPositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> };

export type TimeSlotsTasksFragment = { __typename?: 'readRosterTask', timeSlots?: Array<{ __typename?: 'readTaskTimeSlots', id?: any, start?: any, end?: any }> };

export type TimeSlotsPositionFragment = { __typename?: 'rosteredEmployeeIdAndSchedule', timeSlots?: Array<{ __typename?: 'readRosterPositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> };

export type OperatingHoursFragment = { __typename?: 'readRoster', shiftOperatingHours?: { __typename?: 'shiftOperatingHours', startTime?: any, endTime?: any, openTime?: any, closeTime?: any } };

export type StationsFragment = { __typename?: 'readRoster', stations?: Array<{ __typename?: 'rosterStation', id?: any, stationId: number, stationName: string, displayOrder: number, excludeHours: boolean, positions?: Array<{ __typename?: 'readRosterPositions', id?: any, displayOrder: number, properties?: string, templatedEmployeeId?: any, employeeId?: any, contractRoleId?: any, templatedContractRoleId?: any, start?: any, end?: any, breaks?: Array<{ __typename?: 'readRosterTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readRosterPositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }>, tasks?: Array<{ __typename?: 'readRosterTask', id?: any, taskId: number, taskName: string, displayOrder: number, timeSlots?: Array<{ __typename?: 'readTaskTimeSlots', id?: any, start?: any, end?: any }> }> }> };

export type ShiftsFragment = { __typename?: 'shifts', shifts?: Array<{ __typename?: 'shift', start?: any, end?: any, status: string, location?: { __typename?: 'location', id: number, name: string } }> };

export type FoundShiftsFragment = { __typename?: 'foundShifts', shifts?: Array<{ __typename?: 'readRosterPositions', id?: any, start?: any, end?: any, properties?: string, employeeId?: any, breaks?: Array<{ __typename?: 'readRosterTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readRosterPositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }> };

export type FoundShiftsDateRangeFragment = { __typename?: 'foundShiftsInDateRange', shifts?: Array<{ __typename?: 'readRosterDayPositions', id?: any, date?: any, start?: any, end?: any, properties?: string, employeeId?: any, breaks?: Array<{ __typename?: 'readRosterTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readRosterPositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }> };

export type SkillFragment = { __typename?: 'readSkills', id: string, active?: boolean, name: string, properties?: string };

export type TaskFragment = { __typename?: 'readTask', id: number, name: string, properties?: string, active?: boolean, stationId: number, stationName: string, priority?: number, weight: number, skills?: Array<{ __typename?: 'readSkills', id: string, active?: boolean, name: string, properties?: string }> };

export type TemplateStationFragment = { __typename?: 'readTemplateStations', id?: any, stationId: number, stationName: string, displayOrder: number, positions?: Array<{ __typename?: 'readTemplatesPositions', id?: any, displayOrder: number, start?: any, end?: any, properties?: string, contractRoleId?: any, employeeId?: any, breaks?: Array<{ __typename?: 'readTaskTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readTemplatePositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }> };

export type TemplateTagFragment = { __typename?: 'readTemplateTag', id?: any, label: string };

export type TemplateFragment = { __typename?: 'readTemplate', id?: any, name: string, weekday: boolean, properties?: string, draft?: boolean, version?: string, baseTemplateId?: any, lastModified: any, target?: { __typename?: 'target', type: string, value: number }, location?: { __typename?: 'location', id: number, name: string, properties?: string, active: boolean, phoneNumber?: string, holidayRegionCode?: string, externalId?: string, address?: { __typename?: 'address', line1: string, line2?: string, city: string, postcode: string, country: string } }, shiftOperatingHours?: { __typename?: 'shiftOperatingHours', startTime?: any, endTime?: any, openTime?: any, closeTime?: any }, stations?: Array<{ __typename?: 'readTemplateStations', id?: any, stationId: number, stationName: string, displayOrder: number, positions?: Array<{ __typename?: 'readTemplatesPositions', id?: any, displayOrder: number, start?: any, end?: any, properties?: string, contractRoleId?: any, employeeId?: any, breaks?: Array<{ __typename?: 'readTaskTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readTemplatePositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }> }>, templateTags?: Array<{ __typename?: 'readTemplateTag', id?: any, label: string }> };

export type GetHolidaysQueryVariables = Exact<{
  start: Scalars['DateOnly']['input'];
  end: Scalars['DateOnly']['input'];
  holidayRegionCode: Scalars['String']['input'];
}>;


export type GetHolidaysQuery = { __typename?: 'RosteringQuery', holidays?: { __typename?: 'holidays', holidays?: Array<{ __typename?: 'holiday', name: string, date?: any, holidayRegionCode?: string }> } };

export type CreateLeaveTypesMutationVariables = Exact<{
  leaveTypes: Array<InputMaybe<CreateLeaveType>> | InputMaybe<CreateLeaveType>;
}>;


export type CreateLeaveTypesMutation = { __typename?: 'RosteringMutation', createLeaveTypes?: boolean };

export type CreateLeaveTypeMutationVariables = Exact<{
  leaveType: CreateLeaveType;
}>;


export type CreateLeaveTypeMutation = { __typename?: 'RosteringMutation', createLeaveType?: { __typename?: 'readLeaveType', id?: any, name: string, active: boolean, properties?: string } };

export type UpdateLeaveTypesMutationVariables = Exact<{
  leaveTypes: Array<InputMaybe<UpdateLeaveType>> | InputMaybe<UpdateLeaveType>;
}>;


export type UpdateLeaveTypesMutation = { __typename?: 'RosteringMutation', updateLeaveTypes?: boolean };

export type UpdateLeaveTypeMutationVariables = Exact<{
  leaveType: UpdateLeaveType;
}>;


export type UpdateLeaveTypeMutation = { __typename?: 'RosteringMutation', updateLeaveType?: { __typename?: 'readLeaveType', id?: any, name: string, active: boolean, properties?: string } };

export type DeleteLeaveTypesMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Guid']['input']>> | InputMaybe<Scalars['Guid']['input']>;
}>;


export type DeleteLeaveTypesMutation = { __typename?: 'RosteringMutation', deleteLeaveTypes?: boolean };

export type GetLeaveTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeaveTypesQuery = { __typename?: 'RosteringQuery', leaveTypes?: Array<{ __typename?: 'readLeaveType', id?: any, name: string, active: boolean, properties?: string }> };

export type GetLeaveTypeQueryVariables = Exact<{
  id: Scalars['Guid']['input'];
}>;


export type GetLeaveTypeQuery = { __typename?: 'RosteringQuery', leaveType?: { __typename?: 'readLeaveType', id?: any, name: string, active: boolean, properties?: string } };

export type LeaveTypeDeleteValidationQueryVariables = Exact<{
  leaveTypeId: Scalars['Guid']['input'];
  boundaryDate: Scalars['DateOnly']['input'];
}>;


export type LeaveTypeDeleteValidationQuery = { __typename?: 'RosteringQuery', leaveTypeDeleteValidation: { __typename?: 'leaveTypeDeleteValidation', hasUsagesBeforeBoundary: boolean, usagesOnOrAfterBoundary: Array<{ __typename?: 'leaveTypeUsageOnOrAfterBoundary', availabilityExceptionId?: any, employeeId?: any, date?: any, locationId?: number }> } };

export type GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQuery = { __typename?: 'RosteringQuery', locations?: Array<{ __typename?: 'location', id: number, name: string, properties?: string, active: boolean, phoneNumber?: string, holidayRegionCode?: string, externalId?: string, locationCoordinates?: Array<{ __typename?: 'locationCoordinates', locationName: string, latitude?: number, longitude?: number }>, address?: { __typename?: 'address', line1: string, line2?: string, city: string, postcode: string, country: string } }> };

export type AddApprovedLocationsMutationVariables = Exact<{
  location: UpdateLocation;
}>;


export type AddApprovedLocationsMutation = { __typename?: 'RosteringMutation', updateLocation?: { __typename?: 'location', name: string, id: number, locationCoordinates?: Array<{ __typename?: 'locationCoordinates', locationName: string, latitude?: number, longitude?: number }> } };

export type CreateLocationMutationVariables = Exact<{
  location: CreateLocation;
}>;


export type CreateLocationMutation = { __typename?: 'RosteringMutation', createLocation?: { __typename?: 'location', id: number, name: string, holidayRegionCode?: string, locationCoordinates?: Array<{ __typename?: 'locationCoordinates', locationName: string, longitude?: number, latitude?: number }> } };

export type CreateLocationCoordinatesMutationVariables = Exact<{
  locationCoordinates: NewLocationCoordinates;
}>;


export type CreateLocationCoordinatesMutation = { __typename?: 'RosteringMutation', createLocationCoordinates?: { __typename?: 'locationCoordinates', id?: any, locationName: string, locationId: number, longitude?: number, latitude?: number } };

export type UpdateLocationMutationVariables = Exact<{
  location: UpdateLocation;
}>;


export type UpdateLocationMutation = { __typename?: 'RosteringMutation', updateLocation?: { __typename?: 'location', id: number, name: string, holidayRegionCode?: string } };

export type GetSupportedHolidayRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupportedHolidayRegionsQuery = { __typename?: 'RosteringQuery', supportedHolidayRegions?: Array<{ __typename?: 'holidayRegion', code: string, displayName: string }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'RosteringQuery', myEmployee?: { __typename?: 'readEmployee', identityId?: any, employeeId?: string, avatarUrl?: string, email?: string, role: string, phoneNumber?: string, firstName: string, lastName?: string, isRosterable?: boolean, isDeleted?: boolean, isDeactivated?: boolean, homeLocationId?: number, contractRoleId?: any, hireDate?: any, properties?: string, contract?: { __typename?: 'employeeContract', contractTypeId?: string, contractModificationId: number }, personas?: Array<{ __typename?: 'persona', id?: any, name: string, management?: boolean, templateLibrarian?: boolean }>, locations?: Array<{ __typename?: 'location', id: number, name: string, properties?: string }> } };

export type GetBatchJobStatusQueryVariables = Exact<{
  id: Scalars['Guid']['input'];
  start: Scalars['DateOnly']['input'];
  end: Scalars['DateOnly']['input'];
}>;


export type GetBatchJobStatusQuery = { __typename?: 'RosteringQuery', batchJobStatusForManager?: { __typename?: 'BatchStatusGT', locationStatuses?: Array<{ __typename?: 'LocationStatusGT', locationId: number, name: string, statuses?: Array<{ __typename?: 'JobDateStatusGT', date?: any, status?: BasicJobStatus }> }> } };

export type OptimiserBatchSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OptimiserBatchSubscription = { __typename?: 'RosteringSubscription', batchJobStateChange?: { __typename?: 'BatchJobStateChangeNotifyGT', id: string, date: any, started?: any, finished?: any, properties: string, changeType?: ChangeType, batchId: string } };

export type GetOrganisationHierarchyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationHierarchyQuery = { __typename?: 'RosteringQuery', getOrganisationHierarchy?: { __typename?: 'readDivision', id: string, divisionId?: string, name: string, level: number, locations?: Array<{ __typename?: 'location', id: number, name: string, properties?: string }>, children?: Array<{ __typename?: 'readDivision', id: string, name: string, divisionId?: string, level: number, locations?: Array<{ __typename?: 'location', id: number, name: string, properties?: string }>, children?: Array<{ __typename?: 'readDivision', id: string, name: string, divisionId?: string, level: number, locations?: Array<{ __typename?: 'location', id: number, name: string, properties?: string }>, children?: Array<{ __typename?: 'readDivision', id: string, name: string, divisionId?: string, level: number, locations?: Array<{ __typename?: 'location', id: number, name: string, properties?: string }> }> }> }> } };

export type GetPersonaQueryVariables = Exact<{
  id: Scalars['Guid']['input'];
}>;


export type GetPersonaQuery = { __typename?: 'RosteringQuery', persona?: { __typename?: 'persona', id?: any, name: string, displayOrder?: number, management?: boolean, adminControlled?: boolean, templateLibrarian?: boolean } };

export type GetPersonasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonasQuery = { __typename?: 'RosteringQuery', personas?: Array<{ __typename?: 'persona', id?: any, name: string, displayOrder?: number, management?: boolean, adminControlled?: boolean, templateLibrarian?: boolean }> };

export type CreatePersonasMutationVariables = Exact<{
  personas: Array<InputMaybe<CreatePersona>> | InputMaybe<CreatePersona>;
}>;


export type CreatePersonasMutation = { __typename?: 'RosteringMutation', createPersonas?: Array<{ __typename?: 'persona', id?: any, name: string, displayOrder?: number, management?: boolean, adminControlled?: boolean, templateLibrarian?: boolean }> };

export type UpdatePersonasMutationVariables = Exact<{
  personas: Array<InputMaybe<UpdatePersona>> | InputMaybe<UpdatePersona>;
}>;


export type UpdatePersonasMutation = { __typename?: 'RosteringMutation', updatePersonas?: Array<{ __typename?: 'persona', id?: any, name: string, displayOrder?: number, management?: boolean, adminControlled?: boolean, templateLibrarian?: boolean }> };

export type DeletePersonasMutationVariables = Exact<{
  personaIds: Array<InputMaybe<Scalars['Guid']['input']>> | InputMaybe<Scalars['Guid']['input']>;
}>;


export type DeletePersonasMutation = { __typename?: 'RosteringMutation', deletePersonas?: boolean };

export type MinimalRosterMutationResultFragment = { __typename?: 'minimalRosterResult', id?: any, rosterDate?: any, status: string, lastModified: any, publicationTime?: any };

export type GetRostersOverviewQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  startDate: Scalars['DateOnly']['input'];
  endDate: Scalars['DateOnly']['input'];
}>;


export type GetRostersOverviewQuery = { __typename?: 'RosteringQuery', rostersInDateRange?: Array<{ __typename?: 'readRoster', id?: any, rosterDate?: any, status: string, lastModified: any, publicationTime?: any }> };

export type GetRosterPropertiesQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  startDate: Scalars['DateOnly']['input'];
  endDate: Scalars['DateOnly']['input'];
}>;


export type GetRosterPropertiesQuery = { __typename?: 'RosteringQuery', rostersInDateRange?: Array<{ __typename?: 'readRoster', rosterDate?: any, properties?: string }> };

export type GetFullRostersQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  startDate: Scalars['DateOnly']['input'];
  endDate: Scalars['DateOnly']['input'];
}>;


export type GetFullRostersQuery = { __typename?: 'RosteringQuery', rostersWithPositionsAndTasksInDateRange?: Array<{ __typename?: 'readRoster', id?: any, rosterDate?: any, status: string, lastModified: any, publicationTime?: any, templateName?: string, templateId?: string, properties?: string, shiftOperatingHours?: { __typename?: 'shiftOperatingHours', startTime?: any, endTime?: any, openTime?: any, closeTime?: any }, stations?: Array<{ __typename?: 'rosterStation', id?: any, stationId: number, stationName: string, displayOrder: number, excludeHours: boolean, positions?: Array<{ __typename?: 'readRosterPositions', id?: any, displayOrder: number, properties?: string, templatedEmployeeId?: any, employeeId?: any, contractRoleId?: any, templatedContractRoleId?: any, start?: any, end?: any, breaks?: Array<{ __typename?: 'readRosterTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readRosterPositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }>, tasks?: Array<{ __typename?: 'readRosterTask', id?: any, taskId: number, taskName: string, displayOrder: number, timeSlots?: Array<{ __typename?: 'readTaskTimeSlots', id?: any, start?: any, end?: any }> }> }> }> };

export type GetRosterQueryVariables = Exact<{
  id: Scalars['Guid']['input'];
}>;


export type GetRosterQuery = { __typename?: 'RosteringQuery', roster?: { __typename?: 'readRoster', id?: any, rosterDate?: any, status: string, lastModified: any, publicationTime?: any, templateId?: string, templateName?: string, isHoliday: boolean, properties?: string, location?: { __typename?: 'location', id: number, name: string, properties?: string, active: boolean, phoneNumber?: string, holidayRegionCode?: string, externalId?: string, address?: { __typename?: 'address', line1: string, line2?: string, city: string, postcode: string, country: string } }, shiftOperatingHours?: { __typename?: 'shiftOperatingHours', startTime?: any, endTime?: any, openTime?: any, closeTime?: any }, stations?: Array<{ __typename?: 'rosterStation', id?: any, stationId: number, stationName: string, displayOrder: number, excludeHours: boolean, positions?: Array<{ __typename?: 'readRosterPositions', id?: any, displayOrder: number, properties?: string, templatedEmployeeId?: any, employeeId?: any, contractRoleId?: any, templatedContractRoleId?: any, start?: any, end?: any, breaks?: Array<{ __typename?: 'readRosterTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readRosterPositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }>, tasks?: Array<{ __typename?: 'readRosterTask', id?: any, taskId: number, taskName: string, displayOrder: number, timeSlots?: Array<{ __typename?: 'readTaskTimeSlots', id?: any, start?: any, end?: any }> }> }> } };

export type GetRosteredStaffInDateRangeQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateOnly']['input']>;
  endDate?: InputMaybe<Scalars['DateOnly']['input']>;
}>;


export type GetRosteredStaffInDateRangeQuery = { __typename?: 'RosteringQuery', rosteredStaffInDateRange?: Array<{ __typename?: 'rosteredEmployeeIdAndSchedule', identityId?: any, date: any, start?: any, end?: any, properties?: string, breaks?: Array<{ __typename?: 'readRosterTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readRosterPositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }> };

export type GetLeftCompanyShiftsQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  startDate: Scalars['DateOnly']['input'];
}>;


export type GetLeftCompanyShiftsQuery = { __typename?: 'RosteringQuery', rosteredStaffAfterLeaveDate?: Array<{ __typename?: 'rosteredEmployeeIdAndDates', identityId?: any, dates: Array<any> }> };

export type GetRosterStatusesQueryVariables = Exact<{
  dateRangeAndLocations: RosterStatuses;
}>;


export type GetRosterStatusesQuery = { __typename?: 'RosteringQuery', rosterStatuses?: Array<{ __typename?: 'rosterStatus', locationId: number, rosterId?: any, rosterDate: any, status: string }> };

export type GetDayShiftsQueryVariables = Exact<{
  dateAndIdentityIds: DayShifts;
}>;


export type GetDayShiftsQuery = { __typename?: 'RosteringQuery', dayShifts?: Array<{ __typename?: 'shifts', identityId?: any, shifts?: Array<{ __typename?: 'shift', start?: any, end?: any, status: string, location?: { __typename?: 'location', id: number, name: string } }> }> };

export type CreateRosterMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
  date: Scalars['DateOnly']['input'];
  locationId: Scalars['Int']['input'];
}>;


export type CreateRosterMutation = { __typename?: 'RosteringMutation', createRosterFromTemplate?: { __typename?: 'minimalRosterResult', id?: any, rosterDate?: any, status: string, lastModified: any, publicationTime?: any } };

export type UpdateRosterMutationVariables = Exact<{
  updateRoster: UpdateRoster;
}>;


export type UpdateRosterMutation = { __typename?: 'RosteringMutation', updateRoster?: { __typename?: 'minimalRosterResult', id?: any, rosterDate?: any, status: string, lastModified: any, publicationTime?: any } };

export type SetNotificationsMutationVariables = Exact<{
  notifications: Array<InputMaybe<UpdateNotification>> | InputMaybe<UpdateNotification>;
}>;


export type SetNotificationsMutation = { __typename?: 'RosteringMutation', updateNotifications?: boolean };

export type DeleteNotificationsMutationVariables = Exact<{
  notifications: Array<InputMaybe<Scalars['Guid']['input']>> | InputMaybe<Scalars['Guid']['input']>;
}>;


export type DeleteNotificationsMutation = { __typename?: 'RosteringMutation', deleteNotifications?: boolean };

export type PushNotificationsMutationVariables = Exact<{
  notifications: PushNotifications;
}>;


export type PushNotificationsMutation = { __typename?: 'RosteringMutation', pushNotifications?: boolean };

export type GetNotificationsQueryVariables = Exact<{
  notifications: GetNotifications;
}>;


export type GetNotificationsQuery = { __typename?: 'RosteringQuery', locationNotificationsForDateRange?: Array<{ __typename?: 'NotificationGT', id: string, locationId: number, date?: any, triggerType: number, value: boolean, properties?: string }> };

export type AddDummyTaskMutationVariables = Exact<{
  rosterId: Scalars['Guid']['input'];
  stationId: Scalars['Guid']['input'];
}>;


export type AddDummyTaskMutation = { __typename?: 'RosteringMutation', addRosterTask?: { __typename?: 'minimalRosterResult', id?: any } };

export type PublishRosterMutationVariables = Exact<{
  rosterId: Scalars['Guid']['input'];
}>;


export type PublishRosterMutation = { __typename?: 'RosteringMutation', completeRoster?: { __typename?: 'completeRosterResult', lastModified: any } };

export type DeleteRosterMutationVariables = Exact<{
  rosterId: Scalars['Guid']['input'];
}>;


export type DeleteRosterMutation = { __typename?: 'RosteringMutation', deleteRoster?: boolean };

export type SetRosterStatusesMutationVariables = Exact<{
  updateStatuses: UpdateRosterStatuses;
}>;


export type SetRosterStatusesMutation = { __typename?: 'RosteringMutation', setRosterStatuses?: boolean };

export type FindShiftsQueryVariables = Exact<{
  searchParams: FindShiftsByProperty;
}>;


export type FindShiftsQuery = { __typename?: 'RosteringQuery', findShiftsByProperty?: Array<{ __typename?: 'foundShifts', locationId: number, locationName: string, shifts?: Array<{ __typename?: 'readRosterPositions', id?: any, start?: any, end?: any, properties?: string, employeeId?: any, breaks?: Array<{ __typename?: 'readRosterTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readRosterPositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }> }> };

export type FindReassignedShiftsInDateRangeQueryVariables = Exact<{
  searchParams: FindReassignedShiftsInDateRange;
}>;


export type FindReassignedShiftsInDateRangeQuery = { __typename?: 'RosteringQuery', findReassignedShiftsInDateRange?: Array<{ __typename?: 'foundShiftsInDateRange', locationId: number, locationName: string, shifts?: Array<{ __typename?: 'readRosterDayPositions', id?: any, date?: any, start?: any, end?: any, properties?: string, employeeId?: any, breaks?: Array<{ __typename?: 'readRosterTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readRosterPositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }> }> };

export type AssignEmployeesToPositionsMutationVariables = Exact<{
  positionAndEmployeePairs: Array<InputMaybe<AssignPositionEmployee>> | InputMaybe<AssignPositionEmployee>;
}>;


export type AssignEmployeesToPositionsMutation = { __typename?: 'RosteringMutation', assignEmployeesToPositions?: boolean };

export type SetPositionPropertiesMutationVariables = Exact<{
  idAndPropertiesPairs: Array<InputMaybe<SetPositionProperties>> | InputMaybe<SetPositionProperties>;
}>;


export type SetPositionPropertiesMutation = { __typename?: 'RosteringMutation', setPositionProperties?: boolean };

export type DeletePositionsMutationVariables = Exact<{
  positionIds: Array<InputMaybe<Scalars['Guid']['input']>> | InputMaybe<Scalars['Guid']['input']>;
}>;


export type DeletePositionsMutation = { __typename?: 'RosteringMutation', deletePositions?: boolean };

export type DeleteRostersMutationVariables = Exact<{
  locationAndDateRange: DeleteRostersInDateRange;
}>;


export type DeleteRostersMutation = { __typename?: 'RosteringMutation', deleteRostersInDateRange?: boolean };

export type GetShiftOperatingHoursQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  start?: InputMaybe<Scalars['DateOnly']['input']>;
  end?: InputMaybe<Scalars['DateOnly']['input']>;
}>;


export type GetShiftOperatingHoursQuery = { __typename?: 'RosteringQuery', shiftOperatingHoursInDateRange?: Array<{ __typename?: 'shiftOperatingHoursDay', date?: any, startTime?: any, endTime?: any, openTime?: any, closeTime?: any }> };

export type GetLocationListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationListQuery = { __typename?: 'RosteringQuery', locations?: Array<{ __typename?: 'location', id: number, name: string, properties?: string, active: boolean, phoneNumber?: string, holidayRegionCode?: string, externalId?: string, address?: { __typename?: 'address', line1: string, line2?: string, city: string, postcode: string, country: string } }> };

export type GetLocationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetLocationQuery = { __typename?: 'RosteringQuery', location?: { __typename?: 'location', id: number, name: string, properties?: string, active: boolean, phoneNumber?: string, holidayRegionCode?: string, externalId?: string, address?: { __typename?: 'address', line1: string, line2?: string, city: string, postcode: string, country: string } } };

export type UpdateLocationsMutationVariables = Exact<{
  locations: Array<InputMaybe<UpdateLocation>> | InputMaybe<UpdateLocation>;
}>;


export type UpdateLocationsMutation = { __typename?: 'RosteringMutation', updateLocations?: boolean };

export type UpdateEmployeeLocationsMutationVariables = Exact<{
  employeeLocations: Array<InputMaybe<UpdateEmployeeLocations>> | InputMaybe<UpdateEmployeeLocations>;
}>;


export type UpdateEmployeeLocationsMutation = { __typename?: 'RosteringMutation', updateEmployeeLocations?: boolean };

export type DeleteAllRostersMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllRostersMutation = { __typename?: 'RosteringMutation', deleteAllRosters?: boolean };

export type DeleteAllTemplatesMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllTemplatesMutation = { __typename?: 'RosteringMutation', deleteAllTemplates?: boolean };

export type DeleteAllWorkingPatternsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllWorkingPatternsMutation = { __typename?: 'RosteringMutation', deleteAllWorkingPatterns?: boolean };

export type DeleteAllAvailabilityExceptionsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllAvailabilityExceptionsMutation = { __typename?: 'RosteringMutation', deleteAllAvailabilityExceptions?: boolean };

export type DeleteAllAvailabilitiesMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAllAvailabilitiesMutation = { __typename?: 'RosteringMutation', deleteAllAvailabilities?: boolean };

export type ResetAllPasswordsMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetAllPasswordsMutation = { __typename?: 'RosteringMutation', resetAllPasswords?: boolean };

export type UpdateMySettingsMutationVariables = Exact<{
  settings: UpdateSettings;
}>;


export type UpdateMySettingsMutation = { __typename?: 'RosteringMutation', updateMySettings?: { __typename?: 'readSettings', displayLanguage: string } };

export type CreateMySettingsMutationVariables = Exact<{
  settings: CreateSettings;
}>;


export type CreateMySettingsMutation = { __typename?: 'RosteringMutation', createMySettings?: { __typename?: 'readSettings', displayLanguage: string } };

export type MySettingQueryVariables = Exact<{ [key: string]: never; }>;


export type MySettingQuery = { __typename?: 'RosteringQuery', mySettings?: { __typename?: 'readSettings', displayLanguage: string } };

export type GetMyShiftsForDateRangeQueryVariables = Exact<{
  range: GetShiftsForDateRange;
}>;


export type GetMyShiftsForDateRangeQuery = { __typename?: 'RosteringQuery', myShiftsForDateRange?: { __typename?: 'shifts', shifts?: Array<{ __typename?: 'shift', start?: any, end?: any, date: any, lastModified: any, publicationTime?: any, location?: { __typename?: 'location', name: string } }> } };

export type GetVacantShiftsForLocationsQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  triggerType: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateOnly']['input']>;
  endDate?: InputMaybe<Scalars['DateOnly']['input']>;
}>;


export type GetVacantShiftsForLocationsQuery = { __typename?: 'RosteringQuery', notifiableVacantShiftsInDateRange?: { __typename?: 'countAndShifts', count: number, shifts?: Array<{ __typename?: 'readRosterDayPositions', id?: any, date?: any, start?: any, end?: any }> } };

export type GetVacantShiftsCountQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  triggerType: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateOnly']['input']>;
}>;


export type GetVacantShiftsCountQuery = { __typename?: 'RosteringQuery', notifiableVacantShiftsInDateRange?: { __typename?: 'countAndShifts', count: number } };

export type GetShiftsCountsQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
  startDate?: InputMaybe<Scalars['DateOnly']['input']>;
  endDate?: InputMaybe<Scalars['DateOnly']['input']>;
}>;


export type GetShiftsCountsQuery = { __typename?: 'RosteringQuery', vacantShiftsInDateRange?: { __typename?: 'countAndShifts', count: number, total: number } };

export type GetSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSkillsQuery = { __typename?: 'RosteringQuery', skills?: Array<{ __typename?: 'readSkills', id: string, active?: boolean, name: string, properties?: string }> };

export type CreateSkillsMutationVariables = Exact<{
  skills: Array<InputMaybe<CreateSkill>> | InputMaybe<CreateSkill>;
}>;


export type CreateSkillsMutation = { __typename?: 'RosteringMutation', createSkills?: Array<{ __typename?: 'readSkills', id: string, active?: boolean, name: string, properties?: string }> };

export type UpdateSkillsMutationVariables = Exact<{
  skills: Array<InputMaybe<UpdateSkill>> | InputMaybe<UpdateSkill>;
}>;


export type UpdateSkillsMutation = { __typename?: 'RosteringMutation', updateSkills?: Array<{ __typename?: 'readSkills', id: string, active?: boolean, name: string, properties?: string }> };

export type DeleteSkillsMutationVariables = Exact<{
  skillIds: Array<InputMaybe<Scalars['Guid']['input']>> | InputMaybe<Scalars['Guid']['input']>;
}>;


export type DeleteSkillsMutation = { __typename?: 'RosteringMutation', deleteSkills?: boolean };

export type GetEmployeeSkillsQueryVariables = Exact<{
  employeeIds: Array<InputMaybe<Scalars['Guid']['input']>> | InputMaybe<Scalars['Guid']['input']>;
}>;


export type GetEmployeeSkillsQuery = { __typename?: 'RosteringQuery', employeeSkillsByEmployeeIds?: Array<{ __typename?: 'readEmployeeIdAndSkills', employeeId?: any, skills?: Array<{ __typename?: 'readEmployeeSkills', name: string, skillId?: any }> }> };

export type UpdateEmployeeSkillsMutationVariables = Exact<{
  skills: Array<InputMaybe<UpdateEmployeeSkillsByEmployeeIdAndSkills>> | InputMaybe<UpdateEmployeeSkillsByEmployeeIdAndSkills>;
}>;


export type UpdateEmployeeSkillsMutation = { __typename?: 'RosteringMutation', updateEmployeeSkills?: boolean };

export type AllUserAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUserAccountsQuery = { __typename?: 'RosteringQuery', employees?: Array<{ __typename?: 'readEmployee', identityId?: any, employeeId?: string, firstName: string, lastName?: string, role: string, isDeleted?: boolean, isDeactivated?: boolean, isRosterable?: boolean, contractRoleId?: any, email?: string, phoneNumber?: string, homeLocationId?: number, hireDate?: any, leaveDate?: any, dateOfBirth?: any, endOfProbationDate?: any, properties?: string, avatarUrl?: string, contract?: { __typename?: 'employeeContract', contractTypeId?: string, contractTypeName?: string, contractModificationName: string, contractModificationId: number }, locations?: Array<{ __typename?: 'location', id: number, name: string }>, personas?: Array<{ __typename?: 'persona', id?: any, name: string, displayOrder?: number, management?: boolean, adminControlled?: boolean, templateLibrarian?: boolean }> }> };

export type GetEmployeesByLocationsQueryVariables = Exact<{
  locationIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetEmployeesByLocationsQuery = { __typename?: 'RosteringQuery', employeesByLocations?: { __typename?: 'readEmployeesList', employees?: Array<{ __typename?: 'readEmployee', identityId?: any, employeeId?: string, firstName: string, lastName?: string, role: string, isDeleted?: boolean, isDeactivated?: boolean, isRosterable?: boolean, contractRoleId?: any, email?: string, phoneNumber?: string, homeLocationId?: number, hireDate?: any, leaveDate?: any, dateOfBirth?: any, endOfProbationDate?: any, properties?: string, avatarUrl?: string, contract?: { __typename?: 'employeeContract', contractTypeId?: string, contractTypeName?: string, contractModificationName: string, contractModificationId: number }, locations?: Array<{ __typename?: 'location', id: number, name: string }>, personas?: Array<{ __typename?: 'persona', id?: any, name: string, displayOrder?: number, management?: boolean, adminControlled?: boolean, templateLibrarian?: boolean }> }> } };

export type GetEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployeesQuery = { __typename?: 'RosteringQuery', employees?: Array<{ __typename?: 'readEmployee', identityId?: any, employeeId?: string, firstName: string, lastName?: string, role: string, isDeleted?: boolean, isDeactivated?: boolean, isRosterable?: boolean, contractRoleId?: any, email?: string, phoneNumber?: string, homeLocationId?: number, hireDate?: any, leaveDate?: any, dateOfBirth?: any, endOfProbationDate?: any, properties?: string, avatarUrl?: string, contract?: { __typename?: 'employeeContract', contractTypeId?: string, contractTypeName?: string, contractModificationName: string, contractModificationId: number }, locations?: Array<{ __typename?: 'location', id: number, name: string }>, personas?: Array<{ __typename?: 'persona', id?: any, name: string, displayOrder?: number, management?: boolean, adminControlled?: boolean, templateLibrarian?: boolean }> }> };

export type GetEmployeesByIdsQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Guid']['input']>> | InputMaybe<Scalars['Guid']['input']>;
}>;


export type GetEmployeesByIdsQuery = { __typename?: 'RosteringQuery', employeesByIds?: Array<{ __typename?: 'readEmployee', identityId?: any, employeeId?: string, firstName: string, lastName?: string, role: string, isDeleted?: boolean, isDeactivated?: boolean, isRosterable?: boolean, contractRoleId?: any, email?: string, phoneNumber?: string, homeLocationId?: number, hireDate?: any, leaveDate?: any, dateOfBirth?: any, endOfProbationDate?: any, properties?: string, avatarUrl?: string, contract?: { __typename?: 'employeeContract', contractTypeId?: string, contractTypeName?: string, contractModificationName: string, contractModificationId: number }, locations?: Array<{ __typename?: 'location', id: number, name: string }>, personas?: Array<{ __typename?: 'persona', id?: any, name: string, displayOrder?: number, management?: boolean, adminControlled?: boolean, templateLibrarian?: boolean }> }> };

export type UpdateWorkRulesMutationVariables = Exact<{
  workRules: Array<InputMaybe<UpdateEmployeeWorkRules>> | InputMaybe<UpdateEmployeeWorkRules>;
}>;


export type UpdateWorkRulesMutation = { __typename?: 'RosteringMutation', updateWorkRules?: Array<{ __typename?: 'employeeConstraints', id?: any, identityId?: any, maxHoursPerMonth?: number, minHoursPerMonth?: number, maxHoursPerWeek?: number, minHoursPerWeek?: number }> };

export type GetEmployeeWorkRulesQueryVariables = Exact<{
  employeeIds: Array<InputMaybe<Scalars['Guid']['input']>> | InputMaybe<Scalars['Guid']['input']>;
}>;


export type GetEmployeeWorkRulesQuery = { __typename?: 'RosteringQuery', workRulesByEmployeeIds?: Array<{ __typename?: 'employeeConstraints', id?: any, identityId?: any, maxHoursPerMonth?: number, minHoursPerMonth?: number, maxHoursPerWeek?: number, minHoursPerWeek?: number }> };

export type ResetPasswordMutationVariables = Exact<{
  employeeId: Scalars['Guid']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'RosteringMutation', resetPassword?: boolean };

export type UpdateEmployeesMutationVariables = Exact<{
  employees: Array<InputMaybe<UpdateEmployee>> | InputMaybe<UpdateEmployee>;
}>;


export type UpdateEmployeesMutation = { __typename?: 'RosteringMutation', updateEmployees?: boolean };

export type CreateEmployeeMutationVariables = Exact<{
  createEmployee: CreateEmployee;
}>;


export type CreateEmployeeMutation = { __typename?: 'RosteringMutation', createUserAndEmployee?: { __typename?: 'readEmployee', identityId?: any } };

export type GetEmployeeHistoryQueryVariables = Exact<{
  idAndDateRange: GetEmployeeHistory;
}>;


export type GetEmployeeHistoryQuery = { __typename?: 'RosteringQuery', employeeHistory?: { __typename?: 'readEmployeeHistory', rosterHistory?: Array<{ __typename?: 'readRosterHistory', date?: any, history?: Array<{ __typename?: 'readRosterHistoryTimeSlot', start?: any, end?: any, locationId: number }> }>, availabilityHistory?: Array<{ __typename?: 'readAvailabilityHistory', date?: any, leaveTypeId?: any, history?: Array<{ __typename?: 'readAvailabilityHistoryTimeSlot', start?: any, end?: any }> }> } };

export type GetEmployeeNamesByIdsQueryVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Guid']['input']>> | InputMaybe<Scalars['Guid']['input']>;
}>;


export type GetEmployeeNamesByIdsQuery = { __typename?: 'RosteringQuery', employeeNamesByIds?: Array<{ __typename?: 'readEmployeeName', identityId?: any, firstName: string, lastName?: string }> };

export type GetStaffByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Guid']['input']>;
}>;


export type GetStaffByIdQuery = { __typename?: 'RosteringQuery', employee?: { __typename?: 'readEmployee', identityId?: any, employeeId?: string, firstName: string, lastName?: string, role: string, isDeleted?: boolean, isDeactivated?: boolean, isRosterable?: boolean, contractRoleId?: any, email?: string, phoneNumber?: string, homeLocationId?: number, hireDate?: any, leaveDate?: any, dateOfBirth?: any, endOfProbationDate?: any, properties?: string, avatarUrl?: string, contract?: { __typename?: 'employeeContract', contractTypeId?: string, contractTypeName?: string, contractModificationName: string, contractModificationId: number }, locations?: Array<{ __typename?: 'location', id: number, name: string }>, personas?: Array<{ __typename?: 'persona', id?: any, name: string, displayOrder?: number, management?: boolean, adminControlled?: boolean, templateLibrarian?: boolean }> } };

export type UpdateStaffMutationVariables = Exact<{
  employee: UpdateEmployee;
}>;


export type UpdateStaffMutation = { __typename?: 'RosteringMutation', updateEmployee?: { __typename?: 'readEmployee', identityId?: any, email?: string, firstName: string, lastName?: string, role: string } };

export type UpdateSelfMutationVariables = Exact<{
  employee: UpdateEmployee;
}>;


export type UpdateSelfMutation = { __typename?: 'RosteringMutation', updateMyInfo?: { __typename?: 'readEmployee', email?: string, firstName: string, lastName?: string, role: string } };

export type UpdateDeactivatedStatusMutationVariables = Exact<{
  id: Scalars['Guid']['input'];
  deactivated: Scalars['Boolean']['input'];
}>;


export type UpdateDeactivatedStatusMutation = { __typename?: 'RosteringMutation', updateDeactivatedStatus?: { __typename?: 'id', userId: string, deactivated: boolean } };

export type GdprDeleteUserMutationVariables = Exact<{
  id: Scalars['Guid']['input'];
}>;


export type GdprDeleteUserMutation = { __typename?: 'RosteringMutation', gdprDeleteUser?: boolean };

export type CreateUserAndEmployeeMutationVariables = Exact<{
  employee: CreateEmployee;
}>;


export type CreateUserAndEmployeeMutation = { __typename?: 'RosteringMutation', createUserAndEmployee?: { __typename?: 'readEmployee', identityId?: any } };

export type CreateMultipleUsersAndEmployeesMutationVariables = Exact<{
  employees: Array<CreateEmployee> | CreateEmployee;
}>;


export type CreateMultipleUsersAndEmployeesMutation = { __typename?: 'RosteringMutation', createMultipleUsersAndEmployees?: Array<{ __typename?: 'readEmployee', identityId?: any }> };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'RosteringQuery', roles?: Array<{ __typename?: 'readRole', id: number, name: string }> };

export type EmployeeIdWorkingPatternsQueryVariables = Exact<{
  dateAndPeriods: DateAndPeriods;
  id: Scalars['Guid']['input'];
}>;


export type EmployeeIdWorkingPatternsQuery = { __typename?: 'RosteringQuery', employeeIdWorkingPatterns?: { __typename?: 'workingPatternPeriods', periods?: Array<{ __typename?: 'workingPatternPeriod', patterns?: Array<{ __typename?: 'workingPatternDay', id?: any, startTime?: any, endTime?: any, slotNumber?: number, day: string, dayNumber?: number }> }> } };

export type SendWelcomeInfoMutationVariables = Exact<{
  welcomeInfo: SendWelcomeInfo;
}>;


export type SendWelcomeInfoMutation = { __typename?: 'RosteringMutation', sendWelcomeInfo?: boolean };

export type UpdateWorkingPatternMutationVariables = Exact<{
  args: UpdateWorkingPattern;
}>;


export type UpdateWorkingPatternMutation = { __typename?: 'RosteringMutation', updateWorkingPattern?: { __typename?: 'WorkingPatternGT', workingPattern?: Array<{ __typename?: 'workingPatternDay', startTime?: any, endTime?: any }> } };

export type GetBreakOffsetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBreakOffsetsQuery = { __typename?: 'RosteringQuery', getBreakOffsets?: { __typename?: 'readBreakOffsets', timeOffsetAfterLastBreak?: any, timeOffsetBeforeFirstBreak?: any } };

export type SetBreakOffsetsMutationVariables = Exact<{
  timeOffsetAfterLastBreak: Scalars['Seconds']['input'];
  timeOffsetBeforeFirstBreak: Scalars['Seconds']['input'];
}>;


export type SetBreakOffsetsMutation = { __typename?: 'RosteringMutation', setBreakOffsets?: boolean };

export type GetOrganisationPropertiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationPropertiesQuery = { __typename?: 'RosteringQuery', getOrganisationProperties?: string };

export type GetOrganisationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganisationSettingsQuery = { __typename?: 'RosteringQuery', organisationSettings?: { __typename?: 'organisationSettings', minMinutesBeforeBreak?: any, minMinutesAfterBreak?: any, shortestBreak?: any, defaultHolidayRegionCode?: string, leaveTypeTier?: Tier } };

export type SetOrganisationPropertiesMutationVariables = Exact<{
  properties: Scalars['String']['input'];
}>;


export type SetOrganisationPropertiesMutation = { __typename?: 'RosteringMutation', setOrganisationProperties?: boolean };

export type GetTargetsByLocationIdsQueryVariables = Exact<{
  locationIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateOnly']['input'];
  endDate: Scalars['DateOnly']['input'];
}>;


export type GetTargetsByLocationIdsQuery = { __typename?: 'RosteringQuery', targetsByLocationIds?: Array<{ __typename?: 'TargetGT', id?: any, locationId: number, date?: any, type: string, value: number }> };

export type UpdateTargetsMutationVariables = Exact<{
  targets: Array<InputMaybe<UpdateTargetByValue>> | InputMaybe<UpdateTargetByValue>;
}>;


export type UpdateTargetsMutation = { __typename?: 'RosteringMutation', updateTargets?: Array<{ __typename?: 'TargetGT', id?: any, locationId: number, date?: any, type: string, value: number }> };

export type GetTasksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTasksQuery = { __typename?: 'RosteringQuery', tasks?: Array<{ __typename?: 'readTask', id: number, name: string, properties?: string, active?: boolean, stationId: number, stationName: string, priority?: number, weight: number, skills?: Array<{ __typename?: 'readSkills', id: string, active?: boolean, name: string, properties?: string }> }> };

export type CreateTasksMutationVariables = Exact<{
  tasks: Array<InputMaybe<CreateTask>> | InputMaybe<CreateTask>;
}>;


export type CreateTasksMutation = { __typename?: 'RosteringMutation', createTasks?: Array<{ __typename?: 'readTask', id: number, name: string, properties?: string, active?: boolean, stationId: number, stationName: string, priority?: number, weight: number, skills?: Array<{ __typename?: 'readSkills', id: string, active?: boolean, name: string, properties?: string }> }> };

export type UpdateTasksMutationVariables = Exact<{
  tasks: Array<InputMaybe<UpdateTask>> | InputMaybe<UpdateTask>;
}>;


export type UpdateTasksMutation = { __typename?: 'RosteringMutation', updateTasks?: Array<{ __typename?: 'readTask', id: number, name: string, properties?: string, active?: boolean, stationId: number, stationName: string, priority?: number, weight: number, skills?: Array<{ __typename?: 'readSkills', id: string, active?: boolean, name: string, properties?: string }> }> };

export type DeleteTasksMutationVariables = Exact<{
  taskIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
}>;


export type DeleteTasksMutation = { __typename?: 'RosteringMutation', deleteTasks?: boolean };

export type MinimalTemplateMutationResultFragment = { __typename?: 'minimalTemplateResult', id?: any };

export type GetLibraryTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLibraryTemplatesQuery = { __typename?: 'RosteringQuery', templatesForLocation?: Array<{ __typename?: 'readTemplate', id?: any, name: string, weekday: boolean, properties?: string, draft?: boolean, version?: string, baseTemplateId?: any, lastModified: any, target?: { __typename?: 'target', type: string, value: number }, location?: { __typename?: 'location', id: number, name: string, properties?: string, active: boolean, phoneNumber?: string, holidayRegionCode?: string, externalId?: string, address?: { __typename?: 'address', line1: string, line2?: string, city: string, postcode: string, country: string } }, shiftOperatingHours?: { __typename?: 'shiftOperatingHours', startTime?: any, endTime?: any, openTime?: any, closeTime?: any }, stations?: Array<{ __typename?: 'readTemplateStations', id?: any, stationId: number, stationName: string, displayOrder: number, positions?: Array<{ __typename?: 'readTemplatesPositions', id?: any, displayOrder: number, start?: any, end?: any, properties?: string, contractRoleId?: any, employeeId?: any, breaks?: Array<{ __typename?: 'readTaskTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readTemplatePositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }> }>, templateTags?: Array<{ __typename?: 'readTemplateTag', id?: any, label: string }> }> };

export type GetTemplatesForLocationQueryVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;


export type GetTemplatesForLocationQuery = { __typename?: 'RosteringQuery', templatesForLocation?: Array<{ __typename?: 'readTemplate', id?: any, name: string, weekday: boolean, properties?: string, draft?: boolean, version?: string, baseTemplateId?: any, lastModified: any, target?: { __typename?: 'target', type: string, value: number }, location?: { __typename?: 'location', id: number, name: string, properties?: string, active: boolean, phoneNumber?: string, holidayRegionCode?: string, externalId?: string, address?: { __typename?: 'address', line1: string, line2?: string, city: string, postcode: string, country: string } }, shiftOperatingHours?: { __typename?: 'shiftOperatingHours', startTime?: any, endTime?: any, openTime?: any, closeTime?: any }, stations?: Array<{ __typename?: 'readTemplateStations', id?: any, stationId: number, stationName: string, displayOrder: number, positions?: Array<{ __typename?: 'readTemplatesPositions', id?: any, displayOrder: number, start?: any, end?: any, properties?: string, contractRoleId?: any, employeeId?: any, breaks?: Array<{ __typename?: 'readTaskTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readTemplatePositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }> }>, templateTags?: Array<{ __typename?: 'readTemplateTag', id?: any, label: string }> }> };

export type GetTemplateQueryVariables = Exact<{
  id: Scalars['Guid']['input'];
}>;


export type GetTemplateQuery = { __typename?: 'RosteringQuery', template?: { __typename?: 'readTemplate', id?: any, name: string, weekday: boolean, properties?: string, draft?: boolean, version?: string, baseTemplateId?: any, lastModified: any, target?: { __typename?: 'target', type: string, value: number }, location?: { __typename?: 'location', id: number, name: string, properties?: string, active: boolean, phoneNumber?: string, holidayRegionCode?: string, externalId?: string, address?: { __typename?: 'address', line1: string, line2?: string, city: string, postcode: string, country: string } }, shiftOperatingHours?: { __typename?: 'shiftOperatingHours', startTime?: any, endTime?: any, openTime?: any, closeTime?: any }, stations?: Array<{ __typename?: 'readTemplateStations', id?: any, stationId: number, stationName: string, displayOrder: number, positions?: Array<{ __typename?: 'readTemplatesPositions', id?: any, displayOrder: number, start?: any, end?: any, properties?: string, contractRoleId?: any, employeeId?: any, breaks?: Array<{ __typename?: 'readTaskTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readTemplatePositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }> }>, templateTags?: Array<{ __typename?: 'readTemplateTag', id?: any, label: string }> } };

export type GetTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplatesQuery = { __typename?: 'RosteringQuery', templates?: Array<{ __typename?: 'readTemplate', id?: any, name: string, weekday: boolean, properties?: string, draft?: boolean, version?: string, baseTemplateId?: any, lastModified: any, target?: { __typename?: 'target', type: string, value: number }, location?: { __typename?: 'location', id: number, name: string, properties?: string, active: boolean, phoneNumber?: string, holidayRegionCode?: string, externalId?: string, address?: { __typename?: 'address', line1: string, line2?: string, city: string, postcode: string, country: string } }, shiftOperatingHours?: { __typename?: 'shiftOperatingHours', startTime?: any, endTime?: any, openTime?: any, closeTime?: any }, stations?: Array<{ __typename?: 'readTemplateStations', id?: any, stationId: number, stationName: string, displayOrder: number, positions?: Array<{ __typename?: 'readTemplatesPositions', id?: any, displayOrder: number, start?: any, end?: any, properties?: string, contractRoleId?: any, employeeId?: any, breaks?: Array<{ __typename?: 'readTaskTimeSlots', id?: any, start?: any, end?: any }>, timeSlots?: Array<{ __typename?: 'readTemplatePositionTimeSlot', id?: any, start?: any, end?: any, properties?: string }> }> }>, templateTags?: Array<{ __typename?: 'readTemplateTag', id?: any, label: string }> }> };

export type UpdateTemplateMutationVariables = Exact<{
  updateTemplate: UpdateTemplate;
}>;


export type UpdateTemplateMutation = { __typename?: 'RosteringMutation', updateTemplate?: { __typename?: 'minimalTemplateResult', id?: any } };

export type CreateTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<CreateTemplateTag>> | InputMaybe<CreateTemplateTag>>;
}>;


export type CreateTemplateMutation = { __typename?: 'RosteringMutation', createTemplate?: { __typename?: 'minimalTemplateResult', id?: any } };

export type DeleteTemplateMutationVariables = Exact<{
  id: Scalars['Guid']['input'];
}>;


export type DeleteTemplateMutation = { __typename?: 'RosteringMutation', deleteTemplate?: boolean };

export type CopyTemplateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['Int']['input']>;
  sourceTemplateId: Scalars['Guid']['input'];
}>;


export type CopyTemplateMutation = { __typename?: 'RosteringMutation', copyTemplate?: { __typename?: 'minimalTemplateResult', id?: any } };

export type GetTemplateTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTemplateTagsQuery = { __typename?: 'RosteringQuery', templateTags?: Array<{ __typename?: 'readTemplateTag', id?: any, label: string }> };

export type GetTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantQuery = { __typename?: 'RosteringQuery', tenant?: { __typename?: 'tenant', id?: any, name: string } };

export const BasicFragmentDoc = gql`
    fragment Basic on WorkTimeRecord {
  id
  locationId
  risk
}
    `;
export const StartFragmentDoc = gql`
    fragment Start on WorkTimeRecord {
  start {
    dateTime
    origin
    geoLocation {
      latitude
      longitude
    }
  }
}
    `;
export const EndFragmentDoc = gql`
    fragment End on WorkTimeRecord {
  end {
    dateTime
    origin
    geoLocation {
      latitude
      longitude
    }
  }
}
    `;
export const BasicEFragmentDoc = gql`
    fragment BasicE on employeeWorkTimeRecord {
  id
  locationId
  risk
}
    `;
export const StartEFragmentDoc = gql`
    fragment StartE on employeeWorkTimeRecord {
  start {
    dateTime
    origin
    geoLocation {
      latitude
      longitude
    }
  }
}
    `;
export const EndEFragmentDoc = gql`
    fragment EndE on employeeWorkTimeRecord {
  end {
    dateTime
    origin
    geoLocation {
      latitude
      longitude
    }
  }
}
    `;
export const PatternFragmentDoc = gql`
    fragment Pattern on workingPatternDay {
  id
  startTime
  endTime
  slotNumber
  dayNumber
  day
}
    `;
export const ExceptionFragmentDoc = gql`
    fragment Exception on availabilityException {
  available
  approval
  date
  start
  end
  updatedOn
  leaveType {
    id
    name
    active
    properties
  }
}
    `;
export const ContractRolesFragmentDoc = gql`
    fragment ContractRoles on readContractRole {
  displayOrder
  id
  name
  notes
  properties
  active
}
    `;
export const ContractFragmentDoc = gql`
    fragment Contract on readContractTypes {
  id
  name
  minHoursPerDay
  maxHoursPerDay
  minHoursPerWeek
  maxHoursPerWeek
  maxDaysPerWeek
  maxConsecutiveDays
  earliestStartTime
  active
  latestEndTime
  maxHoursPerShift
  displayOrder
  properties
  overtimeAllowed
  roles {
    ...ContractRoles
  }
}
    ${ContractRolesFragmentDoc}`;
export const EmployeeContractFragmentDoc = gql`
    fragment EmployeeContract on employeeContract {
  contractTypeId
  contractTypeName
  contractModificationName
  contractModificationId
}
    `;
export const PersonaFragmentDoc = gql`
    fragment Persona on persona {
  id
  name
  displayOrder
  management
  adminControlled
  templateLibrarian
}
    `;
export const EmployeeFragmentDoc = gql`
    fragment Employee on readEmployee {
  identityId
  employeeId
  firstName
  lastName
  role
  isDeleted
  isDeactivated
  isRosterable
  contract {
    ...EmployeeContract
  }
  contractRoleId
  email
  phoneNumber
  locations {
    id
    name
  }
  homeLocationId
  hireDate
  leaveDate
  dateOfBirth
  endOfProbationDate
  personas {
    ...Persona
  }
  properties
  avatarUrl
}
    ${EmployeeContractFragmentDoc}
${PersonaFragmentDoc}`;
export const LeaveTypeFragmentDoc = gql`
    fragment LeaveType on readLeaveType {
  id
  name
  active
  properties
}
    `;
export const TimeSlotsPositionFragmentDoc = gql`
    fragment TimeSlotsPosition on rosteredEmployeeIdAndSchedule {
  timeSlots {
    id
    start
    end
    properties
  }
}
    `;
export const OperatingHoursFragmentDoc = gql`
    fragment OperatingHours on readRoster {
  shiftOperatingHours {
    startTime
    endTime
    openTime
    closeTime
  }
}
    `;
export const TimeSlotsPositionsFragmentDoc = gql`
    fragment TimeSlotsPositions on readRosterPositions {
  timeSlots {
    id
    start
    end
    properties
  }
}
    `;
export const TimeSlotsTasksFragmentDoc = gql`
    fragment TimeSlotsTasks on readRosterTask {
  timeSlots {
    id
    start
    end
  }
}
    `;
export const StationsFragmentDoc = gql`
    fragment Stations on readRoster {
  stations {
    id
    stationId
    stationName
    displayOrder
    excludeHours
    positions {
      id
      displayOrder
      properties
      templatedEmployeeId
      employeeId
      breaks {
        id
        start
        end
      }
      ...TimeSlotsPositions
      contractRoleId
      templatedContractRoleId
      start
      end
    }
    tasks {
      id
      taskId
      taskName
      displayOrder
      ...TimeSlotsTasks
    }
  }
}
    ${TimeSlotsPositionsFragmentDoc}
${TimeSlotsTasksFragmentDoc}`;
export const ShiftsFragmentDoc = gql`
    fragment Shifts on shifts {
  shifts {
    start
    end
    status
    location {
      id
      name
    }
  }
}
    `;
export const FoundShiftsFragmentDoc = gql`
    fragment FoundShifts on foundShifts {
  shifts {
    id
    start
    end
    properties
    breaks {
      id
      start
      end
    }
    timeSlots {
      id
      start
      end
      properties
    }
    employeeId
  }
}
    `;
export const FoundShiftsDateRangeFragmentDoc = gql`
    fragment FoundShiftsDateRange on foundShiftsInDateRange {
  shifts {
    id
    date
    start
    end
    properties
    breaks {
      id
      start
      end
    }
    timeSlots {
      id
      start
      end
      properties
    }
    employeeId
  }
}
    `;
export const SkillFragmentDoc = gql`
    fragment Skill on readSkills {
  id
  active
  name
  properties
}
    `;
export const TaskFragmentDoc = gql`
    fragment Task on readTask {
  id
  name
  properties
  active
  stationId
  stationName
  priority
  weight
  skills {
    ...Skill
  }
}
    ${SkillFragmentDoc}`;
export const LocationFragmentDoc = gql`
    fragment Location on location {
  id
  name
  properties
  active
  phoneNumber
  holidayRegionCode
  externalId
  address {
    line1
    line2
    city
    postcode
    country
  }
}
    `;
export const TemplateStationFragmentDoc = gql`
    fragment TemplateStation on readTemplateStations {
  id
  stationId
  stationName
  displayOrder
  positions {
    id
    displayOrder
    start
    end
    properties
    contractRoleId
    employeeId
    breaks {
      id
      start
      end
    }
    timeSlots {
      id
      start
      end
      properties
    }
  }
}
    `;
export const TemplateTagFragmentDoc = gql`
    fragment TemplateTag on readTemplateTag {
  id
  label
}
    `;
export const TemplateFragmentDoc = gql`
    fragment Template on readTemplate {
  id
  name
  weekday
  properties
  draft
  version
  baseTemplateId
  lastModified
  target {
    type
    value
  }
  location {
    ...Location
  }
  shiftOperatingHours {
    startTime
    endTime
    openTime
    closeTime
  }
  stations {
    ...TemplateStation
  }
  templateTags {
    ...TemplateTag
  }
}
    ${LocationFragmentDoc}
${TemplateStationFragmentDoc}
${TemplateTagFragmentDoc}`;
export const MinimalRosterMutationResultFragmentDoc = gql`
    fragment MinimalRosterMutationResult on minimalRosterResult {
  id
  rosterDate
  status
  lastModified
  publicationTime
}
    `;
export const MinimalTemplateMutationResultFragmentDoc = gql`
    fragment MinimalTemplateMutationResult on minimalTemplateResult {
  id
}
    `;
export const GetDevicesForLocationDocument = gql`
    query GetDevicesForLocation($id: Int) {
  devicesForLocation(locationId: $id) {
    id
    name
    activated
  }
}
    `;

export function useGetDevicesForLocationQuery(options?: Omit<Urql.UseQueryArgs<GetDevicesForLocationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDevicesForLocationQuery, GetDevicesForLocationQueryVariables>({ query: GetDevicesForLocationDocument, ...options });
};
export const GetDeviceByIdDocument = gql`
    query GetDeviceById($id: Guid) {
  device(id: $id) {
    id
    name
    activationId
    activationToken
    activated
  }
}
    `;

export function useGetDeviceByIdQuery(options?: Omit<Urql.UseQueryArgs<GetDeviceByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDeviceByIdQuery, GetDeviceByIdQueryVariables>({ query: GetDeviceByIdDocument, ...options });
};
export const CreateDeviceDocument = gql`
    mutation CreateDevice($args: createDevice!) {
  createDevice(device: $args) {
    id
    name
  }
}
    `;

export function useCreateDeviceMutation() {
  return Urql.useMutation<CreateDeviceMutation, CreateDeviceMutationVariables>(CreateDeviceDocument);
};
export const UpdateDeviceDocument = gql`
    mutation UpdateDevice($args: updateDevice!) {
  updateDevice(device: $args) {
    id
  }
}
    `;

export function useUpdateDeviceMutation() {
  return Urql.useMutation<UpdateDeviceMutation, UpdateDeviceMutationVariables>(UpdateDeviceDocument);
};
export const DeleteDeviceDocument = gql`
    mutation DeleteDevice($id: Guid!) {
  deleteDevice(id: $id) {
    id
  }
}
    `;

export function useDeleteDeviceMutation() {
  return Urql.useMutation<DeleteDeviceMutation, DeleteDeviceMutationVariables>(DeleteDeviceDocument);
};
export const ResetDeviceDocument = gql`
    mutation ResetDevice($id: Guid!) {
  resetDevice(id: $id) {
    id
  }
}
    `;

export function useResetDeviceMutation() {
  return Urql.useMutation<ResetDeviceMutation, ResetDeviceMutationVariables>(ResetDeviceDocument);
};
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($id: Int!) {
  deleteLocation(id: $id) {
    id
  }
}
    `;

export function useDeleteLocationMutation() {
  return Urql.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument);
};
export const GetPolicyAcceptanceDatesDocument = gql`
    query getPolicyAcceptanceDates {
  myEmployee {
    acceptedPrivacyPolicy
    acceptedTermsAndConditions
  }
}
    `;

export function useGetPolicyAcceptanceDatesQuery(options?: Omit<Urql.UseQueryArgs<GetPolicyAcceptanceDatesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPolicyAcceptanceDatesQuery, GetPolicyAcceptanceDatesQueryVariables>({ query: GetPolicyAcceptanceDatesDocument, ...options });
};
export const GetAllMyShiftsDocument = gql`
    query GetAllMyShifts {
  getAllMyWorkTimeRecord {
    risk
    start {
      dateTime
      origin
      geoLocation {
        latitude
        longitude
      }
    }
    end {
      dateTime
      origin
      geoLocation {
        latitude
        longitude
      }
    }
  }
}
    `;

export function useGetAllMyShiftsQuery(options?: Omit<Urql.UseQueryArgs<GetAllMyShiftsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAllMyShiftsQuery, GetAllMyShiftsQueryVariables>({ query: GetAllMyShiftsDocument, ...options });
};
export const GetMyPersonalInfoDocument = gql`
    query getMyPersonalInfo {
  gdpr_myPersonalInfo {
    acceptedPrivacyPolicy
    acceptedTermsAndConditions
    userName
    employeeLocations
    displayLanguage
    employeeSkills {
      rating
      taskName
    }
    contractModification
    roleId
    workingPattern {
      workingPattern {
        startTime
        endTime
        day
        dayOfWeek
        dayNumber
        available
        state
        updatedOn
        approvedOn
      }
    }
    availabilities {
      day
      start
      end
    }
    availabilityExceptions {
      date
      start
      end
      available
      approval
      approvedOn
      updatedOn
    }
    locations {
      name
      locationCoordinates {
        latitude
        longitude
      }
    }
    firstName
    lastName
    email
    identityId
    title
    role
    employeeId
    isRosterable
    phoneNumber
    contract {
      contractTypeId
      contractTypeName
      contractModificationName
      contractModificationId
    }
  }
}
    `;

export function useGetMyPersonalInfoQuery(options?: Omit<Urql.UseQueryArgs<GetMyPersonalInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMyPersonalInfoQuery, GetMyPersonalInfoQueryVariables>({ query: GetMyPersonalInfoDocument, ...options });
};
export const GetShiftsListDocument = gql`
    query GetShiftsList($queryWorkItemArgs: GetWorkTimeRecordsInRangeGT) {
  getWorkTimeRecord(queryWorkItemArgs: $queryWorkItemArgs) {
    id
    employee {
      identityId
      firstName
      lastName
      isDeleted
      isDeactivated
    }
    locationId
    risk
    start {
      dateTime
      origin
      geoLocation {
        longitude
        latitude
      }
      device {
        id
        name
      }
    }
    end {
      dateTime
      origin
      geoLocation {
        longitude
        latitude
      }
      device {
        id
        name
      }
    }
  }
}
    `;

export function useGetShiftsListQuery(options?: Omit<Urql.UseQueryArgs<GetShiftsListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetShiftsListQuery, GetShiftsListQueryVariables>({ query: GetShiftsListDocument, ...options });
};
export const GetMyShiftsListDocument = gql`
    query GetMyShiftsList($queryWorkItemArgs: GetMyWorkTimeRecordsInRangeGT) {
  getMyWorkTimeRecord(queryWorkItemArgs: $queryWorkItemArgs) {
    id
    employee {
      identityId
      firstName
      lastName
      isDeleted
      isDeactivated
    }
    locationId
    risk
    start {
      dateTime
      origin
      geoLocation {
        longitude
        latitude
      }
      device {
        id
        name
      }
    }
    end {
      dateTime
      origin
      geoLocation {
        longitude
        latitude
      }
      device {
        id
        name
      }
    }
  }
}
    `;

export function useGetMyShiftsListQuery(options?: Omit<Urql.UseQueryArgs<GetMyShiftsListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMyShiftsListQuery, GetMyShiftsListQueryVariables>({ query: GetMyShiftsListDocument, ...options });
};
export const UpdateShiftDocument = gql`
    mutation UpdateShift($change: CreateWorkTimeRecordChange!) {
  updateWorkTimeRecord(workTimeRecordChange: $change) {
    id
    risk
    start {
      dateTime
      origin
      geoLocation {
        longitude
        latitude
      }
      device {
        id
        name
      }
    }
    end {
      dateTime
      origin
      geoLocation {
        longitude
        latitude
      }
      device {
        id
        name
      }
    }
  }
}
    `;

export function useUpdateShiftMutation() {
  return Urql.useMutation<UpdateShiftMutation, UpdateShiftMutationVariables>(UpdateShiftDocument);
};
export const UpdateMyShiftDocument = gql`
    mutation UpdateMyShift($change: CreateWorkTimeRecordChange!) {
  updateMyWorkTimeRecord(workTimeRecordChange: $change) {
    id
    risk
    start {
      dateTime
      origin
      geoLocation {
        longitude
        latitude
      }
      device {
        id
        name
      }
    }
    end {
      dateTime
      origin
      geoLocation {
        longitude
        latitude
      }
      device {
        id
        name
      }
    }
  }
}
    `;

export function useUpdateMyShiftMutation() {
  return Urql.useMutation<UpdateMyShiftMutation, UpdateMyShiftMutationVariables>(UpdateMyShiftDocument);
};
export const GetCurrentWorkStatusForEmployeeDocument = gql`
    query GetCurrentWorkStatusForEmployee($employeeId: Guid) {
  getOpenWorkTimeRecord(queryOpenWorkItemArgs: {employeeId: $employeeId}) {
    ...BasicE
    ...StartE
  }
}
    ${BasicEFragmentDoc}
${StartEFragmentDoc}`;

export function useGetCurrentWorkStatusForEmployeeQuery(options?: Omit<Urql.UseQueryArgs<GetCurrentWorkStatusForEmployeeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetCurrentWorkStatusForEmployeeQuery, GetCurrentWorkStatusForEmployeeQueryVariables>({ query: GetCurrentWorkStatusForEmployeeDocument, ...options });
};
export const GetMyCurrentWorkStatusDocument = gql`
    query GetMyCurrentWorkStatus {
  getMyOpenWorkTimeRecord {
    ...BasicE
    ...StartE
    ...EndE
  }
}
    ${BasicEFragmentDoc}
${StartEFragmentDoc}
${EndEFragmentDoc}`;

export function useGetMyCurrentWorkStatusQuery(options?: Omit<Urql.UseQueryArgs<GetMyCurrentWorkStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMyCurrentWorkStatusQuery, GetMyCurrentWorkStatusQueryVariables>({ query: GetMyCurrentWorkStatusDocument, ...options });
};
export const StartMyWorkTimeRecordDocument = gql`
    mutation StartMyWorkTimeRecord($workTimeRecordStart: StartMyWorkTimeRecord!) {
  startMyWorkTimeRecord(workTimeRecordStart: $workTimeRecordStart) {
    ...Basic
    ...Start
  }
}
    ${BasicFragmentDoc}
${StartFragmentDoc}`;

export function useStartMyWorkTimeRecordMutation() {
  return Urql.useMutation<StartMyWorkTimeRecordMutation, StartMyWorkTimeRecordMutationVariables>(StartMyWorkTimeRecordDocument);
};
export const EndMyWorkTimeRecordDocument = gql`
    mutation EndMyWorkTimeRecord($workTimeRecordEnd: EndMyWorkTimeRecord!) {
  endMyWorkTimeRecord(workTimeRecordEnd: $workTimeRecordEnd) {
    ...Basic
    ...End
  }
}
    ${BasicFragmentDoc}
${EndFragmentDoc}`;

export function useEndMyWorkTimeRecordMutation() {
  return Urql.useMutation<EndMyWorkTimeRecordMutation, EndMyWorkTimeRecordMutationVariables>(EndMyWorkTimeRecordDocument);
};
export const StartWorkTimeRecordDocument = gql`
    mutation StartWorkTimeRecord($workTimeRecordStart: StartWorkTimeRecord!) {
  startWorkTimeRecord(workTimeRecordStart: $workTimeRecordStart) {
    ...Basic
    ...Start
  }
}
    ${BasicFragmentDoc}
${StartFragmentDoc}`;

export function useStartWorkTimeRecordMutation() {
  return Urql.useMutation<StartWorkTimeRecordMutation, StartWorkTimeRecordMutationVariables>(StartWorkTimeRecordDocument);
};
export const EndWorkTimeRecordDocument = gql`
    mutation EndWorkTimeRecord($workTimeRecordEnd: EndWorkTimeRecord!) {
  endWorkTimeRecord(workTimeRecordEnd: $workTimeRecordEnd) {
    ...Basic
    ...End
  }
}
    ${BasicFragmentDoc}
${EndFragmentDoc}`;

export function useEndWorkTimeRecordMutation() {
  return Urql.useMutation<EndWorkTimeRecordMutation, EndWorkTimeRecordMutationVariables>(EndWorkTimeRecordDocument);
};
export const GetOpenWorkRecordsDocument = gql`
    query GetOpenWorkRecords($args: GetWorkTimeRecordsGT) {
  getOpenWorkTimeRecord(queryOpenWorkItemArgs: $args) {
    id
    locationId
    employee {
      identityId
      firstName
      lastName
    }
    start {
      dateTime
      origin
      geoLocation {
        longitude
        latitude
      }
    }
    risk
  }
}
    `;

export function useGetOpenWorkRecordsQuery(options?: Omit<Urql.UseQueryArgs<GetOpenWorkRecordsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOpenWorkRecordsQuery, GetOpenWorkRecordsQueryVariables>({ query: GetOpenWorkRecordsDocument, ...options });
};
export const GetMyOpenWorkRecordsDocument = gql`
    query GetMyOpenWorkRecords($args: GetMyWorkTimeRecordsGT) {
  getMyOpenWorkTimeRecord(queryOpenWorkItemArgs: $args) {
    id
    locationId
    employee {
      identityId
      firstName
      lastName
    }
    start {
      dateTime
      origin
      geoLocation {
        longitude
        latitude
      }
    }
    risk
  }
}
    `;

export function useGetMyOpenWorkRecordsQuery(options?: Omit<Urql.UseQueryArgs<GetMyOpenWorkRecordsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMyOpenWorkRecordsQuery, GetMyOpenWorkRecordsQueryVariables>({ query: GetMyOpenWorkRecordsDocument, ...options });
};
export const MyAvailabilityExceptionsDocument = gql`
    query MyAvailabilityExceptions($dateRange: myAvailabilityExceptionsDateRange) {
  myAvailabilityExceptions(dateRange: $dateRange) {
    exceptions {
      ...Exception
    }
  }
}
    ${ExceptionFragmentDoc}`;

export function useMyAvailabilityExceptionsQuery(options?: Omit<Urql.UseQueryArgs<MyAvailabilityExceptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<MyAvailabilityExceptionsQuery, MyAvailabilityExceptionsQueryVariables>({ query: MyAvailabilityExceptionsDocument, ...options });
};
export const AvailabilityExceptionsForEmployeeDocument = gql`
    query AvailabilityExceptionsForEmployee($userId: Guid!, $startDate: DateOnly!, $endDate: DateOnly!) {
  availabilityExceptions(
    availabilityExceptions: {employeeIds: [$userId], start: $startDate, end: $endDate}
  ) {
    ...Exception
  }
}
    ${ExceptionFragmentDoc}`;

export function useAvailabilityExceptionsForEmployeeQuery(options: Omit<Urql.UseQueryArgs<AvailabilityExceptionsForEmployeeQueryVariables>, 'query'>) {
  return Urql.useQuery<AvailabilityExceptionsForEmployeeQuery, AvailabilityExceptionsForEmployeeQueryVariables>({ query: AvailabilityExceptionsForEmployeeDocument, ...options });
};
export const UpdateAvailabilityExceptionsDocument = gql`
    mutation UpdateAvailabilityExceptions($exceptions: updateAvailabilityExceptionsInDateRange!) {
  updateAvailabilityExceptionsInDateRange(exceptions: $exceptions) {
    id
    employeeId
    date
    available
    start
    end
    approval
  }
}
    `;

export function useUpdateAvailabilityExceptionsMutation() {
  return Urql.useMutation<UpdateAvailabilityExceptionsMutation, UpdateAvailabilityExceptionsMutationVariables>(UpdateAvailabilityExceptionsDocument);
};
export const EmployeeWorkingPatternDocument = gql`
    query EmployeeWorkingPattern($date: DateOnly) {
  employeeWorkingPatterns(dateAndPeriods: {date: $date, periods: 1}) {
    periods {
      patterns {
        ...Pattern
      }
    }
  }
}
    ${PatternFragmentDoc}`;

export function useEmployeeWorkingPatternQuery(options?: Omit<Urql.UseQueryArgs<EmployeeWorkingPatternQueryVariables>, 'query'>) {
  return Urql.useQuery<EmployeeWorkingPatternQuery, EmployeeWorkingPatternQueryVariables>({ query: EmployeeWorkingPatternDocument, ...options });
};
export const ApproveAndApplyAvailabilitiesDocument = gql`
    mutation ApproveAndApplyAvailabilities($applyAvailabilities: applyAvailabilities!) {
  approveAndApplyAvailabilities(applyAvailabilities: $applyAvailabilities)
}
    `;

export function useApproveAndApplyAvailabilitiesMutation() {
  return Urql.useMutation<ApproveAndApplyAvailabilitiesMutation, ApproveAndApplyAvailabilitiesMutationVariables>(ApproveAndApplyAvailabilitiesDocument);
};
export const LocationWorkingPatternsDocument = gql`
    query LocationWorkingPatterns($locationId: Int!, $date: DateOnly) {
  locationWorkingPatterns(
    locationAndPeriod: {locationId: $locationId, date: $date, periods: 1}
  ) {
    employeePatterns {
      identityId
      periods {
        patterns {
          ...Pattern
        }
      }
    }
  }
}
    ${PatternFragmentDoc}`;

export function useLocationWorkingPatternsQuery(options: Omit<Urql.UseQueryArgs<LocationWorkingPatternsQueryVariables>, 'query'>) {
  return Urql.useQuery<LocationWorkingPatternsQuery, LocationWorkingPatternsQueryVariables>({ query: LocationWorkingPatternsDocument, ...options });
};
export const LocationExceptionsDocument = gql`
    query LocationExceptions($locationId: Int!, $startDate: DateOnly!, $endDate: DateOnly!) {
  locationAvailabilityExceptions(
    locationDates: {locationId: $locationId, start: $startDate, end: $endDate}
  ) {
    employeeAvailabilityExceptions {
      employeeId
      patternsAndExceptions {
        patterns {
          ...Pattern
        }
        exceptions {
          ...Exception
        }
      }
    }
  }
}
    ${PatternFragmentDoc}
${ExceptionFragmentDoc}`;

export function useLocationExceptionsQuery(options: Omit<Urql.UseQueryArgs<LocationExceptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<LocationExceptionsQuery, LocationExceptionsQueryVariables>({ query: LocationExceptionsDocument, ...options });
};
export const SearchAvailabilitiesDocument = gql`
    query SearchAvailabilities($search: searchAvailabilities!) {
  searchAvailabilities(search: $search) {
    location {
      ...Location
    }
    availabilities {
      start
      end
      employeeId
      firstName
      lastName
      role
    }
  }
}
    ${LocationFragmentDoc}`;

export function useSearchAvailabilitiesQuery(options: Omit<Urql.UseQueryArgs<SearchAvailabilitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchAvailabilitiesQuery, SearchAvailabilitiesQueryVariables>({ query: SearchAvailabilitiesDocument, ...options });
};
export const UpdateWorkingPatternsDocument = gql`
    mutation UpdateWorkingPatterns($workingPatterns: [updateEmployeeWorkingPatterns]!) {
  updateWorkingPatterns(workingPatterns: {employeePatterns: $workingPatterns})
}
    `;

export function useUpdateWorkingPatternsMutation() {
  return Urql.useMutation<UpdateWorkingPatternsMutation, UpdateWorkingPatternsMutationVariables>(UpdateWorkingPatternsDocument);
};
export const DeleteAvailabilityExceptionDocument = gql`
    mutation DeleteAvailabilityException($employeeId: Guid!, $date: DateOnly!) {
  deleteAvailabilityExceptions(
    exceptionDetails: {employeeId: $employeeId, date: $date}
  ) {
    id
  }
}
    `;

export function useDeleteAvailabilityExceptionMutation() {
  return Urql.useMutation<DeleteAvailabilityExceptionMutation, DeleteAvailabilityExceptionMutationVariables>(DeleteAvailabilityExceptionDocument);
};
export const GetContractsDocument = gql`
    query GetContracts {
  readContracts {
    ...Contract
  }
}
    ${ContractFragmentDoc}`;

export function useGetContractsQuery(options?: Omit<Urql.UseQueryArgs<GetContractsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetContractsQuery, GetContractsQueryVariables>({ query: GetContractsDocument, ...options });
};
export const GetContractDocument = gql`
    query GetContract($id: Guid!) {
  readContract(id: $id) {
    ...Contract
  }
}
    ${ContractFragmentDoc}`;

export function useGetContractQuery(options: Omit<Urql.UseQueryArgs<GetContractQueryVariables>, 'query'>) {
  return Urql.useQuery<GetContractQuery, GetContractQueryVariables>({ query: GetContractDocument, ...options });
};
export const CreateContractDocument = gql`
    mutation CreateContract($contract: createContract!) {
  createContract(contract: $contract) {
    ...Contract
  }
}
    ${ContractFragmentDoc}`;

export function useCreateContractMutation() {
  return Urql.useMutation<CreateContractMutation, CreateContractMutationVariables>(CreateContractDocument);
};
export const UpdateContractDocument = gql`
    mutation UpdateContract($contract: updateContract!) {
  updateContract(contract: $contract)
}
    `;

export function useUpdateContractMutation() {
  return Urql.useMutation<UpdateContractMutation, UpdateContractMutationVariables>(UpdateContractDocument);
};
export const DeleteContractDocument = gql`
    mutation DeleteContract($id: Guid!) {
  deleteContract(id: $id)
}
    `;

export function useDeleteContractMutation() {
  return Urql.useMutation<DeleteContractMutation, DeleteContractMutationVariables>(DeleteContractDocument);
};
export const UpdateContractRolesDocument = gql`
    mutation UpdateContractRoles($contractRoles: updateContractRoles!) {
  updateContractRoles(contractRoles: $contractRoles) {
    ...ContractRoles
  }
}
    ${ContractRolesFragmentDoc}`;

export function useUpdateContractRolesMutation() {
  return Urql.useMutation<UpdateContractRolesMutation, UpdateContractRolesMutationVariables>(UpdateContractRolesDocument);
};
export const GetEmployeeSummariesDocument = gql`
    query GetEmployeeSummaries($contractTypeId: Guid!) {
  employeeSummariesByContractTypeId(contractTypeId: $contractTypeId) {
    identityId
    employeeId
    firstName
    lastName
    locations {
      id
      name
    }
    homeLocationId
  }
}
    `;

export function useGetEmployeeSummariesQuery(options: Omit<Urql.UseQueryArgs<GetEmployeeSummariesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEmployeeSummariesQuery, GetEmployeeSummariesQueryVariables>({ query: GetEmployeeSummariesDocument, ...options });
};
export const GetEmployeeSummariesByContractRoleDocument = gql`
    query GetEmployeeSummariesByContractRole($contractRoleId: Guid!) {
  employeeSummariesByContractRoleId(contractRoleId: $contractRoleId) {
    identityId
    employeeId
    firstName
    lastName
    locations {
      id
      name
    }
    homeLocationId
  }
}
    `;

export function useGetEmployeeSummariesByContractRoleQuery(options: Omit<Urql.UseQueryArgs<GetEmployeeSummariesByContractRoleQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEmployeeSummariesByContractRoleQuery, GetEmployeeSummariesByContractRoleQueryVariables>({ query: GetEmployeeSummariesByContractRoleDocument, ...options });
};
export const GetTemplateSummaryByContractRoleDocument = gql`
    query GetTemplateSummaryByContractRole($contractRoleId: Guid!) {
  templateSummariesByContractRoleId(contractRoleId: $contractRoleId) {
    id
    name
    location {
      id
      name
    }
    version
  }
}
    `;

export function useGetTemplateSummaryByContractRoleQuery(options: Omit<Urql.UseQueryArgs<GetTemplateSummaryByContractRoleQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTemplateSummaryByContractRoleQuery, GetTemplateSummaryByContractRoleQueryVariables>({ query: GetTemplateSummaryByContractRoleDocument, ...options });
};
export const GetEmployeesAssignedToRolesInContractDocument = gql`
    query GetEmployeesAssignedToRolesInContract($contractId: Guid!) {
  employeesAssignedToRolesInContract(contractId: $contractId) {
    identityId
    firstName
    lastName
    employeeId
    role
    homeLocationId
    contractRoleId
    contract {
      contractTypeId
    }
  }
}
    `;

export function useGetEmployeesAssignedToRolesInContractQuery(options: Omit<Urql.UseQueryArgs<GetEmployeesAssignedToRolesInContractQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEmployeesAssignedToRolesInContractQuery, GetEmployeesAssignedToRolesInContractQueryVariables>({ query: GetEmployeesAssignedToRolesInContractDocument, ...options });
};
export const GetHolidaysDocument = gql`
    query GetHolidays($start: DateOnly!, $end: DateOnly!, $holidayRegionCode: String!) {
  holidays(
    holidays: {start: $start, end: $end, holidayRegionCode: $holidayRegionCode}
  ) {
    holidays {
      name
      date
      holidayRegionCode
    }
  }
}
    `;

export function useGetHolidaysQuery(options: Omit<Urql.UseQueryArgs<GetHolidaysQueryVariables>, 'query'>) {
  return Urql.useQuery<GetHolidaysQuery, GetHolidaysQueryVariables>({ query: GetHolidaysDocument, ...options });
};
export const CreateLeaveTypesDocument = gql`
    mutation CreateLeaveTypes($leaveTypes: [createLeaveType]!) {
  createLeaveTypes(leaveTypes: $leaveTypes)
}
    `;

export function useCreateLeaveTypesMutation() {
  return Urql.useMutation<CreateLeaveTypesMutation, CreateLeaveTypesMutationVariables>(CreateLeaveTypesDocument);
};
export const CreateLeaveTypeDocument = gql`
    mutation CreateLeaveType($leaveType: createLeaveType!) {
  createLeaveType(leaveType: $leaveType) {
    ...LeaveType
  }
}
    ${LeaveTypeFragmentDoc}`;

export function useCreateLeaveTypeMutation() {
  return Urql.useMutation<CreateLeaveTypeMutation, CreateLeaveTypeMutationVariables>(CreateLeaveTypeDocument);
};
export const UpdateLeaveTypesDocument = gql`
    mutation UpdateLeaveTypes($leaveTypes: [updateLeaveType]!) {
  updateLeaveTypes(leaveTypes: $leaveTypes)
}
    `;

export function useUpdateLeaveTypesMutation() {
  return Urql.useMutation<UpdateLeaveTypesMutation, UpdateLeaveTypesMutationVariables>(UpdateLeaveTypesDocument);
};
export const UpdateLeaveTypeDocument = gql`
    mutation UpdateLeaveType($leaveType: updateLeaveType!) {
  updateLeaveType(leaveType: $leaveType) {
    ...LeaveType
  }
}
    ${LeaveTypeFragmentDoc}`;

export function useUpdateLeaveTypeMutation() {
  return Urql.useMutation<UpdateLeaveTypeMutation, UpdateLeaveTypeMutationVariables>(UpdateLeaveTypeDocument);
};
export const DeleteLeaveTypesDocument = gql`
    mutation DeleteLeaveTypes($ids: [Guid]!) {
  deleteLeaveTypes(ids: $ids)
}
    `;

export function useDeleteLeaveTypesMutation() {
  return Urql.useMutation<DeleteLeaveTypesMutation, DeleteLeaveTypesMutationVariables>(DeleteLeaveTypesDocument);
};
export const GetLeaveTypesDocument = gql`
    query GetLeaveTypes {
  leaveTypes {
    ...LeaveType
  }
}
    ${LeaveTypeFragmentDoc}`;

export function useGetLeaveTypesQuery(options?: Omit<Urql.UseQueryArgs<GetLeaveTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLeaveTypesQuery, GetLeaveTypesQueryVariables>({ query: GetLeaveTypesDocument, ...options });
};
export const GetLeaveTypeDocument = gql`
    query GetLeaveType($id: Guid!) {
  leaveType(id: $id) {
    ...LeaveType
  }
}
    ${LeaveTypeFragmentDoc}`;

export function useGetLeaveTypeQuery(options: Omit<Urql.UseQueryArgs<GetLeaveTypeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLeaveTypeQuery, GetLeaveTypeQueryVariables>({ query: GetLeaveTypeDocument, ...options });
};
export const LeaveTypeDeleteValidationDocument = gql`
    query LeaveTypeDeleteValidation($leaveTypeId: Guid!, $boundaryDate: DateOnly!) {
  leaveTypeDeleteValidation(
    leaveTypeId: $leaveTypeId
    boundaryDate: $boundaryDate
  ) {
    hasUsagesBeforeBoundary
    usagesOnOrAfterBoundary {
      availabilityExceptionId
      employeeId
      date
      locationId
    }
  }
}
    `;

export function useLeaveTypeDeleteValidationQuery(options: Omit<Urql.UseQueryArgs<LeaveTypeDeleteValidationQueryVariables>, 'query'>) {
  return Urql.useQuery<LeaveTypeDeleteValidationQuery, LeaveTypeDeleteValidationQueryVariables>({ query: LeaveTypeDeleteValidationDocument, ...options });
};
export const GetLocationsDocument = gql`
    query GetLocations {
  locations {
    ...Location
    locationCoordinates {
      locationName
      latitude
      longitude
    }
  }
}
    ${LocationFragmentDoc}`;

export function useGetLocationsQuery(options?: Omit<Urql.UseQueryArgs<GetLocationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLocationsQuery, GetLocationsQueryVariables>({ query: GetLocationsDocument, ...options });
};
export const AddApprovedLocationsDocument = gql`
    mutation AddApprovedLocations($location: updateLocation!) {
  updateLocation(location: $location) {
    name
    id
    locationCoordinates {
      locationName
      latitude
      longitude
    }
  }
}
    `;

export function useAddApprovedLocationsMutation() {
  return Urql.useMutation<AddApprovedLocationsMutation, AddApprovedLocationsMutationVariables>(AddApprovedLocationsDocument);
};
export const CreateLocationDocument = gql`
    mutation CreateLocation($location: createLocation!) {
  createLocation(location: $location) {
    id
    name
    holidayRegionCode
    locationCoordinates {
      locationName
      longitude
      latitude
    }
  }
}
    `;

export function useCreateLocationMutation() {
  return Urql.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument);
};
export const CreateLocationCoordinatesDocument = gql`
    mutation CreateLocationCoordinates($locationCoordinates: newLocationCoordinates!) {
  createLocationCoordinates(locationCoordinates: $locationCoordinates) {
    id
    locationName
    locationId
    longitude
    latitude
  }
}
    `;

export function useCreateLocationCoordinatesMutation() {
  return Urql.useMutation<CreateLocationCoordinatesMutation, CreateLocationCoordinatesMutationVariables>(CreateLocationCoordinatesDocument);
};
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($location: updateLocation!) {
  updateLocation(location: $location) {
    id
    name
    holidayRegionCode
  }
}
    `;

export function useUpdateLocationMutation() {
  return Urql.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument);
};
export const GetSupportedHolidayRegionsDocument = gql`
    query GetSupportedHolidayRegions {
  supportedHolidayRegions {
    code
    displayName
  }
}
    `;

export function useGetSupportedHolidayRegionsQuery(options?: Omit<Urql.UseQueryArgs<GetSupportedHolidayRegionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSupportedHolidayRegionsQuery, GetSupportedHolidayRegionsQueryVariables>({ query: GetSupportedHolidayRegionsDocument, ...options });
};
export const GetMeDocument = gql`
    query getMe {
  myEmployee {
    identityId
    employeeId
    avatarUrl
    email
    role
    phoneNumber
    firstName
    lastName
    isRosterable
    isDeleted
    isDeactivated
    homeLocationId
    contract {
      contractTypeId
      contractModificationId
    }
    contractRoleId
    hireDate
    properties
    personas {
      id
      name
      management
      templateLibrarian
    }
    locations {
      id
      name
      properties
    }
  }
}
    `;

export function useGetMeQuery(options?: Omit<Urql.UseQueryArgs<GetMeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMeQuery, GetMeQueryVariables>({ query: GetMeDocument, ...options });
};
export const GetBatchJobStatusDocument = gql`
    query GetBatchJobStatus($id: Guid!, $start: DateOnly!, $end: DateOnly!) {
  batchJobStatusForManager(
    managerIdAndDateRange: {managerId: $id, dateRangeStart: $start, dateRangeEnd: $end}
  ) {
    locationStatuses {
      locationId
      name
      statuses {
        date
        status
      }
    }
  }
}
    `;

export function useGetBatchJobStatusQuery(options: Omit<Urql.UseQueryArgs<GetBatchJobStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBatchJobStatusQuery, GetBatchJobStatusQueryVariables>({ query: GetBatchJobStatusDocument, ...options });
};
export const OptimiserBatchDocument = gql`
    subscription OptimiserBatch {
  batchJobStateChange {
    id
    date
    started
    finished
    properties
    changeType
    batchId
  }
}
    `;

export function useOptimiserBatchSubscription<TData = OptimiserBatchSubscription>(options: Omit<Urql.UseSubscriptionArgs<OptimiserBatchSubscriptionVariables>, 'query'> = {}, handler?: Urql.SubscriptionHandler<OptimiserBatchSubscription, TData>) {
  return Urql.useSubscription<OptimiserBatchSubscription, TData, OptimiserBatchSubscriptionVariables>({ query: OptimiserBatchDocument, ...options }, handler);
};
export const GetOrganisationHierarchyDocument = gql`
    query GetOrganisationHierarchy {
  getOrganisationHierarchy {
    id
    divisionId
    name
    level
    locations {
      id
      name
      properties
    }
    children {
      id
      name
      divisionId
      level
      locations {
        id
        name
        properties
      }
      children {
        id
        name
        divisionId
        level
        locations {
          id
          name
          properties
        }
        children {
          id
          name
          divisionId
          level
          locations {
            id
            name
            properties
          }
        }
      }
    }
  }
}
    `;

export function useGetOrganisationHierarchyQuery(options?: Omit<Urql.UseQueryArgs<GetOrganisationHierarchyQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganisationHierarchyQuery, GetOrganisationHierarchyQueryVariables>({ query: GetOrganisationHierarchyDocument, ...options });
};
export const GetPersonaDocument = gql`
    query GetPersona($id: Guid!) {
  persona(id: $id) {
    ...Persona
  }
}
    ${PersonaFragmentDoc}`;

export function useGetPersonaQuery(options: Omit<Urql.UseQueryArgs<GetPersonaQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPersonaQuery, GetPersonaQueryVariables>({ query: GetPersonaDocument, ...options });
};
export const GetPersonasDocument = gql`
    query GetPersonas {
  personas {
    ...Persona
  }
}
    ${PersonaFragmentDoc}`;

export function useGetPersonasQuery(options?: Omit<Urql.UseQueryArgs<GetPersonasQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPersonasQuery, GetPersonasQueryVariables>({ query: GetPersonasDocument, ...options });
};
export const CreatePersonasDocument = gql`
    mutation CreatePersonas($personas: [createPersona]!) {
  createPersonas(personas: $personas) {
    ...Persona
  }
}
    ${PersonaFragmentDoc}`;

export function useCreatePersonasMutation() {
  return Urql.useMutation<CreatePersonasMutation, CreatePersonasMutationVariables>(CreatePersonasDocument);
};
export const UpdatePersonasDocument = gql`
    mutation UpdatePersonas($personas: [updatePersona]!) {
  updatePersonas(personas: $personas) {
    ...Persona
  }
}
    ${PersonaFragmentDoc}`;

export function useUpdatePersonasMutation() {
  return Urql.useMutation<UpdatePersonasMutation, UpdatePersonasMutationVariables>(UpdatePersonasDocument);
};
export const DeletePersonasDocument = gql`
    mutation DeletePersonas($personaIds: [Guid]!) {
  deletePersonas(ids: $personaIds)
}
    `;

export function useDeletePersonasMutation() {
  return Urql.useMutation<DeletePersonasMutation, DeletePersonasMutationVariables>(DeletePersonasDocument);
};
export const GetRostersOverviewDocument = gql`
    query getRostersOverview($locationId: Int!, $startDate: DateOnly!, $endDate: DateOnly!) {
  rostersInDateRange(
    restaurantAndDateRange: {locationId: $locationId, dateRangeStart: $startDate, dateRangeEnd: $endDate}
  ) {
    id
    rosterDate
    status
    lastModified
    publicationTime
  }
}
    `;

export function useGetRostersOverviewQuery(options: Omit<Urql.UseQueryArgs<GetRostersOverviewQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRostersOverviewQuery, GetRostersOverviewQueryVariables>({ query: GetRostersOverviewDocument, ...options });
};
export const GetRosterPropertiesDocument = gql`
    query getRosterProperties($locationId: Int!, $startDate: DateOnly!, $endDate: DateOnly!) {
  rostersInDateRange(
    restaurantAndDateRange: {locationId: $locationId, dateRangeStart: $startDate, dateRangeEnd: $endDate}
  ) {
    rosterDate
    properties
  }
}
    `;

export function useGetRosterPropertiesQuery(options: Omit<Urql.UseQueryArgs<GetRosterPropertiesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRosterPropertiesQuery, GetRosterPropertiesQueryVariables>({ query: GetRosterPropertiesDocument, ...options });
};
export const GetFullRostersDocument = gql`
    query getFullRosters($locationId: Int!, $startDate: DateOnly!, $endDate: DateOnly!) {
  rostersWithPositionsAndTasksInDateRange(
    locationAndDateRange: {locationId: $locationId, dateRangeStart: $startDate, dateRangeEnd: $endDate}
  ) {
    id
    rosterDate
    status
    lastModified
    publicationTime
    templateName
    templateId
    properties
    ...OperatingHours
    ...Stations
  }
}
    ${OperatingHoursFragmentDoc}
${StationsFragmentDoc}`;

export function useGetFullRostersQuery(options: Omit<Urql.UseQueryArgs<GetFullRostersQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFullRostersQuery, GetFullRostersQueryVariables>({ query: GetFullRostersDocument, ...options });
};
export const GetRosterDocument = gql`
    query getRoster($id: Guid!) {
  roster(id: $id) {
    id
    rosterDate
    status
    lastModified
    publicationTime
    templateId
    templateName
    isHoliday
    properties
    location {
      ...Location
    }
    ...OperatingHours
    ...Stations
  }
}
    ${LocationFragmentDoc}
${OperatingHoursFragmentDoc}
${StationsFragmentDoc}`;

export function useGetRosterQuery(options: Omit<Urql.UseQueryArgs<GetRosterQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRosterQuery, GetRosterQueryVariables>({ query: GetRosterDocument, ...options });
};
export const GetRosteredStaffInDateRangeDocument = gql`
    query getRosteredStaffInDateRange($locationId: Int!, $startDate: DateOnly, $endDate: DateOnly) {
  rosteredStaffInDateRange(
    restaurantAndDateRange: {locationId: $locationId, dateRangeStart: $startDate, dateRangeEnd: $endDate}
  ) {
    identityId
    date
    start
    end
    breaks {
      id
      start
      end
    }
    properties
    ...TimeSlotsPosition
  }
}
    ${TimeSlotsPositionFragmentDoc}`;

export function useGetRosteredStaffInDateRangeQuery(options: Omit<Urql.UseQueryArgs<GetRosteredStaffInDateRangeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRosteredStaffInDateRangeQuery, GetRosteredStaffInDateRangeQueryVariables>({ query: GetRosteredStaffInDateRangeDocument, ...options });
};
export const GetLeftCompanyShiftsDocument = gql`
    query GetLeftCompanyShifts($locationId: Int!, $startDate: DateOnly!) {
  rosteredStaffAfterLeaveDate(
    rosteredStaffAfterLeave: {locationIds: [$locationId], dateRangeStart: $startDate}
  ) {
    identityId
    dates
  }
}
    `;

export function useGetLeftCompanyShiftsQuery(options: Omit<Urql.UseQueryArgs<GetLeftCompanyShiftsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLeftCompanyShiftsQuery, GetLeftCompanyShiftsQueryVariables>({ query: GetLeftCompanyShiftsDocument, ...options });
};
export const GetRosterStatusesDocument = gql`
    query getRosterStatuses($dateRangeAndLocations: rosterStatuses!) {
  rosterStatuses(dateRangeAndLocations: $dateRangeAndLocations) {
    locationId
    rosterId
    rosterDate
    status
  }
}
    `;

export function useGetRosterStatusesQuery(options: Omit<Urql.UseQueryArgs<GetRosterStatusesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRosterStatusesQuery, GetRosterStatusesQueryVariables>({ query: GetRosterStatusesDocument, ...options });
};
export const GetDayShiftsDocument = gql`
    query getDayShifts($dateAndIdentityIds: dayShifts!) {
  dayShifts(dateAndIdentityIds: $dateAndIdentityIds) {
    identityId
    ...Shifts
  }
}
    ${ShiftsFragmentDoc}`;

export function useGetDayShiftsQuery(options: Omit<Urql.UseQueryArgs<GetDayShiftsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetDayShiftsQuery, GetDayShiftsQueryVariables>({ query: GetDayShiftsDocument, ...options });
};
export const CreateRosterDocument = gql`
    mutation createRoster($templateId: ID!, $date: DateOnly!, $locationId: Int!) {
  createRosterFromTemplate(
    rosterCreationDetails: {templateId: $templateId, rosterDate: $date, locationId: $locationId}
  ) {
    ...MinimalRosterMutationResult
  }
}
    ${MinimalRosterMutationResultFragmentDoc}`;

export function useCreateRosterMutation() {
  return Urql.useMutation<CreateRosterMutation, CreateRosterMutationVariables>(CreateRosterDocument);
};
export const UpdateRosterDocument = gql`
    mutation UpdateRoster($updateRoster: updateRoster!) {
  updateRoster(roster: $updateRoster) {
    ...MinimalRosterMutationResult
  }
}
    ${MinimalRosterMutationResultFragmentDoc}`;

export function useUpdateRosterMutation() {
  return Urql.useMutation<UpdateRosterMutation, UpdateRosterMutationVariables>(UpdateRosterDocument);
};
export const SetNotificationsDocument = gql`
    mutation SetNotifications($notifications: [updateNotification]!) {
  updateNotifications(notifications: $notifications)
}
    `;

export function useSetNotificationsMutation() {
  return Urql.useMutation<SetNotificationsMutation, SetNotificationsMutationVariables>(SetNotificationsDocument);
};
export const DeleteNotificationsDocument = gql`
    mutation DeleteNotifications($notifications: [Guid]!) {
  deleteNotifications(notifications: $notifications)
}
    `;

export function useDeleteNotificationsMutation() {
  return Urql.useMutation<DeleteNotificationsMutation, DeleteNotificationsMutationVariables>(DeleteNotificationsDocument);
};
export const PushNotificationsDocument = gql`
    mutation PushNotifications($notifications: pushNotifications!) {
  pushNotifications(notifications: $notifications)
}
    `;

export function usePushNotificationsMutation() {
  return Urql.useMutation<PushNotificationsMutation, PushNotificationsMutationVariables>(PushNotificationsDocument);
};
export const GetNotificationsDocument = gql`
    query GetNotifications($notifications: getNotifications!) {
  locationNotificationsForDateRange(notifications: $notifications) {
    id
    locationId
    date
    triggerType
    value
    properties
  }
}
    `;

export function useGetNotificationsQuery(options: Omit<Urql.UseQueryArgs<GetNotificationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>({ query: GetNotificationsDocument, ...options });
};
export const AddDummyTaskDocument = gql`
    mutation AddDummyTask($rosterId: Guid!, $stationId: Guid!) {
  addRosterTask(
    addRosterTask: {rosterId: $rosterId, rosterStationId: $stationId, taskId: 1}
  ) {
    id
  }
}
    `;

export function useAddDummyTaskMutation() {
  return Urql.useMutation<AddDummyTaskMutation, AddDummyTaskMutationVariables>(AddDummyTaskDocument);
};
export const PublishRosterDocument = gql`
    mutation PublishRoster($rosterId: Guid!) {
  completeRoster(rosterId: $rosterId) {
    lastModified
  }
}
    `;

export function usePublishRosterMutation() {
  return Urql.useMutation<PublishRosterMutation, PublishRosterMutationVariables>(PublishRosterDocument);
};
export const DeleteRosterDocument = gql`
    mutation DeleteRoster($rosterId: Guid!) {
  deleteRoster(id: $rosterId)
}
    `;

export function useDeleteRosterMutation() {
  return Urql.useMutation<DeleteRosterMutation, DeleteRosterMutationVariables>(DeleteRosterDocument);
};
export const SetRosterStatusesDocument = gql`
    mutation SetRosterStatuses($updateStatuses: updateRosterStatuses!) {
  setRosterStatuses(rosterStatuses: $updateStatuses)
}
    `;

export function useSetRosterStatusesMutation() {
  return Urql.useMutation<SetRosterStatusesMutation, SetRosterStatusesMutationVariables>(SetRosterStatusesDocument);
};
export const FindShiftsDocument = gql`
    query FindShifts($searchParams: findShiftsByProperty!) {
  findShiftsByProperty(searchParams: $searchParams) {
    locationId
    locationName
    ...FoundShifts
  }
}
    ${FoundShiftsFragmentDoc}`;

export function useFindShiftsQuery(options: Omit<Urql.UseQueryArgs<FindShiftsQueryVariables>, 'query'>) {
  return Urql.useQuery<FindShiftsQuery, FindShiftsQueryVariables>({ query: FindShiftsDocument, ...options });
};
export const FindReassignedShiftsInDateRangeDocument = gql`
    query FindReassignedShiftsInDateRange($searchParams: findReassignedShiftsInDateRange!) {
  findReassignedShiftsInDateRange(searchParams: $searchParams) {
    locationId
    locationName
    ...FoundShiftsDateRange
  }
}
    ${FoundShiftsDateRangeFragmentDoc}`;

export function useFindReassignedShiftsInDateRangeQuery(options: Omit<Urql.UseQueryArgs<FindReassignedShiftsInDateRangeQueryVariables>, 'query'>) {
  return Urql.useQuery<FindReassignedShiftsInDateRangeQuery, FindReassignedShiftsInDateRangeQueryVariables>({ query: FindReassignedShiftsInDateRangeDocument, ...options });
};
export const AssignEmployeesToPositionsDocument = gql`
    mutation AssignEmployeesToPositions($positionAndEmployeePairs: [assignPositionEmployee]!) {
  assignEmployeesToPositions(positionAndEmployeePairs: $positionAndEmployeePairs)
}
    `;

export function useAssignEmployeesToPositionsMutation() {
  return Urql.useMutation<AssignEmployeesToPositionsMutation, AssignEmployeesToPositionsMutationVariables>(AssignEmployeesToPositionsDocument);
};
export const SetPositionPropertiesDocument = gql`
    mutation SetPositionProperties($idAndPropertiesPairs: [setPositionProperties]!) {
  setPositionProperties(idAndPropertiesPairs: $idAndPropertiesPairs)
}
    `;

export function useSetPositionPropertiesMutation() {
  return Urql.useMutation<SetPositionPropertiesMutation, SetPositionPropertiesMutationVariables>(SetPositionPropertiesDocument);
};
export const DeletePositionsDocument = gql`
    mutation DeletePositions($positionIds: [Guid]!) {
  deletePositions(positionIds: $positionIds)
}
    `;

export function useDeletePositionsMutation() {
  return Urql.useMutation<DeletePositionsMutation, DeletePositionsMutationVariables>(DeletePositionsDocument);
};
export const DeleteRostersDocument = gql`
    mutation DeleteRosters($locationAndDateRange: deleteRostersInDateRange!) {
  deleteRostersInDateRange(locationAndDateRange: $locationAndDateRange)
}
    `;

export function useDeleteRostersMutation() {
  return Urql.useMutation<DeleteRostersMutation, DeleteRostersMutationVariables>(DeleteRostersDocument);
};
export const GetShiftOperatingHoursDocument = gql`
    query GetShiftOperatingHours($locationId: Int!, $start: DateOnly, $end: DateOnly) {
  shiftOperatingHoursInDateRange(
    locationAndDateRange: {locationId: $locationId, dateRangeStart: $start, dateRangeEnd: $end}
  ) {
    date
    startTime
    endTime
    openTime
    closeTime
  }
}
    `;

export function useGetShiftOperatingHoursQuery(options: Omit<Urql.UseQueryArgs<GetShiftOperatingHoursQueryVariables>, 'query'>) {
  return Urql.useQuery<GetShiftOperatingHoursQuery, GetShiftOperatingHoursQueryVariables>({ query: GetShiftOperatingHoursDocument, ...options });
};
export const GetLocationListDocument = gql`
    query getLocationList {
  locations {
    ...Location
  }
}
    ${LocationFragmentDoc}`;

export function useGetLocationListQuery(options?: Omit<Urql.UseQueryArgs<GetLocationListQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLocationListQuery, GetLocationListQueryVariables>({ query: GetLocationListDocument, ...options });
};
export const GetLocationDocument = gql`
    query getLocation($id: Int!) {
  location(id: $id) {
    ...Location
  }
}
    ${LocationFragmentDoc}`;

export function useGetLocationQuery(options: Omit<Urql.UseQueryArgs<GetLocationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLocationQuery, GetLocationQueryVariables>({ query: GetLocationDocument, ...options });
};
export const UpdateLocationsDocument = gql`
    mutation UpdateLocations($locations: [updateLocation]!) {
  updateLocations(locations: $locations)
}
    `;

export function useUpdateLocationsMutation() {
  return Urql.useMutation<UpdateLocationsMutation, UpdateLocationsMutationVariables>(UpdateLocationsDocument);
};
export const UpdateEmployeeLocationsDocument = gql`
    mutation UpdateEmployeeLocations($employeeLocations: [updateEmployeeLocations]!) {
  updateEmployeeLocations(employeeLocations: $employeeLocations)
}
    `;

export function useUpdateEmployeeLocationsMutation() {
  return Urql.useMutation<UpdateEmployeeLocationsMutation, UpdateEmployeeLocationsMutationVariables>(UpdateEmployeeLocationsDocument);
};
export const DeleteAllRostersDocument = gql`
    mutation DeleteAllRosters {
  deleteAllRosters
}
    `;

export function useDeleteAllRostersMutation() {
  return Urql.useMutation<DeleteAllRostersMutation, DeleteAllRostersMutationVariables>(DeleteAllRostersDocument);
};
export const DeleteAllTemplatesDocument = gql`
    mutation DeleteAllTemplates {
  deleteAllTemplates
}
    `;

export function useDeleteAllTemplatesMutation() {
  return Urql.useMutation<DeleteAllTemplatesMutation, DeleteAllTemplatesMutationVariables>(DeleteAllTemplatesDocument);
};
export const DeleteAllWorkingPatternsDocument = gql`
    mutation DeleteAllWorkingPatterns {
  deleteAllWorkingPatterns
}
    `;

export function useDeleteAllWorkingPatternsMutation() {
  return Urql.useMutation<DeleteAllWorkingPatternsMutation, DeleteAllWorkingPatternsMutationVariables>(DeleteAllWorkingPatternsDocument);
};
export const DeleteAllAvailabilityExceptionsDocument = gql`
    mutation DeleteAllAvailabilityExceptions {
  deleteAllAvailabilityExceptions
}
    `;

export function useDeleteAllAvailabilityExceptionsMutation() {
  return Urql.useMutation<DeleteAllAvailabilityExceptionsMutation, DeleteAllAvailabilityExceptionsMutationVariables>(DeleteAllAvailabilityExceptionsDocument);
};
export const DeleteAllAvailabilitiesDocument = gql`
    mutation DeleteAllAvailabilities {
  deleteAllAvailabilities
}
    `;

export function useDeleteAllAvailabilitiesMutation() {
  return Urql.useMutation<DeleteAllAvailabilitiesMutation, DeleteAllAvailabilitiesMutationVariables>(DeleteAllAvailabilitiesDocument);
};
export const ResetAllPasswordsDocument = gql`
    mutation ResetAllPasswords {
  resetAllPasswords
}
    `;

export function useResetAllPasswordsMutation() {
  return Urql.useMutation<ResetAllPasswordsMutation, ResetAllPasswordsMutationVariables>(ResetAllPasswordsDocument);
};
export const UpdateMySettingsDocument = gql`
    mutation UpdateMySettings($settings: updateSettings!) {
  updateMySettings(settings: $settings) {
    displayLanguage
  }
}
    `;

export function useUpdateMySettingsMutation() {
  return Urql.useMutation<UpdateMySettingsMutation, UpdateMySettingsMutationVariables>(UpdateMySettingsDocument);
};
export const CreateMySettingsDocument = gql`
    mutation CreateMySettings($settings: createSettings!) {
  createMySettings(settings: $settings) {
    displayLanguage
  }
}
    `;

export function useCreateMySettingsMutation() {
  return Urql.useMutation<CreateMySettingsMutation, CreateMySettingsMutationVariables>(CreateMySettingsDocument);
};
export const MySettingDocument = gql`
    query MySetting {
  mySettings {
    displayLanguage
  }
}
    `;

export function useMySettingQuery(options?: Omit<Urql.UseQueryArgs<MySettingQueryVariables>, 'query'>) {
  return Urql.useQuery<MySettingQuery, MySettingQueryVariables>({ query: MySettingDocument, ...options });
};
export const GetMyShiftsForDateRangeDocument = gql`
    query GetMyShiftsForDateRange($range: getShiftsForDateRange!) {
  myShiftsForDateRange(range: $range) {
    shifts {
      start
      end
      date
      location {
        name
      }
      lastModified
      publicationTime
    }
  }
}
    `;

export function useGetMyShiftsForDateRangeQuery(options: Omit<Urql.UseQueryArgs<GetMyShiftsForDateRangeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMyShiftsForDateRangeQuery, GetMyShiftsForDateRangeQueryVariables>({ query: GetMyShiftsForDateRangeDocument, ...options });
};
export const GetVacantShiftsForLocationsDocument = gql`
    query GetVacantShiftsForLocations($locationId: Int!, $triggerType: Int!, $startDate: DateOnly, $endDate: DateOnly) {
  notifiableVacantShiftsInDateRange(
    notifiableVacantShifts: {homeLocationId: $locationId, triggerType: $triggerType, start: $startDate, end: $endDate}
  ) {
    count
    shifts {
      id
      date
      start
      end
    }
  }
}
    `;

export function useGetVacantShiftsForLocationsQuery(options: Omit<Urql.UseQueryArgs<GetVacantShiftsForLocationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetVacantShiftsForLocationsQuery, GetVacantShiftsForLocationsQueryVariables>({ query: GetVacantShiftsForLocationsDocument, ...options });
};
export const GetVacantShiftsCountDocument = gql`
    query GetVacantShiftsCount($locationId: Int!, $triggerType: Int!, $startDate: DateOnly) {
  notifiableVacantShiftsInDateRange(
    notifiableVacantShifts: {homeLocationId: $locationId, triggerType: $triggerType, start: $startDate}
  ) {
    count
  }
}
    `;

export function useGetVacantShiftsCountQuery(options: Omit<Urql.UseQueryArgs<GetVacantShiftsCountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetVacantShiftsCountQuery, GetVacantShiftsCountQueryVariables>({ query: GetVacantShiftsCountDocument, ...options });
};
export const GetShiftsCountsDocument = gql`
    query GetShiftsCounts($locationId: Int!, $startDate: DateOnly, $endDate: DateOnly) {
  vacantShiftsInDateRange(
    locationAndDateRange: {homeLocationId: $locationId, start: $startDate, end: $endDate}
  ) {
    count
    total
  }
}
    `;

export function useGetShiftsCountsQuery(options: Omit<Urql.UseQueryArgs<GetShiftsCountsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetShiftsCountsQuery, GetShiftsCountsQueryVariables>({ query: GetShiftsCountsDocument, ...options });
};
export const GetSkillsDocument = gql`
    query GetSkills {
  skills {
    ...Skill
  }
}
    ${SkillFragmentDoc}`;

export function useGetSkillsQuery(options?: Omit<Urql.UseQueryArgs<GetSkillsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSkillsQuery, GetSkillsQueryVariables>({ query: GetSkillsDocument, ...options });
};
export const CreateSkillsDocument = gql`
    mutation CreateSkills($skills: [createSkill]!) {
  createSkills(skills: $skills) {
    ...Skill
  }
}
    ${SkillFragmentDoc}`;

export function useCreateSkillsMutation() {
  return Urql.useMutation<CreateSkillsMutation, CreateSkillsMutationVariables>(CreateSkillsDocument);
};
export const UpdateSkillsDocument = gql`
    mutation UpdateSkills($skills: [updateSkill]!) {
  updateSkills(skills: $skills) {
    ...Skill
  }
}
    ${SkillFragmentDoc}`;

export function useUpdateSkillsMutation() {
  return Urql.useMutation<UpdateSkillsMutation, UpdateSkillsMutationVariables>(UpdateSkillsDocument);
};
export const DeleteSkillsDocument = gql`
    mutation DeleteSkills($skillIds: [Guid]!) {
  deleteSkills(skillIds: $skillIds)
}
    `;

export function useDeleteSkillsMutation() {
  return Urql.useMutation<DeleteSkillsMutation, DeleteSkillsMutationVariables>(DeleteSkillsDocument);
};
export const GetEmployeeSkillsDocument = gql`
    query GetEmployeeSkills($employeeIds: [Guid]!) {
  employeeSkillsByEmployeeIds(employeeIds: $employeeIds) {
    employeeId
    skills {
      name
      skillId
    }
  }
}
    `;

export function useGetEmployeeSkillsQuery(options: Omit<Urql.UseQueryArgs<GetEmployeeSkillsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEmployeeSkillsQuery, GetEmployeeSkillsQueryVariables>({ query: GetEmployeeSkillsDocument, ...options });
};
export const UpdateEmployeeSkillsDocument = gql`
    mutation UpdateEmployeeSkills($skills: [updateEmployeeSkillsByEmployeeIdAndSkills]!) {
  updateEmployeeSkills(skills: $skills)
}
    `;

export function useUpdateEmployeeSkillsMutation() {
  return Urql.useMutation<UpdateEmployeeSkillsMutation, UpdateEmployeeSkillsMutationVariables>(UpdateEmployeeSkillsDocument);
};
export const AllUserAccountsDocument = gql`
    query allUserAccounts {
  employees {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`;

export function useAllUserAccountsQuery(options?: Omit<Urql.UseQueryArgs<AllUserAccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<AllUserAccountsQuery, AllUserAccountsQueryVariables>({ query: AllUserAccountsDocument, ...options });
};
export const GetEmployeesByLocationsDocument = gql`
    query getEmployeesByLocations($locationIds: [Int!]!) {
  employeesByLocations(locationIds: $locationIds) {
    employees {
      ...Employee
    }
  }
}
    ${EmployeeFragmentDoc}`;

export function useGetEmployeesByLocationsQuery(options: Omit<Urql.UseQueryArgs<GetEmployeesByLocationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEmployeesByLocationsQuery, GetEmployeesByLocationsQueryVariables>({ query: GetEmployeesByLocationsDocument, ...options });
};
export const GetEmployeesDocument = gql`
    query getEmployees {
  employees {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`;

export function useGetEmployeesQuery(options?: Omit<Urql.UseQueryArgs<GetEmployeesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>({ query: GetEmployeesDocument, ...options });
};
export const GetEmployeesByIdsDocument = gql`
    query getEmployeesByIds($ids: [Guid]!) {
  employeesByIds(ids: $ids) {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`;

export function useGetEmployeesByIdsQuery(options: Omit<Urql.UseQueryArgs<GetEmployeesByIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEmployeesByIdsQuery, GetEmployeesByIdsQueryVariables>({ query: GetEmployeesByIdsDocument, ...options });
};
export const UpdateWorkRulesDocument = gql`
    mutation UpdateWorkRules($workRules: [updateEmployeeWorkRules]!) {
  updateWorkRules(constraints: {employeeWorkRules: $workRules}) {
    id
    identityId
    maxHoursPerMonth
    minHoursPerMonth
    maxHoursPerWeek
    minHoursPerWeek
  }
}
    `;

export function useUpdateWorkRulesMutation() {
  return Urql.useMutation<UpdateWorkRulesMutation, UpdateWorkRulesMutationVariables>(UpdateWorkRulesDocument);
};
export const GetEmployeeWorkRulesDocument = gql`
    query GetEmployeeWorkRules($employeeIds: [Guid]!) {
  workRulesByEmployeeIds(employeeIds: $employeeIds) {
    id
    identityId
    maxHoursPerMonth
    minHoursPerMonth
    maxHoursPerWeek
    minHoursPerWeek
  }
}
    `;

export function useGetEmployeeWorkRulesQuery(options: Omit<Urql.UseQueryArgs<GetEmployeeWorkRulesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEmployeeWorkRulesQuery, GetEmployeeWorkRulesQueryVariables>({ query: GetEmployeeWorkRulesDocument, ...options });
};
export const ResetPasswordDocument = gql`
    mutation ResetPassword($employeeId: Guid!) {
  resetPassword(employeeId: $employeeId)
}
    `;

export function useResetPasswordMutation() {
  return Urql.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument);
};
export const UpdateEmployeesDocument = gql`
    mutation UpdateEmployees($employees: [updateEmployee]!) {
  updateEmployees(employees: $employees)
}
    `;

export function useUpdateEmployeesMutation() {
  return Urql.useMutation<UpdateEmployeesMutation, UpdateEmployeesMutationVariables>(UpdateEmployeesDocument);
};
export const CreateEmployeeDocument = gql`
    mutation CreateEmployee($createEmployee: createEmployee!) {
  createUserAndEmployee(employee: $createEmployee) {
    identityId
  }
}
    `;

export function useCreateEmployeeMutation() {
  return Urql.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument);
};
export const GetEmployeeHistoryDocument = gql`
    query GetEmployeeHistory($idAndDateRange: getEmployeeHistory!) {
  employeeHistory(idAndDateRange: $idAndDateRange) {
    rosterHistory {
      date
      history {
        start
        end
        locationId
      }
    }
    availabilityHistory {
      date
      history {
        start
        end
      }
      leaveTypeId
    }
  }
}
    `;

export function useGetEmployeeHistoryQuery(options: Omit<Urql.UseQueryArgs<GetEmployeeHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEmployeeHistoryQuery, GetEmployeeHistoryQueryVariables>({ query: GetEmployeeHistoryDocument, ...options });
};
export const GetEmployeeNamesByIdsDocument = gql`
    query getEmployeeNamesByIds($ids: [Guid]!) {
  employeeNamesByIds(ids: $ids) {
    identityId
    firstName
    lastName
  }
}
    `;

export function useGetEmployeeNamesByIdsQuery(options: Omit<Urql.UseQueryArgs<GetEmployeeNamesByIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetEmployeeNamesByIdsQuery, GetEmployeeNamesByIdsQueryVariables>({ query: GetEmployeeNamesByIdsDocument, ...options });
};
export const GetStaffByIdDocument = gql`
    query getStaffById($id: Guid) {
  employee(id: $id) {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`;

export function useGetStaffByIdQuery(options?: Omit<Urql.UseQueryArgs<GetStaffByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetStaffByIdQuery, GetStaffByIdQueryVariables>({ query: GetStaffByIdDocument, ...options });
};
export const UpdateStaffDocument = gql`
    mutation UpdateStaff($employee: updateEmployee!) {
  updateEmployee(employee: $employee) {
    identityId
    email
    firstName
    lastName
    role
  }
}
    `;

export function useUpdateStaffMutation() {
  return Urql.useMutation<UpdateStaffMutation, UpdateStaffMutationVariables>(UpdateStaffDocument);
};
export const UpdateSelfDocument = gql`
    mutation UpdateSelf($employee: updateEmployee!) {
  updateMyInfo(employee: $employee) {
    email
    firstName
    lastName
    role
  }
}
    `;

export function useUpdateSelfMutation() {
  return Urql.useMutation<UpdateSelfMutation, UpdateSelfMutationVariables>(UpdateSelfDocument);
};
export const UpdateDeactivatedStatusDocument = gql`
    mutation updateDeactivatedStatus($id: Guid!, $deactivated: Boolean!) {
  updateDeactivatedStatus(id: $id, deactivated: $deactivated) {
    userId
    deactivated
  }
}
    `;

export function useUpdateDeactivatedStatusMutation() {
  return Urql.useMutation<UpdateDeactivatedStatusMutation, UpdateDeactivatedStatusMutationVariables>(UpdateDeactivatedStatusDocument);
};
export const GdprDeleteUserDocument = gql`
    mutation gdprDeleteUser($id: Guid!) {
  gdprDeleteUser(id: $id)
}
    `;

export function useGdprDeleteUserMutation() {
  return Urql.useMutation<GdprDeleteUserMutation, GdprDeleteUserMutationVariables>(GdprDeleteUserDocument);
};
export const CreateUserAndEmployeeDocument = gql`
    mutation createUserAndEmployee($employee: createEmployee!) {
  createUserAndEmployee(employee: $employee) {
    identityId
  }
}
    `;

export function useCreateUserAndEmployeeMutation() {
  return Urql.useMutation<CreateUserAndEmployeeMutation, CreateUserAndEmployeeMutationVariables>(CreateUserAndEmployeeDocument);
};
export const CreateMultipleUsersAndEmployeesDocument = gql`
    mutation createMultipleUsersAndEmployees($employees: [createEmployee!]!) {
  createMultipleUsersAndEmployees(employees: $employees) {
    identityId
  }
}
    `;

export function useCreateMultipleUsersAndEmployeesMutation() {
  return Urql.useMutation<CreateMultipleUsersAndEmployeesMutation, CreateMultipleUsersAndEmployeesMutationVariables>(CreateMultipleUsersAndEmployeesDocument);
};
export const GetRolesDocument = gql`
    query getRoles {
  roles {
    id
    name
  }
}
    `;

export function useGetRolesQuery(options?: Omit<Urql.UseQueryArgs<GetRolesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetRolesQuery, GetRolesQueryVariables>({ query: GetRolesDocument, ...options });
};
export const EmployeeIdWorkingPatternsDocument = gql`
    query employeeIdWorkingPatterns($dateAndPeriods: dateAndPeriods!, $id: Guid!) {
  employeeIdWorkingPatterns(dateAndPeriods: $dateAndPeriods, id: $id) {
    periods {
      patterns {
        id
        startTime
        endTime
        slotNumber
        day
        dayNumber
      }
    }
  }
}
    `;

export function useEmployeeIdWorkingPatternsQuery(options: Omit<Urql.UseQueryArgs<EmployeeIdWorkingPatternsQueryVariables>, 'query'>) {
  return Urql.useQuery<EmployeeIdWorkingPatternsQuery, EmployeeIdWorkingPatternsQueryVariables>({ query: EmployeeIdWorkingPatternsDocument, ...options });
};
export const SendWelcomeInfoDocument = gql`
    mutation sendWelcomeInfo($welcomeInfo: sendWelcomeInfo!) {
  sendWelcomeInfo(welcomeInfo: $welcomeInfo)
}
    `;

export function useSendWelcomeInfoMutation() {
  return Urql.useMutation<SendWelcomeInfoMutation, SendWelcomeInfoMutationVariables>(SendWelcomeInfoDocument);
};
export const UpdateWorkingPatternDocument = gql`
    mutation UpdateWorkingPattern($args: updateWorkingPattern!) {
  updateWorkingPattern(workingPattern: $args) {
    workingPattern {
      startTime
      endTime
    }
  }
}
    `;

export function useUpdateWorkingPatternMutation() {
  return Urql.useMutation<UpdateWorkingPatternMutation, UpdateWorkingPatternMutationVariables>(UpdateWorkingPatternDocument);
};
export const GetBreakOffsetsDocument = gql`
    query GetBreakOffsets {
  getBreakOffsets {
    timeOffsetAfterLastBreak
    timeOffsetBeforeFirstBreak
  }
}
    `;

export function useGetBreakOffsetsQuery(options?: Omit<Urql.UseQueryArgs<GetBreakOffsetsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBreakOffsetsQuery, GetBreakOffsetsQueryVariables>({ query: GetBreakOffsetsDocument, ...options });
};
export const SetBreakOffsetsDocument = gql`
    mutation SetBreakOffsets($timeOffsetAfterLastBreak: Seconds!, $timeOffsetBeforeFirstBreak: Seconds!) {
  setBreakOffsets(
    breakOffsets: {timeOffsetAfterLastBreak: $timeOffsetAfterLastBreak, timeOffsetBeforeFirstBreak: $timeOffsetBeforeFirstBreak}
  )
}
    `;

export function useSetBreakOffsetsMutation() {
  return Urql.useMutation<SetBreakOffsetsMutation, SetBreakOffsetsMutationVariables>(SetBreakOffsetsDocument);
};
export const GetOrganisationPropertiesDocument = gql`
    query getOrganisationProperties {
  getOrganisationProperties
}
    `;

export function useGetOrganisationPropertiesQuery(options?: Omit<Urql.UseQueryArgs<GetOrganisationPropertiesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganisationPropertiesQuery, GetOrganisationPropertiesQueryVariables>({ query: GetOrganisationPropertiesDocument, ...options });
};
export const GetOrganisationSettingsDocument = gql`
    query GetOrganisationSettings {
  organisationSettings {
    minMinutesBeforeBreak
    minMinutesAfterBreak
    shortestBreak
    defaultHolidayRegionCode
    leaveTypeTier
  }
}
    `;

export function useGetOrganisationSettingsQuery(options?: Omit<Urql.UseQueryArgs<GetOrganisationSettingsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganisationSettingsQuery, GetOrganisationSettingsQueryVariables>({ query: GetOrganisationSettingsDocument, ...options });
};
export const SetOrganisationPropertiesDocument = gql`
    mutation setOrganisationProperties($properties: String!) {
  setOrganisationProperties(properties: $properties)
}
    `;

export function useSetOrganisationPropertiesMutation() {
  return Urql.useMutation<SetOrganisationPropertiesMutation, SetOrganisationPropertiesMutationVariables>(SetOrganisationPropertiesDocument);
};
export const GetTargetsByLocationIdsDocument = gql`
    query getTargetsByLocationIds($locationIds: [Int]!, $startDate: DateOnly!, $endDate: DateOnly!) {
  targetsByLocationIds(
    targetsLocationIds: {locationIds: $locationIds, start: $startDate, end: $endDate}
  ) {
    id
    locationId
    date
    type
    value
  }
}
    `;

export function useGetTargetsByLocationIdsQuery(options: Omit<Urql.UseQueryArgs<GetTargetsByLocationIdsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTargetsByLocationIdsQuery, GetTargetsByLocationIdsQueryVariables>({ query: GetTargetsByLocationIdsDocument, ...options });
};
export const UpdateTargetsDocument = gql`
    mutation updateTargets($targets: [updateTargetByValue]!) {
  updateTargets(targets: $targets) {
    id
    locationId
    date
    type
    value
  }
}
    `;

export function useUpdateTargetsMutation() {
  return Urql.useMutation<UpdateTargetsMutation, UpdateTargetsMutationVariables>(UpdateTargetsDocument);
};
export const GetTasksDocument = gql`
    query GetTasks {
  tasks {
    ...Task
  }
}
    ${TaskFragmentDoc}`;

export function useGetTasksQuery(options?: Omit<Urql.UseQueryArgs<GetTasksQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTasksQuery, GetTasksQueryVariables>({ query: GetTasksDocument, ...options });
};
export const CreateTasksDocument = gql`
    mutation CreateTasks($tasks: [createTask]!) {
  createTasks(tasks: $tasks) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;

export function useCreateTasksMutation() {
  return Urql.useMutation<CreateTasksMutation, CreateTasksMutationVariables>(CreateTasksDocument);
};
export const UpdateTasksDocument = gql`
    mutation UpdateTasks($tasks: [updateTask]!) {
  updateTasks(tasks: $tasks) {
    ...Task
  }
}
    ${TaskFragmentDoc}`;

export function useUpdateTasksMutation() {
  return Urql.useMutation<UpdateTasksMutation, UpdateTasksMutationVariables>(UpdateTasksDocument);
};
export const DeleteTasksDocument = gql`
    mutation DeleteTasks($taskIds: [Int]!) {
  deleteTasks(taskIds: $taskIds)
}
    `;

export function useDeleteTasksMutation() {
  return Urql.useMutation<DeleteTasksMutation, DeleteTasksMutationVariables>(DeleteTasksDocument);
};
export const GetLibraryTemplatesDocument = gql`
    query getLibraryTemplates {
  templatesForLocation {
    ...Template
  }
}
    ${TemplateFragmentDoc}`;

export function useGetLibraryTemplatesQuery(options?: Omit<Urql.UseQueryArgs<GetLibraryTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLibraryTemplatesQuery, GetLibraryTemplatesQueryVariables>({ query: GetLibraryTemplatesDocument, ...options });
};
export const GetTemplatesForLocationDocument = gql`
    query getTemplatesForLocation($locationId: Int!) {
  templatesForLocation(locationId: $locationId) {
    ...Template
  }
}
    ${TemplateFragmentDoc}`;

export function useGetTemplatesForLocationQuery(options: Omit<Urql.UseQueryArgs<GetTemplatesForLocationQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTemplatesForLocationQuery, GetTemplatesForLocationQueryVariables>({ query: GetTemplatesForLocationDocument, ...options });
};
export const GetTemplateDocument = gql`
    query getTemplate($id: Guid!) {
  template(id: $id) {
    ...Template
  }
}
    ${TemplateFragmentDoc}`;

export function useGetTemplateQuery(options: Omit<Urql.UseQueryArgs<GetTemplateQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTemplateQuery, GetTemplateQueryVariables>({ query: GetTemplateDocument, ...options });
};
export const GetTemplatesDocument = gql`
    query getTemplates {
  templates {
    ...Template
  }
}
    ${TemplateFragmentDoc}`;

export function useGetTemplatesQuery(options?: Omit<Urql.UseQueryArgs<GetTemplatesQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>({ query: GetTemplatesDocument, ...options });
};
export const UpdateTemplateDocument = gql`
    mutation UpdateTemplate($updateTemplate: updateTemplate!) {
  updateTemplate(template: $updateTemplate) {
    ...MinimalTemplateMutationResult
  }
}
    ${MinimalTemplateMutationResultFragmentDoc}`;

export function useUpdateTemplateMutation() {
  return Urql.useMutation<UpdateTemplateMutation, UpdateTemplateMutationVariables>(UpdateTemplateDocument);
};
export const CreateTemplateDocument = gql`
    mutation CreateTemplate($name: String!, $locationId: Int, $version: String, $draft: Boolean, $tags: [createTemplateTag]) {
  createTemplate(
    template: {name: $name, locationId: $locationId, includeAllStations: true, version: $version, draft: $draft, templateTags: $tags}
  ) {
    ...MinimalTemplateMutationResult
  }
}
    ${MinimalTemplateMutationResultFragmentDoc}`;

export function useCreateTemplateMutation() {
  return Urql.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument);
};
export const DeleteTemplateDocument = gql`
    mutation deleteTemplate($id: Guid!) {
  deleteTemplate(id: $id, force: true)
}
    `;

export function useDeleteTemplateMutation() {
  return Urql.useMutation<DeleteTemplateMutation, DeleteTemplateMutationVariables>(DeleteTemplateDocument);
};
export const CopyTemplateDocument = gql`
    mutation copyTemplate($name: String!, $locationId: Int, $sourceTemplateId: Guid!) {
  copyTemplate(
    template: {newName: $name, newLocationId: $locationId, sourceTemplateId: $sourceTemplateId}
  ) {
    ...MinimalTemplateMutationResult
  }
}
    ${MinimalTemplateMutationResultFragmentDoc}`;

export function useCopyTemplateMutation() {
  return Urql.useMutation<CopyTemplateMutation, CopyTemplateMutationVariables>(CopyTemplateDocument);
};
export const GetTemplateTagsDocument = gql`
    query getTemplateTags {
  templateTags {
    ...TemplateTag
  }
}
    ${TemplateTagFragmentDoc}`;

export function useGetTemplateTagsQuery(options?: Omit<Urql.UseQueryArgs<GetTemplateTagsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTemplateTagsQuery, GetTemplateTagsQueryVariables>({ query: GetTemplateTagsDocument, ...options });
};
export const GetTenantDocument = gql`
    query GetTenant {
  tenant {
    id
    name
  }
}
    `;

export function useGetTenantQuery(options?: Omit<Urql.UseQueryArgs<GetTenantQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTenantQuery, GetTenantQueryVariables>({ query: GetTenantDocument, ...options });
};